import React from 'react';
import PropTypes from 'prop-types';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var _excluded$2N = ["title", "titleId"];
var SvgAlert = function SvgAlert(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2N);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 3a2 2 0 00-1.846 1.229L2.301 22.947v.002A2 2 0 002 24a2 2 0 002 2 2 2 0 00.14-.006l.005.006h21.71l.004-.008A2 2 0 0026 26a2 2 0 002-2 2 2 0 00-.3-1.053l-.016-.027a2 2 0 00-.002-.002L16.846 4.228A2 2 0 0015 3zm-1.213 8.36h2.426l-.201 6.472h-2.024l-.2-6.473zm1.217 8.45c.822 0 1.314.443 1.314 1.198 0 .74-.492 1.181-1.314 1.181-.828 0-1.324-.44-1.324-1.181 0-.755.495-1.197 1.324-1.197z"
  }));
};
SvgAlert.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2M = ["title", "titleId"];
var SvgAnnounce = function SvgAnnounce(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2M);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M26.984 2.986A1 1 0 0026 4v.404L6 12.5v5l4.674 1.89-.354.837a3.014 3.014 0 001.592 3.931 1 1 0 00.002 0l2.379 1.008a3.017 3.017 0 003.934-1.594l.406-.959L26 25.596V26a1 1 0 102 0V4a1 1 0 00-1.016-1.014zm-24 9A1 1 0 002 13v4a1 1 0 102 0v-4a1 1 0 00-1.016-1.014zm9.543 8.157l4.25 1.72-.392.93a.985.985 0 01-1.31.531l-2.382-1.008a.985.985 0 01-.53-1.31l.364-.863z"
  }));
};
SvgAnnounce.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2L = ["title", "titleId"];
var SvgArrowDown = function SvgArrowDown(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2L);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 3a1 1 0 00-1 1v13.07l-3.863-3.863a.999.999 0 00-1.414 0l-.086.086a.999.999 0 000 1.414l5.656 5.656a.999.999 0 001.414 0l5.656-5.656a.999.999 0 000-1.414l-.086-.086a.999.999 0 00-1.414 0L13 17.07V4a1 1 0 00-1-1z"
  }));
};
SvgArrowDown.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2K = ["title", "titleId"];
var SvgArrowLeft = function SvgArrowLeft(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2K);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 5.342c-.256 0-.512.1-.707.295l-5.656 5.656a.999.999 0 000 1.414l5.656 5.656a.999.999 0 001.414 0l.086-.086a.999.999 0 000-1.414L6.93 13H20a1 1 0 000-2H6.93l3.863-3.863a.999.999 0 000-1.414l-.086-.086A.998.998 0 0010 5.342z"
  }));
};
SvgArrowLeft.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2J = ["title", "titleId"];
var SvgArrowRight = function SvgArrowRight(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2J);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14 5.342c-.256 0-.512.1-.707.295l-.086.086a.999.999 0 000 1.414L17.07 11H4a1 1 0 000 2h13.07l-3.863 3.863a.999.999 0 000 1.414l.086.086a.999.999 0 001.414 0l5.656-5.656a.999.999 0 000-1.414l-5.656-5.656A.998.998 0 0014 5.342z"
  }));
};
SvgArrowRight.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2I = ["title", "titleId"];
var SvgArrowUp = function SvgArrowUp(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2I);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.342c-.256 0-.512.1-.707.295L5.637 9.293a.999.999 0 000 1.414l.086.086a.999.999 0 001.414 0L11 6.93V20a1 1 0 002 0V6.93l3.863 3.863a.999.999 0 001.414 0l.086-.086a.999.999 0 000-1.414l-5.656-5.656A.997.997 0 0012 3.342z"
  }));
};
SvgArrowUp.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2H = ["title", "titleId"];
var SvgBackup = function SvgBackup(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2H);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 4a2 2 0 00-2 2v3a1 1 0 001 1h20a1 1 0 001-1V6a2 2 0 00-2-2H6zm-1 8a1 1 0 00-1 1v4a1 1 0 001 1h10.518A8.991 8.991 0 0123 14c1.054 0 2.06.19 3 .523V13a1 1 0 00-1-1H5zm18 4.008c-1.794 0-3.587.68-4.95 2.043-2.724 2.725-2.724 7.173 0 9.898 2.69 2.69 7.052 2.72 9.786.102L29 29.305l.975-5.264L25 25l1.477 1.588a4.982 4.982 0 01-7.012-.053 4.984 4.984 0 010-7.07 4.984 4.984 0 017.07 0 1 1 0 101.414-1.414A6.976 6.976 0 0023 16.008zM5 20a1 1 0 00-1 1v3a2 2 0 002 2h8.523A8.956 8.956 0 0114 23c0-1.054.19-2.06.523-3H5z"
  }));
};
SvgBackup.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2G = ["title", "titleId"];
var SvgBarman = function SvgBarman(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2G);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24.988 0c9.96 0 18.033 8.074 18.033 18.033 0 9.959-8.074 18.033-18.033 18.033-9.96 0-18.033-8.074-18.033-18.033 0-.596.03-1.184.085-1.765a2.37 2.37 0 01-.4-.093l-4.912-1.596a2.5 2.5 0 011.545-4.755l4.912 1.596.019.007C10.839 4.736 17.36 0 24.988 0zm0 3C16.686 3 9.955 9.73 9.955 18.033c0 8.302 6.73 15.033 15.033 15.033 8.302 0 15.033-6.73 15.033-15.033C40.02 9.73 33.29 3 24.988 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.117 9.216c.666.215 1.204.549 1.613 1.002.426.474.674 1.257.784 1.781a11.351 11.351 0 015.659 9.826c0 1.85-.442 3.597-1.227 5.14-1.875 3.692-6.375 4.988-10.8 4.988 5.924-.715 9.777-4.675 8.595-9.968-.105-.47-.452-.906-1.041-1.307l-.184-.119-1.79 3.689-6.362-2.996c.521-.947.54-1.517.053-1.71-.455-.181-.842.152-1.16 1l-.063.177-7.679-3.7c2.378-4.37 5.81-6.554 10.297-6.554.81 0 1.6.084 2.362.246l-.019.03-.533 4.124.794 2.929-.26-2.929.68-3.994.01.002.27-1.657zm3.61 6.193a.654.654 0 100 1.308.654.654 0 000-1.308z"
  }));
};
SvgBarman.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2F = ["title", "titleId"];
var SvgBdr = function SvgBdr(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2F);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25.983 13.342c.005-.114.017-.226.017-.342a8 8 0 00-8-8c-3.11 0-5.8 1.779-7.123 4.371A4.989 4.989 0 009 9c-2.53 0-4.599 1.885-4.932 4.324A5.997 5.997 0 006 25h18a5.998 5.998 0 001.983-11.658zM21 21v-2H10v2l-4-3 4-3v2h11v-2l4 3-4 3z"
  }));
};
SvgBdr.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2E = ["title", "titleId"];
var SvgBigData = function SvgBigData(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2E);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 4a2 2 0 00-2 2v2a2 2 0 002 2h18a2 2 0 002-2V6a2 2 0 00-2-2H6zm1 2a1 1 0 110 2 1 1 0 010-2zm-1 6a2 2 0 00-2 2v2a2 2 0 002 2h18a2 2 0 002-2v-2a2 2 0 00-2-2H6zm1 2a1 1 0 110 2 1 1 0 010-2zm-1 6a2 2 0 00-2 2v2a2 2 0 002 2h18a2 2 0 002-2v-2a2 2 0 00-2-2H6zm1 2a1 1 0 110 2 1 1 0 010-2z"
  }));
};
SvgBigData.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2D = ["title", "titleId"];
var SvgBrainCircuit = function SvgBrainCircuit(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2D);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11 3a2 2 0 00-2 2c0 .017.006.034.006.05C8.838 5.033 8.673 5 8.5 5A4.5 4.5 0 004 9.5c0 .471.092.916.227 1.342A5.015 5.015 0 002.426 13H8v-2.277A1.993 1.993 0 019 7a1.993 1.993 0 011 3.723V14a1 1 0 01-1 1H2c0 1.735.885 3.261 2.227 4.158C4.092 19.584 4 20.03 4 20.5c0 2.33 1.778 4.222 4.047 4.453A2.497 2.497 0 0013 24.5V21h-2.277A1.993 1.993 0 017 20a1.993 1.993 0 013.723-1H13V5a2 2 0 00-2-2zm6 0a2 2 0 00-2 2v4h2.277A1.993 1.993 0 0121 10a1.993 1.993 0 01-3.723 1H15v13.5a2.497 2.497 0 004.953.453c1.762-.179 3.27-1.324 3.817-2.953H19a1 1 0 01-1-1v-2.277A1.99 1.99 0 0117 17a2 2 0 114 0c0 .738-.405 1.376-1 1.723V20h3.963c-.096-.936-.363-1.338-.363-1.338A4.002 4.002 0 0026 15a4.993 4.993 0 00-2.227-4.158c.135-.426.227-.871.227-1.342A4.5 4.5 0 0019.5 5c-.173 0-.338.032-.506.05 0-.016.006-.033.006-.05a2 2 0 00-2-2z"
  }));
};
SvgBrainCircuit.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2C = ["title", "titleId"];
var SvgBriefcase = function SvgBriefcase(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2C);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14 3a2 2 0 00-2 2H4a2 2 0 00-2 2v9a2 2 0 002 2h22a2 2 0 002-2V7a2 2 0 00-2-2h-8a2 2 0 00-2-2h-2zm1 11a1 1 0 110 2 1 1 0 010-2zM2 19.443V23a2 2 0 002 2h22a2 2 0 002-2v-3.557A3.96 3.96 0 0126 20H4a3.96 3.96 0 01-2-.557z"
  }));
};
SvgBriefcase.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2B = ["title", "titleId"];
var SvgBusinessman = function SvgBusinessman(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2B);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 3.002c-4.242 0-6 2.721-6 6 0 1.104.527 2.213.527 2.213-.212.122-.56.51-.472 1.197.164 1.283.72 1.61 1.074 1.637C10.264 15.246 11.55 16.777 12 17v2c-.002.007-.008.011-.01.018a.994.994 0 00-.775.539l-.313.629C8.434 21.569 3 21.226 3 27h10.305l1.195-3.916L13.361 21h3.278L15.5 23.084 16.695 27H27c0-5.774-5.434-5.43-7.902-6.814l-.313-.63a.994.994 0 00-.775-.538c-.002-.007-.008-.011-.01-.018v-2c.45-.223 1.736-1.754 1.871-2.951.354-.027.91-.354 1.074-1.637.088-.689-.26-1.075-.472-1.197 0 0 .527-1.002.527-2.213 0-2.428-.953-4.5-3-4.5 0 0-.711-1.5-3-1.5z"
  }));
};
SvgBusinessman.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2A = ["title", "titleId"];
var SvgBusinesswoman = function SvgBusinesswoman(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2A);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 24.084L13.361 22h3.277L15.5 24.084 16.39 27H25c0-5-6.957-4.174-8-6.999V19c3.797 0 5.765-1.846 5.765-1.846C20.639 15.41 23.348 3 15.129 3c-1.173 0-2.08 1.043-2.08 1.043-6.723 0-3.989 11.43-5.963 13.072 0 0 2.136 1.885 5.914 1.885v1.001C11.957 22.826 5 22 5 27h8.61l.89-2.916z"
  }));
};
SvgBusinesswoman.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2z = ["title", "titleId"];
var SvgCaseStudy = function SvgCaseStudy(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2z);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4 4a1 1 0 00-1 1v20a1 1 0 001 1h5a1 1 0 001-1V5a1 1 0 00-1-1H4zm17 2a1 1 0 00-1 1v18a1 1 0 001 1h5a1 1 0 001-1V7a1 1 0 00-1-1h-5zM4.5 7h4a.5.5 0 010 1h-4a.5.5 0 010-1zM13 9a1 1 0 00-1 1v15a1 1 0 001 1h4a1 1 0 001-1V10a1 1 0 00-1-1h-4zm8.5 0h4a.5.5 0 010 1h-4a.5.5 0 010-1zm-8 3h3a.5.5 0 010 1h-3a.5.5 0 010-1zm-9 8h4a.5.5 0 010 1h-4a.5.5 0 010-1zm9 0h3a.5.5 0 010 1h-3a.5.5 0 010-1zm8 0h4a.5.5 0 010 1h-4a.5.5 0 010-1zm-17 2h4a.5.5 0 010 1h-4a.5.5 0 010-1zm9 0h3a.5.5 0 010 1h-3a.5.5 0 010-1zm8 0h4a.5.5 0 010 1h-4a.5.5 0 010-1z"
  }));
};
SvgCaseStudy.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2y = ["title", "titleId"];
var SvgCellular = function SvgCellular(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2y);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.139 4.21a1 1 0 00-.707.257 9.982 9.982 0 000 15.066 1 1 0 101.316-1.506A7.965 7.965 0 015 12a7.965 7.965 0 012.748-6.027 1 1 0 00-.61-1.762zm15.793 0a1 1 0 00-.68 1.763A7.965 7.965 0 0125 12a7.965 7.965 0 01-2.748 6.027 1 1 0 101.316 1.506 9.982 9.982 0 000-15.066 1 1 0 00-.636-.256zM10.725 7.292a1 1 0 00-.705.262A5.941 5.941 0 008 12c0 1.776.796 3.362 2.02 4.447a1 1 0 001.328-1.496C10.519 14.216 10 13.184 10 12c0-1.184.52-2.216 1.348-2.951a1 1 0 00-.623-1.758zm8.521 0a1 1 0 00-.594 1.758C19.481 9.784 20 10.816 20 12c0 1.184-.52 2.216-1.348 2.951a1 1 0 001.328 1.496A5.941 5.941 0 0022 12a5.941 5.941 0 00-2.02-4.447 1 1 0 00-.634-.262 1 1 0 00-.1 0zM15 10a2 2 0 00-2 2 2 2 0 001 1.73V25a1 1 0 102 0V13.729A2 2 0 0017 12a2 2 0 00-2-2z"
  }));
};
SvgCellular.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2x = ["title", "titleId"];
var SvgCertificate = function SvgCertificate(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2x);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4 5a1 1 0 00-1 1v17a1 1 0 001.158 1H9.35A5.971 5.971 0 019 22H5V7h20v15h-4c0 .702-.128 1.374-.35 2h5.182A1 1 0 0027 23V6a1 1 0 00-1-1H4zm6 5a1 1 0 100 2h10a1 1 0 100-2H10zm0 4a1 1 0 100 2h10a1 1 0 100-2H10zm5 4c-2.197 0-4 1.803-4 4 0 1 .386 1.907 1 2.611V30l3-2 3 2v-5.389c.614-.704 1-1.61 1-2.611 0-2.197-1.803-4-4-4zm0 2c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2z"
  }));
};
SvgCertificate.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2w = ["title", "titleId"];
var SvgChange = function SvgChange(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2w);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 2L18 7h3v8a1 1 0 01-1 1h-9v5h9a6 6 0 006-6V7h3l-5.5-5zM9 9a5 5 0 00-5 5v9H1l5.5 5 5.5-5H9v-8a1 1 0 011-1h9V9H9z"
  }));
};
SvgChange.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2v = ["title", "titleId"];
var SvgChat = function SvgChat(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2v);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 4a4 4 0 00-4 4v12a4 4 0 004 4h2.527c-.19 1.174-.747 2.36-2.2 3.031A.5.5 0 006 27.5a.5.5 0 00.5.5.5.5 0 00.146-.021c2.489-.055 5.17-1.503 6.624-3.979H24a4 4 0 004-4V8a4 4 0 00-4-4H6zm3 8a2 2 0 11.001 3.999A2 2 0 019 12zm6 0a2 2 0 11.001 3.999A2 2 0 0115 12zm6 0a2 2 0 11.001 3.999A2 2 0 0121 12z"
  }));
};
SvgChat.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2u = ["title", "titleId"];
var SvgChecklist = function SvgChecklist(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2u);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 0c-1.645 0-3 1.355-3 3H8C6.355 3 5 4.355 5 6v18c0 1.645 1.355 3 3 3h14c1.645 0 3-1.355 3-3V6c0-1.645-1.355-3-3-3h-4c0-1.645-1.355-3-3-3zm0 2c.564 0 1 .436 1 1 0 .564-.436 1-1 1-.564 0-1-.436-1-1 0-.564.436-1 1-1zM8 5h2a2 2 0 002 2h6a2 2 0 002-2h2c.565 0 1 .435 1 1v18c0 .565-.435 1-1 1H8c-.565 0-1-.435-1-1V6c0-.565.435-1 1-1zm11.98 5.99a1 1 0 00-.687.303l-.707.707H18a1 1 0 100 2h1a1 1 0 00.707-.293l1-1a1 1 0 00-.727-1.717zM10 12a1 1 0 100 2h4a1 1 0 100-2h-4zm9.98 4.99a1 1 0 00-.687.303l-.707.707H18a1 1 0 100 2h1a1 1 0 00.707-.293l1-1a1 1 0 00-.727-1.717zM10 18a1 1 0 100 2h4a1 1 0 100-2h-4z"
  }));
};
SvgChecklist.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2t = ["title", "titleId"];
var SvgCheckmarkCircle = function SvgCheckmarkCircle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2t);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 3C8.373 3 3 8.373 3 15s5.373 12 12 12 12-5.373 12-12c0-2.18-.59-4.217-1.605-5.979L14.146 20.268a1 1 0 01-1.414 0L8.28 15.814A.999.999 0 119.693 14.4l3.746 3.746 10.801-10.8A11.97 11.97 0 0015 3zm9.24 4.346c.432.52.814 1.084 1.155 1.674l2.312-2.313a.999.999 0 10-1.414-1.414L24.24 7.346z"
  }));
};
SvgCheckmarkCircle.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2s = ["title", "titleId"];
var SvgCheckmark = function SvgCheckmark(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2s);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.98 5.99a1 1 0 00-.687.303L9 16.586l-3.293-3.293a1 1 0 10-1.414 1.414l4 4a1 1 0 001.414 0l11-11a1 1 0 00-.727-1.717z"
  }));
};
SvgCheckmark.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2r = ["title", "titleId"];
var SvgChevronDown = function SvgChevronDown(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2r);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24.99 8.986a1 1 0 00-.697.307L15 18.586 5.707 9.293a1 1 0 00-.717-.303 1 1 0 00-.697 1.717l10 10a1 1 0 001.414 0l10-10a1 1 0 00-.717-1.72z"
  }));
};
SvgChevronDown.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2q = ["title", "titleId"];
var SvgChevronLeft = function SvgChevronLeft(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2q);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.98 3.99a1 1 0 00-.687.303l-10 10a1 1 0 000 1.414l10 10a1 1 0 101.414-1.414L11.414 15l9.293-9.293a1 1 0 00-.727-1.717z"
  }));
};
SvgChevronLeft.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2p = ["title", "titleId"];
var SvgChevronRight = function SvgChevronRight(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2p);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.99 3.99a1 1 0 00-.697 1.717L18.586 15l-9.293 9.293a1 1 0 101.414 1.414l10-10a1 1 0 000-1.414l-10-10a1 1 0 00-.717-.303z"
  }));
};
SvgChevronRight.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2o = ["title", "titleId"];
var SvgChevronUp = function SvgChevronUp(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2o);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.984 9a1 1 0 00-.691.293l-10 10a1 1 0 101.414 1.414L15 11.414l9.293 9.293a1 1 0 101.414-1.414l-10-10A1 1 0 0014.984 9z"
  }));
};
SvgChevronUp.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2n = ["title", "titleId"];
var SvgClose = function SvgClose(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2n);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.99 4.99a1 1 0 00-.697 1.717L10.586 12l-5.293 5.293a1 1 0 101.414 1.414L12 13.414l5.293 5.293a1 1 0 101.414-1.414L13.414 12l5.293-5.293a1 1 0 00-.727-1.717 1 1 0 00-.687.303L12 10.586 6.707 5.293a1 1 0 00-.717-.303z"
  }));
};
SvgClose.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2m = ["title", "titleId"];
var SvgCloudChecked = function SvgCloudChecked(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2m);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.704 9.004A6.97 6.97 0 0012 4a7.026 7.026 0 00-5.742 3.004A6.508 6.508 0 000 13.5C0 17.084 2.916 20 6.5 20h12c3.032 0 5.5-2.467 5.5-5.5a5.506 5.506 0 00-5.296-5.496zm-8.839 7.131l-2.293-2.293a1 1 0 011.414-1.414l1.586 1.586L14.586 10A1 1 0 0116 11.414l-4.721 4.721a1 1 0 01-1.414 0z"
  }));
};
SvgCloudChecked.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2l = ["title", "titleId"];
var SvgCloudDb = function SvgCloudDb(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2l);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 4a7.026 7.026 0 00-5.742 3.004 6.51 6.51 0 00-6.192 7.435C.522 17.676 3.445 20 6.715 20H14a1 1 0 001-1v-3a2 2 0 012-2h6.248c.388 0 .67-.366.582-.744-.549-2.37-2.614-4.16-5.125-4.252A6.957 6.957 0 0012 4zm6 12a1 1 0 100 2h5a1 1 0 100-2h-5zm0 3a1 1 0 100 2h5a1 1 0 100-2h-5zm0 3a1 1 0 100 2h5a1 1 0 100-2h-5z"
  }));
};
SvgCloudDb.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2k = ["title", "titleId"];
var SvgCloudDba = function SvgCloudDba(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2k);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 4a7.026 7.026 0 00-5.742 3.004A6.508 6.508 0 000 13.5C0 17.084 2.916 20 6.5 20h8.3c.366-.411.834-.743 1.343-1.016.265-.142.538-.273.82-.382l.027-.012A3.901 3.901 0 0116 16c0-2.206 1.794-4 4-4 .392 0 .762.075 1.12.182.481.142.923.375 1.31.673.064.05.13.099.191.153a3.963 3.963 0 011.31 2.314A5.44 5.44 0 0024 14.5a5.507 5.507 0 00-5.295-5.496A6.957 6.957 0 0012 4zm8 10a2 2 0 00-2 2 2 2 0 002 2 2 2 0 002-2 2 2 0 00-2-2zm0 6c-1.335 0-4 .72-4 2.05V23a1 1 0 001 1h6a1 1 0 001-1v-.95c0-1.33-2.665-2.05-4-2.05z"
  }));
};
SvgCloudDba.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2j = ["title", "titleId"];
var SvgCloudPrivate = function SvgCloudPrivate(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2j);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 4a7.026 7.026 0 00-5.742 3.004A6.508 6.508 0 000 13.5C0 17.084 2.916 20 6.5 20H14v-1a3.235 3.235 0 01.176-1c.168-.503.447-.945.832-1.28C15.148 14.053 17.29 12 20 12c.4 0 .782.057 1.152.143.206.047.406.108.6.18.068.024.138.047.205.075.789.33 1.468.851 1.984 1.514-.29-2.688-2.497-4.807-5.236-4.908A6.957 6.957 0 0012 4zm8 10c-1.7 0-3 1.3-3 3v1c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h6c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1v-1c0-1.7-1.3-3-3-3zm0 1.5c.8 0 1.5.7 1.5 1.5v1h-3v-1c0-.8.7-1.5 1.5-1.5z"
  }));
};
SvgCloudPrivate.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2i = ["title", "titleId"];
var SvgCloudPublic = function SvgCloudPublic(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2i);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 4a7.026 7.026 0 00-5.742 3.004A6.508 6.508 0 000 13.5C0 17.084 2.916 20 6.5 20h1.283l.412-.861c.03-.061.26-.522.715-1.139h-.002c1.114-1.513 3.622-4 8.092-4 2.098 0 3.754.555 5.047 1.297a9.628 9.628 0 011.598 1.133c.225-.602.355-1.251.355-1.93a5.507 5.507 0 00-5.295-5.496A6.957 6.957 0 0012 4zm5 12c-3.965 0-6 2.426-6.705 3.5a.904.904 0 000 1.002C11 21.575 13.035 24 17 24s6-2.426 6.705-3.5a.904.904 0 000-1.002C23 18.425 20.965 16 17 16zm0 2a2 2 0 11-.001 4.001A2 2 0 0117 18z"
  }));
};
SvgCloudPublic.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2h = ["title", "titleId"];
var SvgCloud = function SvgCloud(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2h);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 4a7.5 7.5 0 00-6.648 4.043A6 6 0 000 14a6 6 0 006 6h13a5 5 0 005-5 5 5 0 00-4.656-4.982A7.5 7.5 0 0012 4z"
  }));
};
SvgCloud.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2g = ["title", "titleId"];
var SvgCluster = function SvgCluster(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2g);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17 2a3 3 0 00-3 3 3 3 0 001.293 2.46l-1.238 4.542A4 4 0 0014 12a4 4 0 00-2.44.838L7.845 9.945A3 3 0 008 9a3 3 0 00-3-3 3 3 0 00-3 3 3 3 0 003 3 3 3 0 001.617-.477l3.715 2.891A4 4 0 0010 16a4 4 0 00.682 2.229L7.13 22.223A3 3 0 006 22a3 3 0 00-3 3 3 3 0 003 3 3 3 0 003-3 3 3 0 00-.375-1.447l3.55-3.994A4 4 0 0014 20a4 4 0 001.822-.443l3.553 3.996A3 3 0 0019 25a3 3 0 003 3 3 3 0 003-3 3 3 0 00-3-3 3 3 0 00-1.13.223l-3.552-3.996A4 4 0 0018 16a4 4 0 00-.002-.053l4.537-1.238A3 3 0 0025 16a3 3 0 003-3 3 3 0 00-3-3 3 3 0 00-2.992 2.78l-4.54 1.238a4 4 0 00-1.486-1.487l1.24-4.543A3 3 0 0020 5a3 3 0 00-3-3z"
  }));
};
SvgCluster.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2f = ["title", "titleId"];
var SvgCodeWriting = function SvgCodeWriting(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2f);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 4a1 1 0 00-1 1v16a1 1 0 001 1h6.998v2H7.83a.999.999 0 00-.684.271l-1.988 1.866a.5.5 0 00.344.863h18.996a.5.5 0 00.344-.865l-1.988-1.865a1.003 1.003 0 00-.684-.27h-4.172v-2H25a1 1 0 001-1V5a1 1 0 00-1-1H5zm1 2h18v14H6V6zm5.98 2.99a1 1 0 00-.687.303l-3 3a1 1 0 000 1.414l3 3a1 1 0 101.414-1.414L10.414 13l2.293-2.293a1 1 0 00-.727-1.717zm6.01 0a1 1 0 00-.697 1.717L19.586 13l-2.293 2.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 00-.717-.303z"
  }));
};
SvgCodeWriting.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2e = ["title", "titleId"];
var SvgCoffee = function SvgCoffee(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2e);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.984-.014A1 1 0 0014 1v3a1 1 0 102 0V1a1 1 0 00-1.016-1.014zm-4 2A1 1 0 0010 3v1a1 1 0 102 0V3a1 1 0 00-1.016-1.014zm8 0A1 1 0 0018 3v1a1 1 0 102 0V3a1 1 0 00-1.016-1.014zM6 7v17a2 2 0 002 2h14a2 2 0 002-2v-2h1c2.197 0 4-1.803 4-4v-3c0-2.197-1.803-4-4-4h-1V7H6zm18 6h1c1.117 0 2 .883 2 2v3c0 1.117-.883 2-2 2h-1v-7z"
  }));
};
SvgCoffee.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2d = ["title", "titleId"];
var SvgConfigManagement = function SvgConfigManagement(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2d);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.781 2a1 1 0 00-.97.758l-.15.603c-.12.477-.504.825-.98.951-.004.002-.01.003-.017.004-.475.128-.98.02-1.322-.334l-.434-.447a1 1 0 00-1.219-.172l-.378.219a1.001 1.001 0 00-.461 1.143l.168.591c.135.473-.024.966-.372 1.313l-.017.017c-.347.348-.84.507-1.313.372l-.591-.168a1.002 1.002 0 00-1.143.46l-.219.38a1 1 0 00.172 1.218l.447.434c.354.342.462.849.334 1.324l-.003.016c-.127.475-.475.858-.952.978l-.603.152a.998.998 0 00-.758.97v.437a1 1 0 00.758.97l.603.15c.477.12.825.504.951.98.002.004.003.01.004.017.128.475.02.98-.334 1.322l-.447.434a1 1 0 00-.172 1.219l.219.38c.229.397.702.588 1.143.461l.591-.17c.473-.135.966.025 1.313.373l.016.016c.348.347.508.84.373 1.313l-.17.591c-.126.441.064.914.46 1.143l.381.219a1 1 0 001.22-.172l.43-.447c.343-.354.85-.462 1.325-.334l.016.003c.113.03.218.075.318.13V18.65A5.996 5.996 0 0113 7a6 6 0 016 6h5v-.219a1 1 0 00-.758-.97l-.603-.15c-.477-.12-.825-.504-.951-.98-.002-.004-.003-.01-.004-.017-.128-.475-.02-.98.334-1.322l.447-.434a1 1 0 00.172-1.219l-.219-.38a1.001 1.001 0 00-1.143-.461l-.591.17c-.473.135-.966-.025-1.313-.373l-.016-.016c-.348-.347-.508-.84-.373-1.313l.17-.591a1.002 1.002 0 00-.46-1.143l-.381-.219a1 1 0 00-1.22.172l-.433.447c-.342.354-.847.462-1.322.334l-.018-.003c-.475-.127-.858-.475-.978-.952l-.15-.603A1 1 0 0013.218 2h-.438zM13 10a3 3 0 00-1.695 5.473A3.998 3.998 0 0115 13h1a3 3 0 00-3-3zm2 5c-1.093 0-2 .907-2 2v9a1 1 0 001 1h12a1 1 0 001-1v-9c0-1.093-.907-2-2-2H15zm0 3h10v7H15v-7zm4.98.99a1 1 0 00-.687.303L18 20.586l-.293-.293a1 1 0 10-1.414 1.414l1 1a1 1 0 001.414 0l2-2a1 1 0 00-.727-1.717z"
  }));
};
SvgConfigManagement.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2c = ["title", "titleId"];
var SvgConflict = function SvgConflict(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2c);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16 2a1 1 0 00-.922.611l-6.84 12.744a1 1 0 00-.197.368l-.006.01.002.001A1 1 0 008 16a1 1 0 001 1h5.5l-1.48 9.8a1 1 0 00-.02.2 1 1 0 001 1 1 1 0 00.883-.533h.002l.006-.014 6.916-12.863A1 1 0 0022 14a1 1 0 00-1-1h-5.5l1.477-9.787A1 1 0 0017 3a1 1 0 00-1-1zM4.99 3.99a1 1 0 00-.697 1.717l2 2a1 1 0 101.414-1.414l-2-2a1 1 0 00-.717-.303zm19.99 0a1 1 0 00-.687.303l-2 2a1 1 0 101.414 1.414l2-2a1 1 0 00-.727-1.717zm-18 18a1 1 0 00-.687.303l-2 2a1 1 0 101.414 1.414l2-2a1 1 0 00-.727-1.717zm16.01 0a1 1 0 00-.697 1.717l2 2a1 1 0 101.414-1.414l-2-2a1 1 0 00-.717-.303z"
  }));
};
SvgConflict.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2b = ["title", "titleId"];
var SvgConnect = function SvgConnect(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2b);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.793 6a.498.498 0 00-.354.146L.293 11.293a1 1 0 000 1.414l5.146 5.147a.5.5 0 00.707 0l.708-.708a.5.5 0 000-.707L2.414 12l4.44-4.44a.5.5 0 000-.706l-.708-.708A.498.498 0 005.793 6zm12.414 0a.498.498 0 00-.353.146l-.708.708a.5.5 0 000 .707L21.586 12l-4.44 4.44a.5.5 0 000 .706l.708.708a.5.5 0 00.707 0l5.146-5.147a1 1 0 000-1.414l-5.146-5.147A.498.498 0 0018.207 6zM7 11c-.551 0-1 .449-1 1 0 .551.449 1 1 1 .551 0 1-.449 1-1 0-.551-.449-1-1-1zm5 0c-.551 0-1 .449-1 1 0 .551.449 1 1 1 .551 0 1-.449 1-1 0-.551-.449-1-1-1zm6 0c-.551 0-1 .449-1 1 0 .551.449 1 1 1 .551 0 1-.449 1-1 0-.551-.449-1-1-1z"
  }));
};
SvgConnect.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2a = ["title", "titleId"];
var SvgConsole = function SvgConsole(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2a);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 4a2 2 0 00-2 2v19a1 1 0 001 1h22a1 1 0 001-1V6a2 2 0 00-2-2H5zm0 5h20v15H5V9zm3.99 3.99a1 1 0 00-.697 1.717L10.586 17l-2.293 2.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 00-.717-.303zM15 19a1 1 0 100 2h6a1 1 0 100-2h-6z"
  }));
};
SvgConsole.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$29 = ["title", "titleId"];
var SvgContact = function SvgContact(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$29);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 2a2 2 0 00-2 2 2 2 0 002 2 2 2 0 002-2 2 2 0 00-2-2zM5 8a2 2 0 00-2 2 2 2 0 002 2 2 2 0 002-2 2 2 0 00-2-2zm20 0a2 2 0 00-2 2 2 2 0 002 2 2 2 0 002-2 2 2 0 00-2-2zM15 9c-2.059 0-2.912 1.356-2.912 2.99 0 .55.256 1.104.256 1.104-.103.06-.274.252-.23.595.08.64.349.803.52.817.067.596.771 1.442.989 1.553v.955C13.139 18.509 10 18.176 10 21h10c0-2.824-3.14-2.491-3.625-3.986v-.955c.218-.111.923-.957.988-1.553.172-.013.443-.177.522-.817.043-.343-.128-.534-.23-.595 0 0 .255-.5.255-1.104 0-1.21-.462-2.242-1.455-2.242C16.456 9.747 16.111 9 15 9zM5 18a2 2 0 00-2 2 2 2 0 002 2 2 2 0 002-2 2 2 0 00-2-2zm20 0a2 2 0 00-2 2 2 2 0 002 2 2 2 0 002-2 2 2 0 00-2-2zm-10 6a2 2 0 00-2 2 2 2 0 002 2 2 2 0 002-2 2 2 0 00-2-2z"
  }));
};
SvgContact.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$28 = ["title", "titleId"];
var SvgContainer = function SvgContainer(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$28);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.018 2a1 1 0 00-.424.086L2.627 6.072l-.033.014a1 1 0 00-.022.012 1 1 0 00-.058.027 1 1 0 00-.026.016 1 1 0 00-.062.04 1 1 0 00-.041.032 1 1 0 00-.018.014 1 1 0 00-.064.056 1 1 0 00-.012.014 1 1 0 00-.062.068 1 1 0 00-.053.07 1 1 0 00-.012.018 1 1 0 00-.047.078 1 1 0 00-.039.082 1 1 0 00-.006.014 1 1 0 00-.023.066 1 1 0 00-.012.037 1 1 0 00-.012.053 1 1 0 00-.01.049 1 1 0 00-.01.068 1 1 0 00-.001.016A1 1 0 002 7a1 1 0 000 .047V17a1 1 0 00.594.914l9 4a1 1 0 00.025.01 1 1 0 00.047.017 1 1 0 00.045.016 1 1 0 00.039.01 1 1 0 00.057.013 1 1 0 00.048.01 1 1 0 00.055.006 1 1 0 00.172 0 1 1 0 00.006 0 1 1 0 00.066-.008 1 1 0 00.053-.01 1 1 0 00.07-.017 1 1 0 00.008-.002 1 1 0 00.088-.031 1 1 0 00.004-.002 1 1 0 00.03-.012l9-4A1 1 0 0022 17V7.053A1 1 0 0022 7a1 1 0 00-.006-.1 1 1 0 00-.012-.088 1 1 0 00-.002-.011 1 1 0 00-.003-.012 1 1 0 00-.022-.084 1 1 0 00-.027-.076 1 1 0 00-.006-.018 1 1 0 00-.01-.02 1 1 0 00-.027-.056 1 1 0 00-.008-.015 1 1 0 00-.006-.01 1 1 0 00-.037-.06 1 1 0 00-.008-.014 1 1 0 00-.01-.012 1 1 0 00-.039-.051 1 1 0 00-.011-.018 1 1 0 00-.014-.015 1 1 0 00-.043-.045 1 1 0 00-.012-.012 1 1 0 00-.01-.008 1 1 0 00-.06-.054 1 1 0 00-.006-.004 1 1 0 00-.006-.004 1 1 0 00-.052-.04 1 1 0 00-.053-.032 1 1 0 00-.01-.006 1 1 0 00-.047-.026 1 1 0 00-.006-.002 1 1 0 00-.04-.021l-9-4a1 1 0 00-.39-.086zM12 4.094L18.537 7 12 9.906 5.463 7 12 4.094zM4 8.539l7 3.111v7.81l-7-3.11V8.54zm16 0v7.81l-7 3.112v-7.81l7-3.112z"
  }));
};
SvgContainer.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$27 = ["title", "titleId"];
var SvgControl = function SvgControl(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$27);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4 4a2 2 0 00-2 2v10a2 2 0 002 2H1a1 1 0 000 2h22a1 1 0 000-2h-3a2 2 0 002-2V5.994A1.995 1.995 0 0020 4H4zm0 2h16l.002 10H4V6zm10.984 1.986A1 1 0 0014 9v4a1 1 0 102 0V9a1 1 0 00-1.016-1.014zm-3 2A1 1 0 0011 11v2a1 1 0 102 0v-2a1 1 0 00-1.016-1.014zM9 12a1 1 0 100 2 1 1 0 100-2z"
  }));
};
SvgControl.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$26 = ["title", "titleId"];
var SvgConvert = function SvgConvert(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$26);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 4c-1.093 0-2 .907-2 2v2H6c-1.093 0-2 .907-2 2v14c0 1.093.907 2 2 2h12c1.093 0 2-.907 2-2v-2h4c1.093 0 2-.907 2-2V6c0-1.093-.907-2-2-2H12zm0 2h12v14h-5a1 1 0 00-1 1v3H6V10h5a1 1 0 001-1V6zm9 3l-3 3 3 3V9zm-8 2a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm2 3a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm-6 1v6l3-3-3-3zm8 2a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1z"
  }));
};
SvgConvert.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$25 = ["title", "titleId"];
var SvgCrown = function SvgCrown(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$25);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 2a2 2 0 00-2 2 2 2 0 001.059 1.764l-3.955 7.416-5.381-3.166A2 2 0 005 9a2 2 0 00-2-2 2 2 0 00-2 2 2 2 0 002 2 2 2 0 00.2-.012L4 19h22l.8-8.01a2 2 0 00.2.01 2 2 0 002-2 2 2 0 00-2-2 2 2 0 00-2 2 2 2 0 00.277 1.014l-5.38 3.166-3.956-7.416A2 2 0 0017 4a2 2 0 00-2-2zM4 21v2a2 2 0 002 2h18a2 2 0 002-2v-2H4z"
  }));
};
SvgCrown.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$24 = ["title", "titleId"];
var SvgCrystalBall = function SvgCrystalBall(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$24);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 3C8.385 3 3 8.385 3 15c0 3.631 1.628 6.885 4.186 9.088l-.936 1.25A1 1 0 006 26a1 1 0 001 1h16a1 1 0 001-1 1 1 0 00-.24-.648l-.946-1.264C25.372 21.885 27 18.63 27 15c0-6.615-5.385-12-12-12zm11 1a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zM15 5c5.535 0 10 4.465 10 10a9.966 9.966 0 01-4.01 8H9.01A9.966 9.966 0 015 15C5 9.465 9.465 5 15 5zm0 2a7.998 7.998 0 00-6.336 3.115 1 1 0 001.584 1.223A5.979 5.979 0 0115 9a1 1 0 100-2zm5 2.002a.456.456 0 00-.44.318L19 11l-1.68.56a.463.463 0 000 .88L19 13l.56 1.68a.463.463 0 00.88 0L21 13l1.68-.56a.463.463 0 000-.88L21 11l-.56-1.68a.456.456 0 00-.44-.318zM8 14a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm8.5 2a.38.38 0 00-.367.264l-.467 1.402-1.402.467a.387.387 0 000 .734l1.402.467.467 1.402a.387.387 0 00.734 0l.467-1.402 1.402-.467a.387.387 0 000-.734l-1.402-.467-.467-1.402A.38.38 0 0016.5 16z"
  }));
};
SvgCrystalBall.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$23 = ["title", "titleId"];
var SvgCubes = function SvgCubes(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$23);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 3.064c-.231 0-.463.04-.684.12l-5 1.818A2.008 2.008 0 008 6.882v5.747c0 .218.042.428.11.629l-4.794 1.744A2.008 2.008 0 002 16.882v5.747c0 .781.46 1.497 1.172 1.82l4.998 2.274c.526.24 1.134.24 1.66 0l4.998-2.274c.063-.028.113-.075.172-.11.059.035.109.082.172.11l4.998 2.274c.526.24 1.134.24 1.66 0l4.998-2.274A2.003 2.003 0 0028 22.63v-5.746a2.01 2.01 0 00-1.316-1.881l-4.793-1.744c.067-.201.109-.41.109-.63V6.884a2.01 2.01 0 00-1.316-1.881l-5-1.818a1 1 0 00-.002 0c-.22-.08-.45-.12-.682-.12zm0 2l4.451 1.618L15 8.3l-4.451-1.62L15 5.065zM10 8.61l4 1.455v4.385l-4-1.82v-4.02zm-1 6.455l4.451 1.618L9 18.3l-4.451-1.62L9 15.065zm12 0l4.451 1.618L21 18.3l-4.451-1.62L21 15.065zM4 18.61l4 1.455v4.385l-4-1.82v-4.02zm12 0l4 1.455v4.385l-4-1.82v-4.02z"
  }));
};
SvgCubes.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$22 = ["title", "titleId"];
var SvgCycle = function SvgCycle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$22);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 3c-.365 0-.71.023-1.037.05a1 1 0 00.17 1.995c.3-.026.59-.045.867-.045a9.93 9.93 0 016.547 2.453L19 10h6V4l-2.04 2.04A11.951 11.951 0 0015 3zM4 5l2.04 2.04A11.951 11.951 0 003 15c0 .365.023.71.05 1.037a1 1 0 001.995-.17C5.019 15.567 5 15.277 5 15a9.93 9.93 0 012.453-6.547L10 11V5H4zm21.95 8.033a1 1 0 00-.995 1.1c.026.3.045.59.045.867a9.93 9.93 0 01-2.453 6.547L20 19v6h6l-2.04-2.04A11.951 11.951 0 0027 15c0-.365-.023-.71-.05-1.037a1 1 0 00-1-.93zM5 20v6l2.04-2.04A11.951 11.951 0 0015 27c.365 0 .71-.023 1.037-.05a1 1 0 00-.17-1.995c-.3.026-.59.045-.867.045a9.93 9.93 0 01-6.547-2.453L11 20H5z"
  }));
};
SvgCycle.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$21 = ["title", "titleId"];
var SvgDataTransfer = function SvgDataTransfer(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$21);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23 3v3H4a1 1 0 100 2h19v3l4-4-4-4zM7 19l-4 4 4 4v-3h19a1 1 0 100-2H7v-3z"
  }));
};
SvgDataTransfer.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$20 = ["title", "titleId"];
var SvgDatabaseAdmin = function SvgDatabaseAdmin(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$20);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 4a2 2 0 00-2 2v3a1 1 0 001 1h20a1 1 0 001-1V6a2 2 0 00-2-2H6zm-1 8a1 1 0 00-1 1v4a1 1 0 001 1h10.525a2.25 2.25 0 011.551-.924 2.246 2.246 0 011.111-1.69l.625-.36a2.244 2.244 0 012.018-.117A2.247 2.247 0 0122.64 14h.722c.737 0 1.397.353 1.809.908.26-.113.541-.17.83-.178V13a1 1 0 00-1-1H5zm17.639 4a.25.25 0 00-.248.223l-.028.256a.759.759 0 01-.605.654 6.05 6.05 0 00-.615.164.758.758 0 01-.85-.264l-.152-.207a.25.25 0 00-.328-.066l-.625.36a.253.253 0 00-.106.317l.105.24a.757.757 0 01-.195.868 6.141 6.141 0 00-.449.45.757.757 0 01-.867.194l-.24-.105a.252.252 0 00-.319.104l-.36.626a.25.25 0 00.067.327l.207.152a.758.758 0 01.264.85c-.065.2-.12.405-.164.615a.759.759 0 01-.654.605l-.213.026c-.168.016-.264.122-.264.25v.722c0 .127.096.235.223.248l.256.028a.759.759 0 01.654.605c.044.21.099.414.164.615a.758.758 0 01-.264.85l-.207.152a.25.25 0 00-.068.327l.361.627c.064.11.2.154.317.103l.24-.105a.76.76 0 01.869.195c.142.157.29.307.447.45.244.22.33.565.197.866l-.105.24a.252.252 0 00.104.319l.626.36a.25.25 0 00.327-.067l.15-.207a.757.757 0 01.85-.264c.2.065.407.12.617.164a.755.755 0 01.603.654l.03.256c.014.127.12.223.248.223h.722a.25.25 0 00.248-.223l.028-.256a.759.759 0 01.605-.654c.21-.044.414-.099.615-.164a.758.758 0 01.85.264l.152.207c.075.103.217.13.327.066l.625-.36a.252.252 0 00.103-.317l-.103-.24a.757.757 0 01.195-.868c.157-.142.307-.291.45-.45a.757.757 0 01.866-.194l.24.105a.252.252 0 00.319-.104l.36-.626a.249.249 0 00-.07-.327l-.204-.152a.759.759 0 01-.266-.85c.065-.2.12-.405.164-.615a.758.758 0 01.655-.605l.255-.028a.248.248 0 00.225-.248v-.722a.25.25 0 00-.223-.248l-.256-.028a.759.759 0 01-.654-.605 6.05 6.05 0 00-.164-.615.758.758 0 01.264-.85l.207-.152a.248.248 0 00.066-.327l-.36-.627a.252.252 0 00-.317-.103l-.24.105a.757.757 0 01-.868-.195 6.141 6.141 0 00-.45-.45.757.757 0 01-.194-.866l.103-.24a.252.252 0 00-.103-.319l-.625-.36a.252.252 0 00-.329.067l-.152.207a.758.758 0 01-.85.264 5.981 5.981 0 00-.615-.164.757.757 0 01-.605-.654l-.028-.256a.245.245 0 00-.246-.223h-.722zM23 19a4 4 0 110 8 4 4 0 010-8zM5 20a1 1 0 00-1 1v3a2 2 0 002 2h8.736c.008-.286.058-.569.172-.832A2.248 2.248 0 0114 23.361v-.722c0-.73.354-1.383.912-1.797a2.249 2.249 0 01-.176-.842H5zm18 2a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1z"
  }));
};
SvgDatabaseAdmin.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1$ = ["title", "titleId"];
var SvgDatabaseBackup = function SvgDatabaseBackup(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1$);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 4a2 2 0 00-2 2v3a1 1 0 001 1h20a1 1 0 001-1V6a2 2 0 00-2-2H6zm-1 8a1 1 0 00-1 1v4a1 1 0 001 1h10.518A8.991 8.991 0 0123 14c1.054 0 2.06.19 3 .523V13a1 1 0 00-1-1H5zm18 4.008c-1.794 0-3.587.68-4.95 2.043-2.724 2.725-2.724 7.173 0 9.898 2.69 2.69 7.052 2.72 9.786.102L29 29.305l.975-5.264L25 25l1.477 1.588a4.982 4.982 0 01-7.012-.053 4.984 4.984 0 010-7.07 4.984 4.984 0 017.07 0 1 1 0 101.414-1.414A6.976 6.976 0 0023 16.008zM5 20a1 1 0 00-1 1v3a2 2 0 002 2h8.523A8.956 8.956 0 0114 23c0-1.054.19-2.06.523-3H5z"
  }));
};
SvgDatabaseBackup.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1_ = ["title", "titleId"];
var SvgDatabase = function SvgDatabase(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1_);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 4a2 2 0 00-2 2v3a1 1 0 001 1h20a1 1 0 001-1V6a2 2 0 00-2-2H6zm-1 8a1 1 0 00-1 1v4a1 1 0 001 1h20a1 1 0 001-1v-4a1 1 0 00-1-1H5zm0 8a1 1 0 00-1 1v3a2 2 0 002 2h18a2 2 0 002-2v-3a1 1 0 00-1-1H5z"
  }));
};
SvgDatabase.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1Z = ["title", "titleId"];
var SvgDeliverLove = function SvgDeliverLove(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1Z);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.273 4A3.273 3.273 0 0014 7.273c0 3.138 3.624 6.129 5.334 7.473a1 1 0 00.055.045 1 1 0 00.01.008A1 1 0 0020 15a1 1 0 00.602-.201 1 1 0 00.013-.012l.006-.004a1 1 0 00.014-.012C22.335 13.437 26 10.427 26 7.273A3.273 3.273 0 0022.727 4C21 4 20 5.5 20 5.5S19 4 17.273 4zM8 14a3 3 0 00-1.117.217L2 16v8l4.22-1.834a2.013 2.013 0 011.565-.018l9.065 3.704h.004A1.5 1.5 0 0017.5 26a1.5 1.5 0 00.738-.197h.006l8.986-4.992-.001-.002A1.5 1.5 0 0028 19.5a1.5 1.5 0 00-1.5-1.5 1.5 1.5 0 00-.637.145v-.002L19 21h-1.5a1.5 1.5 0 001.5-1.5 1.5 1.5 0 00-1.035-1.426v-.002l-8.694-3.79H9.26A3 3 0 008 14z"
  }));
};
SvgDeliverLove.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1Y = ["title", "titleId"];
var SvgDesign = function SvgDesign(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1Y);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.586 2a.997.997 0 00-.707.293L2.293 7.879a.999.999 0 000 1.414l5.793 5.793L9.5 13.672 4.414 8.586l4.172-4.172 1.293 1.293L8.586 7 10 8.414l1.293-1.293 1.086 1.086-2.086 2.086 1.293 1.293 3.5-3.5-1.293-1.293-4.5-4.5A.997.997 0 008.586 2zm15.24 1c-.511 0-1.023.197-1.414.588L21 5l4 4 1.412-1.412a1.997 1.997 0 00.002-2.826l-1.176-1.176c-.39-.39-.9-.587-1.412-.586zM19 7L5.23 20.77l1.27.73L7 23l1.5.5.73 1.27L23 11l-4-4zm2.914 7.914l-3.5 3.5 1.293 1.293 2.086-2.086 1.086 1.086L21.586 20 23 21.414l1.293-1.293 1.293 1.293-4.172 4.172-5.086-5.086-1.414 1.414 5.793 5.793a.997.997 0 001.414 0l5.586-5.586a.999.999 0 000-1.414l-4.5-4.5-1.293-1.293zM3.893 23.893l-.856 2.416A.5.5 0 003 26.5a.5.5 0 00.5.5.5.5 0 00.182-.033l2.427-.858-2.216-2.216z"
  }));
};
SvgDesign.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1X = ["title", "titleId"];
var SvgDeveloper = function SvgDeveloper(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1X);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.281 2.004c-5.42-.138-10.277 3.826-11.135 9.18-.642 4.008.885 7.689 3.588 10.068.83.73 1.266 1.81 1.266 2.916V28h10v-1.559c0-.86.55-1.624 1.367-1.896l3.266-1.088A2.003 2.003 0 0024 21.559v-3.815l2.268-.781A1 1 0 0027 16a1 1 0 00-.227-.63l-.027-.034a1 1 0 00-.03-.033l-2.757-3.305c-.4-5.513-4.097-9.854-9.678-9.994zm.52 6.014a.984.984 0 01.396.002.998.998 0 01.783 1.175l-2 10a.998.998 0 01-1.175.785 1.001 1.001 0 01-.785-1.177l2-10a1 1 0 01.78-.785zm-5.615 2a.999.999 0 01.646 1.54l-1.63 2.442 1.63 2.445a.999.999 0 11-1.664 1.11l-2-3a1 1 0 010-1.11l2-3a.996.996 0 011.018-.427zm9.627 0a1 1 0 011.019.427l2 3a1 1 0 010 1.11l-2 3a1 1 0 01-1.664-1.11L19.798 14l-1.63-2.445a.999.999 0 01.645-1.537z"
  }));
};
SvgDeveloper.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1W = ["title", "titleId"];
var SvgDiploma = function SvgDiploma(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1W);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4 5a1 1 0 00-1 1v17a1 1 0 001.158 1H9.35A5.971 5.971 0 019 22H5V7h20v15h-4c0 .702-.128 1.374-.35 2h5.182A1 1 0 0027 23V6a1 1 0 00-1-1H4zm6 5a1 1 0 100 2h10a1 1 0 100-2H10zm0 4a1 1 0 100 2h10a1 1 0 100-2H10zm5 4c-2.197 0-4 1.803-4 4 0 1 .386 1.907 1 2.611V30l3-2 3 2v-5.389c.614-.704 1-1.61 1-2.611 0-2.197-1.803-4-4-4zm0 2c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2z"
  }));
};
SvgDiploma.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1V = ["title", "titleId"];
var SvgDockerContainer = function SvgDockerContainer(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1V);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 6a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3zm-12 6a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3zm6 0a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3zm6 0a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3zm14.979 2.3l-.454.651a9.167 9.167 0 00-1.222 2.848c-.46 1.933-.182 3.748.804 5.299-1.19.66-3.221.888-3.607.902H2a2 2 0 00-2 2c0 2 .434 4.925 1.387 7.516 1.089 2.844 2.71 4.938 4.818 6.22C8.567 41.177 12.405 42 16.755 42a31.635 31.635 0 005.86-.53 24.554 24.554 0 007.647-2.765 21.027 21.027 0 005.218-4.254c2.505-2.824 3.998-5.97 5.108-8.764.005-.003.009-.003.014-.007 2.997.12 4.81-1.037 5.789-2a5.83 5.83 0 001.414-2.086L48 21.02l-.473-.37c-.13-.104-1.345-1.018-3.908-1.018-.677.003-1.352.062-2.02.174-.495-3.385-3.305-5.038-3.431-5.112l-.69-.394zM4.5 18a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3zm6 0a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3zm6 0a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3zm6 0a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3zm6 0a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3z"
  }));
};
SvgDockerContainer.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1U = ["title", "titleId"];
var SvgDocs = function SvgDocs(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1U);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8 3a3 3 0 00-3 3v18a1 1 0 00.295.709C5.648 25.973 6.63 27 8 27h16a1 1 0 100-2H8c-.565 0-1-.435-1-1s.435-1 1-1h15a2 2 0 002-2V5a2 2 0 00-2-2H8zm4 6h7a1 1 0 010 2h-7a1 1 0 010-2z"
  }));
};
SvgDocs.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1T = ["title", "titleId"];
var SvgDottedBox = function SvgDottedBox(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1T);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22 10c-.523 0-.96.406-1 .93V11c0 .523.406.96.93 1H22c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V11c0 .523.406.96.93 1H26c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V11c0 .523.406.96.93 1H30c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V11c0 .523.406.96.93 1H34c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V11c0 .523.406.96.93 1H38c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V11c0 .523.406.96.93 1H42c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V11c0 .523.406.96.93 1H46c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V11c0 .523.406.96.93 1H50c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V11c0 .523.406.96.93 1H54c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V11c0 .523.406.96.93 1H58c.55 0 1-.45 1-1s-.45-1-1-1zm-40 1a1.002 1.002 0 00-.07 2H18c.55 0 1-.45 1-1s-.45-1-1-1zm44 0c-.523 0-.96.406-1 .93V12c0 .523.406.96.93 1H62c.55 0 1-.45 1-1s-.45-1-1-1zm-48 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm52 0c-.523 0-.96.406-1 .93V14c0 .523.406.96.93 1H66c.55 0 1-.45 1-1s-.45-1-1-1zm-26 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-4.484.441a1.003 1.003 0 00-.984 1.195 1 1 0 001.175.786c.543-.11.895-.633.79-1.176a1.007 1.007 0 00-.981-.805zm9 0a1 1 0 10-.053 2.001 1 1 0 00.053-2zM12 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm44 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 0c-.523 0-.96.406-1 .93V18c0 .523.406.96.93 1H68c.55 0 1-.45 1-1s-.45-1-1-1zm-19.176.75a1.001 1.001 0 00-.949.613 1.006 1.006 0 00.547 1.309.994.994 0 001.3-.543.994.994 0 00-.898-1.379zm-17.62 0a.951.951 0 00-.388.078.992.992 0 00-.539 1.305c.211.508.793.75 1.301.539a.98.98 0 00.543-.54c.102-.245.102-.519.004-.765a1.011 1.011 0 00-.922-.617zm-3.97 2.125a.966.966 0 00-.566.168 1 1 0 10.566-.168zm25.563 0a.999.999 0 10-.037 1.996.999.999 0 00.037-1.996zM21 20c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm38 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-48 1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm58 0c-.523 0-.96.406-1 .93V22c0 .523.406.96.93 1H69c.55 0 1-.45 1-1s-.45-1-1-1zm-45.25 1.734a.976.976 0 00-.719.297.995.995 0 000 1.41.995.995 0 001.41 0 .995.995 0 000-1.41 1 1 0 00-.691-.297zm32.527 0c-.27 0-.53.106-.718.297a.995.995 0 000 1.41.995.995 0 001.41 0 .995.995 0 000-1.41.983.983 0 00-.692-.297zM11 25c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm28 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 0c-.523 0-.96.406-1 .93V26c0 .523.406.96.93 1H69c.55 0 1-.45 1-1s-.45-1-1-1zm-9.863 1.219a1.02 1.02 0 00-.57.172.999.999 0 101.386.273.995.995 0 00-.816-.445zm-38.242 0a1 1 0 00-.848.449.992.992 0 00.277 1.383 1 1 0 001.535-1.023.98.98 0 00-.425-.637.98.98 0 00-.54-.172zM40 27c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-4.582.91a1.002 1.002 0 00-.934 1.387 1 1 0 001.848-.766 1.004 1.004 0 00-.914-.62zm9.195 0a.999.999 0 00-.945.621 1 1 0 101.305-.543 1.022 1.022 0 00-.36-.078zM29 28c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm22 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-40 1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm58 0c-.523 0-.96.406-1 .93V30c0 .523.406.96.93 1H69c.55 0 1-.45 1-1s-.45-1-1-1zm-50.23 1.2a.99.99 0 00-.942.613.997.997 0 101.844.766.994.994 0 00-.902-1.38zm42.484 0a.994.994 0 00-.926 1.379.997.997 0 101.844-.767.992.992 0 00-.918-.613zm-29.723.316a.96.96 0 00-.722.293.995.995 0 000 1.41.987.987 0 001.414 0 .995.995 0 000-1.41.97.97 0 00-.692-.293zm16.969 0a1 1 0 10-.032 2 1 1 0 00.032-2zM11 33c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm23 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm12 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm23 0c-.523 0-.96.406-1 .93V34c0 .523.406.96.93 1H69c.55 0 1-.45 1-1s-.45-1-1-1zm-17.906 1.406a.999.999 0 10.375 1.922.997.997 0 00-.375-1.922zm-22.157 0a1.008 1.008 0 00-.949.621.999.999 0 00.543 1.305 1.004 1.004 0 001.309-.539 1.002 1.002 0 00-.902-1.387zm-11.468.11a.994.994 0 00-1.008.8c-.11.543.242 1.07.785 1.18a1.003 1.003 0 001.027-1.539 1.003 1.003 0 00-.636-.426.815.815 0 00-.168-.015zm45.093 0a.857.857 0 00-.199.015.998.998 0 00-.36 1.813.996.996 0 001.388-.274 1.01 1.01 0 00.152-.754 1 1 0 00-.98-.8zM37 36c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-32 1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm58 0c-.523 0-.96.406-1 .93V38c0 .523.406.96.93 1H69c.55 0 1-.45 1-1s-.45-1-1-1zm-52 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm11 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm12 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm12 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm11 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-52 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm58 0c-.523 0-.96.406-1 .93V42c0 .523.406.96.93 1H69c.55 0 1-.45 1-1s-.45-1-1-1zm-32 1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm19.582 1.484a1 1 0 00-1.004.809 1 1 0 101.961.39 1.001 1.001 0 00-.957-1.199zm-45.133.004c-.07 0-.137.004-.199.016a1.027 1.027 0 00-.64.426.998.998 0 101.664 1.113.999.999 0 00-.824-1.555zm33.66.102a.995.995 0 00-.945.617c-.21.512.031 1.094.54 1.309a1.002 1.002 0 001.308-.543.997.997 0 00-.543-1.305.943.943 0 00-.36-.078zm-22.187.004a.999.999 0 00-.934 1.379 1.003 1.003 0 001.852-.766 1.002 1.002 0 00-.918-.613zM11 45c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm23 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm12 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm23 0c-.523 0-.96.406-1 .93V46c0 .523.406.96.93 1H69c.55 0 1-.45 1-1s-.45-1-1-1zm-37.469 2.484a1 1 0 10.688 1.707 1 1 0 00-.688-1.707zm16.969 0a.997.997 0 00-1.016 1 1 1 0 101.016-1zm-29.738.317c-.137 0-.27.023-.39.074a1.003 1.003 0 00-.544 1.309.997.997 0 001.309.539.999.999 0 00-.375-1.922zm42.508 0a.994.994 0 00-.942.617.992.992 0 00.54 1.305 1 1 0 10.402-1.922zM11 49c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm58 0c-.523 0-.96.406-1 .93V50c0 .523.406.96.93 1H69c.55 0 1-.45 1-1s-.45-1-1-1zm-40 1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm22 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-15.566.086a1.005 1.005 0 00-.95.617 1.005 1.005 0 00.543 1.305.999.999 0 001.305-1.309 1.011 1.011 0 00-.539-.539 1.055 1.055 0 00-.36-.074zm9.164 0a.998.998 0 00-.926 1.383.997.997 0 101.844-.766 1.001 1.001 0 00-.918-.617zM40 51c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm19.14.777a.993.993 0 00-.847.442 1.004 1.004 0 00.273 1.39c.223.145.493.2.754.149.262-.055.489-.207.637-.43a1.001 1.001 0 00-.277-1.387.973.973 0 00-.54-.164zm-38.25 0a.965.965 0 00-.566.168 1 1 0 10.566-.168zM11 53c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm28 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 0c-.523 0-.96.406-1 .93V54c0 .523.406.96.93 1H69c.55 0 1-.45 1-1s-.45-1-1-1zm-45.25 2.262a1 1 0 10.691 1.707 1 1 0 00-.691-1.707zm32.527.004a.972.972 0 00-.722.293 1 1 0 101.414 0 .98.98 0 00-.692-.293zM11 57c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm58 0c-.523 0-.96.406-1 .93V58c0 .523.406.96.93 1H69c.55 0 1-.45 1-1s-.45-1-1-1zm-48 1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm38 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-6.207.121a1.02 1.02 0 00-.57.172.995.995 0 00-.274 1.383 1 1 0 101.66-1.11.995.995 0 00-.816-.445zm-25.55.004c-.34-.008-.661.16-.852.441-.305.461-.18 1.079.277 1.387a.997.997 0 001.387-.277.995.995 0 00-.813-1.551zm3.976 2.125a.99.99 0 00-.942.613.997.997 0 00.54 1.309 1.003 1.003 0 001.308-.543.999.999 0 00-.906-1.379zm17.593 0a.999.999 0 00-.934 1.379c.212.512.798.754 1.31.543.507-.211.75-.797.539-1.309a.997.997 0 00-.914-.613zM12 61c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm44 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 0c-.523 0-.96.406-1 .93V62c0 .523.406.96.93 1H68c.55 0 1-.45 1-1s-.45-1-1-1zm-32.457.559a1.008 1.008 0 00-1.012.804.996.996 0 00.153.75.998.998 0 101.664-1.11.997.997 0 00-.805-.444zm8.95 0a.998.998 0 00-.984 1.195.998.998 0 001.175.785.998.998 0 00.785-1.176c-.094-.465-.5-.8-.977-.804zM40 62c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-26 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm52 0c-.523 0-.96.406-1 .93V66c0 .523.406.96.93 1H66c.55 0 1-.45 1-1s-.45-1-1-1zm-48 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm44 0c-.523 0-.96.406-1 .93V68c0 .523.406.96.93 1H62c.55 0 1-.45 1-1s-.45-1-1-1zm-40 1c-.523 0-.96.406-1 .93V69c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V69c0 .523.406.96.93 1H26c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V69c0 .523.406.96.93 1H30c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V69c0 .523.406.96.93 1H34c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V69c0 .523.406.96.93 1H38c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V69c0 .523.406.96.93 1H42c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V69c0 .523.406.96.93 1H46c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V69c0 .523.406.96.93 1H50c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V69c0 .523.406.96.93 1H54c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V69c0 .523.406.96.93 1H58c.55 0 1-.45 1-1s-.45-1-1-1z"
  }));
};
SvgDottedBox.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1S = ["title", "titleId"];
var SvgDownload = function SvgDownload(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1S);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 1a1 1 0 00-1 1v4h2V2a1 1 0 00-1-1zm1 5v12.586l2.293-2.293a.999.999 0 111.414 1.414l-4 4a.997.997 0 01-1.414 0l-4-4a.999.999 0 111.414-1.414L14 18.586V6H6a2 2 0 00-2 2v17a2 2 0 002 2h18a2 2 0 002-2V8a2 2 0 00-2-2h-8z"
  }));
};
SvgDownload.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1R = ["title", "titleId"];
var SvgDrives = function SvgDrives(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1R);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 4a2 2 0 00-2 2v2a2 2 0 002 2h18a2 2 0 002-2V6a2 2 0 00-2-2H6zm1 2a1 1 0 110 2 1 1 0 010-2zm-1 6a2 2 0 00-2 2v2a2 2 0 002 2h18a2 2 0 002-2v-2a2 2 0 00-2-2H6zm1 2a1 1 0 110 2 1 1 0 010-2zm-1 6a2 2 0 00-2 2v2a2 2 0 002 2h18a2 2 0 002-2v-2a2 2 0 00-2-2H6zm1 2a1 1 0 110 2 1 1 0 010-2z"
  }));
};
SvgDrives.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1Q = ["title", "titleId"];
var SvgDuplicate = function SvgDuplicate(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1Q);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11 2a2 2 0 00-2 2v16a2 2 0 002 2h13a2 2 0 002-2V8.5a1 1 0 00-.293-.707l-5.5-5.5A1 1 0 0019.5 2H11zm8 1.904L24.096 9H20a1 1 0 01-1-1V3.904zM6 7a2 2 0 00-2 2v16a2 2 0 002 2h13a2 2 0 002-2v-1H11c-2.206 0-4-1.794-4-4V7H6z"
  }));
};
SvgDuplicate.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1P = ["title", "titleId"];
var SvgEarth = function SvgEarth(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1P);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 1a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm-4.975.99a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm9.95 0a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zM5.809 4.81a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm18.382 0a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zM15 5C9.489 5 5 9.489 5 15s4.489 10 10 10 10-4.489 10-10S20.511 5 15 5zm-.82 2.041h.002v1.414h-1.637v-1.07a7.974 7.974 0 011.635-.344zm1.636 0a7.956 7.956 0 013.62 1.297l-.344.117v.82h-.819l-.818.819v1.635l1.637-.819 2.455.819-.818 1.636-1.637-.818h-1.637l-1.635 1.637v1.634l1.635 1.637h1.637l.818 1.637-1.594 3.187c-1.01.46-2.13.721-3.316.721a8.08 8.08 0 01-1.111-.086l-1.371-1.34.029-3.3-2.455-2.456H7.637v-1.636l4.09-2.455v-1.635h1.636l.819.816 1.634-.816V7.04zM2.99 9.025a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm24.02 0a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zM2 14a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm26 0a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zM2.99 18.975a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm24.02 0a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zM5.809 23.19a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm18.382 0a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zM10.025 26.01a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm9.95 0a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zM15 27a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1z"
  }));
};
SvgEarth.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1O = ["title", "titleId"];
var SvgEasy = function SvgEasy(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1O);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.984-.014A1 1 0 0011 1v1a1 1 0 102 0V1a1 1 0 00-1.016-1.014zM6.99 1.99a1 1 0 00-.697 1.717l1 1a1 1 0 101.414-1.414l-1-1a1 1 0 00-.717-.303zm9.99 0a1 1 0 00-.687.303l-1 1a1 1 0 101.414 1.414l1-1a1 1 0 00-.727-1.717zm6.235 1.031a1.692 1.692 0 00-1.328.493L11.004 14.396s-1.755-3.302-2.635-4.183C6.834 8.679 4.484 8.547 3.701 9.33l-.416.414a.936.936 0 000 1.324l2.113 2.114 1.153 4.843a7.231 7.231 0 001.92 3.438l4.244 4.242a4.366 4.366 0 006.176 0l1.214-1.215 5.334-5.334c.597-.597.742-1.56.248-2.246a1.697 1.697 0 00-2.583-.217l.537-.537c.598-.598.742-1.559.248-2.244a1.698 1.698 0 00-2.584-.219l.535-.535c.598-.598.742-1.56.248-2.246a1.698 1.698 0 00-2.584-.217l4.719-4.718c.598-.598.742-1.56.248-2.245a1.7 1.7 0 00-1.256-.71z"
  }));
};
SvgEasy.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1N = ["title", "titleId"];
var SvgEdbArk = function SvgEdbArk(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1N);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25 2a4.015 4.015 0 00-4 3.99L9.937 12.312A3.98 3.98 0 007 11c-2.197 0-4 1.803-4 4 0 1.85 1.284 3.406 3 3.855v12.29c-1.716.45-3 2.005-3 3.855 0 2.197 1.803 4 4 4a3.98 3.98 0 002.938-1.313L21 44.01A4.015 4.015 0 0025 48a4.015 4.015 0 004-3.99l11.063-6.322A3.98 3.98 0 0043 39c2.197 0 4-1.803 4-4 0-1.85-1.284-3.406-3-3.855v-12.29c1.716-.45 3-2.005 3-3.855 0-2.197-1.803-4-4-4a3.98 3.98 0 00-2.938 1.313L29 5.99A4.015 4.015 0 0025 2zm0 2c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2zm-3.451 3.98C22.242 9.18 23.525 10 25 10s2.758-.821 3.451-2.02l10.668 6.098c-.071.298-.119.604-.119.922 0 1.85 1.284 3.406 3 3.855v12.29c-1.716.45-3 2.005-3 3.855 0 .318.048.624.12.922L28.45 42.02C27.758 40.82 26.475 40 25 40s-2.758.821-3.451 2.02L10.88 35.922c.071-.298.119-.604.119-.922 0-1.85-1.284-3.406-3-3.855v-12.29c1.716-.45 3-2.005 3-3.855 0-.318-.048-.624-.12-.922L21.55 7.98zM7 13c1.116 0 2 .884 2 2a1.979 1.979 0 01-1.91 1.99 1 1 0 00-.182 0A1.98 1.98 0 015 15c0-1.116.884-2 2-2zm36 0c1.116 0 2 .884 2 2a1.979 1.979 0 01-1.91 1.99 1 1 0 00-.182 0A1.98 1.98 0 0141 15c0-1.116.884-2 2-2zM6.91 33.01a1 1 0 00.182 0A1.98 1.98 0 019 35c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.086.838-1.943 1.91-1.99zm36 0a1 1 0 00.182 0A1.98 1.98 0 0145 35c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.086.838-1.943 1.91-1.99zM25 42c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.02 15.5a1 1 0 00-.516.13l-7 4 .992 1.74L20 20.51v4.99h2v-6.133l3-1.715 3 1.715V25.5h2v-4.99l1.504.86.992-1.74-7-4a1 1 0 00-.476-.13zM17 23.498l-2 .004s.005 2.82.004 3.371c-.003 2.248.92 4.278 2.51 5.516a2.655 2.655 0 01-.764.111c-.563 0-1.056-.175-1.357-.395-.302-.22-.393-.424-.393-.605h-2c0 .924.523 1.718 1.217 2.223.693.504 1.577.777 2.533.777s1.84-.273 2.533-.777c.078-.057.144-.13.217-.194.073.064.139.137.217.194.693.504 1.577.777 2.533.777s1.84-.273 2.533-.777c.078-.057.144-.13.217-.194.073.064.139.137.217.194.693.504 1.577.777 2.533.777s1.84-.273 2.533-.777c.078-.057.144-.13.217-.194.073.064.139.137.217.194.693.504 1.577.777 2.533.777s1.84-.273 2.533-.777c.694-.505 1.217-1.3 1.217-2.223h-2c0 .181-.09.386-.393.605-.301.22-.794.395-1.357.395-.275 0-.533-.043-.76-.111 1.59-1.238 2.513-3.268 2.51-5.516-.001-.55.004-3.371.004-3.371l-2-.004s0 1.085-.002 2.01l-16-.008A3949.6 3949.6 0 0117 23.498zm.043 4.002l15.918.008c-.185 2.086-1.3 3.553-3.1 3.992H29.5c0 .181-.09.386-.393.605-.301.22-.794.395-1.357.395s-1.056-.175-1.357-.395c-.302-.22-.393-.424-.393-.605h-2c0 .181-.09.386-.393.605-.301.22-.794.395-1.357.395s-1.056-.175-1.357-.395c-.302-.22-.393-.424-.393-.605h-.357c-1.802-.44-2.917-1.91-3.1-4z"
  }));
};
SvgEdbArk.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1M = ["title", "titleId"];
var SvgEdbBart = function SvgEdbBart(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1M);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25 2a4.015 4.015 0 00-4 3.99L9.937 12.312A3.98 3.98 0 007 11c-2.197 0-4 1.803-4 4 0 1.85 1.284 3.406 3 3.855v12.29c-1.716.45-3 2.005-3 3.855 0 2.197 1.803 4 4 4a3.98 3.98 0 002.938-1.313L21 44.01A4.015 4.015 0 0025 48a4.015 4.015 0 004-3.99l11.063-6.322A3.98 3.98 0 0043 39c2.197 0 4-1.803 4-4 0-1.85-1.284-3.406-3-3.855v-12.29c1.716-.45 3-2.005 3-3.855 0-2.197-1.803-4-4-4a3.98 3.98 0 00-2.938 1.313L29 5.99A4.015 4.015 0 0025 2zm0 2c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2zm-3.451 3.98C22.242 9.18 23.525 10 25 10s2.758-.821 3.451-2.02l10.668 6.098c-.071.298-.119.604-.119.922 0 1.85 1.284 3.406 3 3.855v12.29c-1.716.45-3 2.005-3 3.855 0 .318.048.624.12.922L28.45 42.02C27.758 40.82 26.475 40 25 40s-2.758.821-3.451 2.02L10.88 35.922c.071-.298.119-.604.119-.922 0-1.85-1.284-3.406-3-3.855v-12.29c1.716-.45 3-2.005 3-3.855 0-.318-.048-.624-.12-.922L21.55 7.98zM7 13c1.116 0 2 .884 2 2a1.979 1.979 0 01-1.91 1.99 1 1 0 00-.182 0A1.98 1.98 0 015 15c0-1.116.884-2 2-2zm36 0c1.116 0 2 .884 2 2a1.979 1.979 0 01-1.91 1.99 1 1 0 00-.182 0A1.98 1.98 0 0141 15c0-1.116.884-2 2-2zM6.91 33.01a1 1 0 00.182 0A1.98 1.98 0 019 35c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.086.838-1.943 1.91-1.99zm36 0a1 1 0 00.182 0A1.98 1.98 0 0145 35c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.086.838-1.943 1.91-1.99zM25 42c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 14c.6 0 1 .4 1 1v3.2c1.2-1.3 3.5-3.2 7-3.2 5.5 0 10 4.5 10 10s-4.5 10-10 10-10-4.5-10-10c0-.6.4-1 1-1s1 .5 1 1c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8c-3.2 0-5.1 2-5.9 3H23c.6 0 1 .4 1 1s-.4 1-1 1h-7v-7c0-.6.4-1 1-1z"
  }));
};
SvgEdbBart.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1L = ["title", "titleId"];
var SvgEdbDashboard = function SvgEdbDashboard(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1L);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25 2a4.015 4.015 0 00-4 3.99L9.937 12.312A3.98 3.98 0 007 11c-2.197 0-4 1.803-4 4 0 1.85 1.284 3.406 3 3.855v12.29c-1.716.45-3 2.005-3 3.855 0 2.197 1.803 4 4 4a3.98 3.98 0 002.938-1.313L21 44.01A4.015 4.015 0 0025 48a4.015 4.015 0 004-3.99l11.063-6.322A3.98 3.98 0 0043 39c2.197 0 4-1.803 4-4 0-1.85-1.284-3.406-3-3.855v-12.29c1.716-.45 3-2.005 3-3.855 0-2.197-1.803-4-4-4a3.98 3.98 0 00-2.938 1.313L29 5.99A4.015 4.015 0 0025 2zm0 2c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2zm-3.451 3.98C22.242 9.18 23.525 10 25 10s2.758-.821 3.451-2.02l10.668 6.098c-.071.298-.119.604-.119.922 0 1.85 1.284 3.406 3 3.855v12.29c-1.716.45-3 2.005-3 3.855 0 .318.048.624.12.922L28.45 42.02C27.758 40.82 26.475 40 25 40s-2.758.821-3.451 2.02L10.88 35.922c.071-.298.119-.604.119-.922 0-1.85-1.284-3.406-3-3.855v-12.29c1.716-.45 3-2.005 3-3.855 0-.318-.048-.624-.12-.922L21.55 7.98zM7 13c1.116 0 2 .884 2 2a1.979 1.979 0 01-1.91 1.99 1 1 0 00-.106-.004 1 1 0 00-.076.004A1.98 1.98 0 015 15c0-1.116.884-2 2-2zm36 0c1.116 0 2 .884 2 2a1.979 1.979 0 01-1.91 1.99 1 1 0 00-.106-.004 1 1 0 00-.076.004A1.98 1.98 0 0141 15c0-1.116.884-2 2-2zm-17.363 2c-2.282 0-4.023.793-4.922 2.207-.81 1.274-.823 2.876-.447 4.52a1.94 1.94 0 00-.256 1.218c.063.57.203 1.023.468 1.39.098.136.273.144.405.243.135.532.276 1.082.54 1.44.187.25.376.461.552.632.007.008.016.01.023.018v.992c-.067.151-.177.291-.525.488-.385.218-.96.44-1.584.745-.625.304-1.313.702-1.875 1.359-.563.657-.952 1.573-1.014 2.693A1 1 0 0018 34h14a1 1 0 00.998-1.055c-.062-1.12-.451-2.036-1.014-2.693-.562-.657-1.25-1.055-1.875-1.36-.624-.304-1.199-.528-1.584-.746-.348-.197-.458-.335-.525-.486v-1.004c.01-.01.021-.015.031-.025.173-.174.36-.387.541-.637.256-.353.392-.886.526-1.4.131-.1.306-.107.404-.242.266-.369.408-.821.47-1.391a2.192 2.192 0 00-.124-1.068c-.018-.045-.096-.069-.118-.114.28-1.145.37-2.366-.072-3.486-.422-1.07-1.514-1.803-2.877-2.068l-.205-.567a1 1 0 00-.94-.658zm-.66 2.111l.084.23A1 1 0 0026 18c1.193 0 1.539.373 1.797 1.027.258.654.23 1.72-.067 2.678a1 1 0 00.256 1.008c0 .019.002 0-.002.03-.03.281-.074.338-.086.362a1 1 0 00-.582.907c0 .121-.136.497-.363.81-.113.157-.24.3-.34.4-.1.101-.227.177-.11.11a1 1 0 00-.503.867v1.735a1 1 0 00.055.324c.274.8.901 1.301 1.484 1.63.583.33 1.177.55 1.693.801.517.252.942.524 1.233.864.087.101.09.326.16.447h-11.25c.07-.121.073-.346.16-.447.291-.34.716-.61 1.233-.862.516-.251 1.11-.473 1.693-.802.583-.33 1.21-.83 1.484-1.631a1 1 0 00.055-.324v-1.735a1 1 0 00-.508-.869c.1.057-.02-.016-.12-.113a3.308 3.308 0 01-.339-.389c-.226-.305-.367-.667-.367-.832a1 1 0 00-.58-.906c-.012-.025-.057-.081-.088-.363-.004-.04.004-.027.01-.04a1 1 0 00.25-.978c-.428-1.494-.33-2.682.144-3.428.402-.63 1.245-1.036 2.575-1.17zM6.91 33.01a1 1 0 00.182 0A1.98 1.98 0 019 35c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.086.838-1.943 1.91-1.99zm36 0a1 1 0 00.182 0A1.98 1.98 0 0145 35c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.086.838-1.943 1.91-1.99zM25 42c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2z"
  }));
};
SvgEdbDashboard.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1K = ["title", "titleId"];
var SvgEdbEfm = function SvgEdbEfm(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1K);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25 2a4.015 4.015 0 00-4 3.99L9.937 12.312A3.98 3.98 0 007 11c-2.197 0-4 1.803-4 4 0 1.85 1.284 3.406 3 3.855v12.29c-1.716.45-3 2.005-3 3.855 0 2.197 1.803 4 4 4a3.98 3.98 0 002.938-1.313L21 44.01A4.015 4.015 0 0025 48a4.015 4.015 0 004-3.99l11.063-6.322A3.98 3.98 0 0043 39c2.197 0 4-1.803 4-4 0-1.85-1.284-3.406-3-3.855v-12.29c1.716-.45 3-2.005 3-3.855 0-2.197-1.803-4-4-4a3.98 3.98 0 00-2.938 1.313L29 5.99A4.015 4.015 0 0025 2zm0 2c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2zm-3.451 3.98C22.242 9.18 23.525 10 25 10s2.758-.821 3.451-2.02l10.668 6.098c-.071.298-.119.604-.119.922 0 1.85 1.284 3.406 3 3.855v12.29c-1.716.45-3 2.005-3 3.855 0 .318.048.624.12.922L28.45 42.02C27.758 40.82 26.475 40 25 40s-2.758.821-3.451 2.02L10.88 35.922c.071-.298.119-.604.119-.922 0-1.85-1.284-3.406-3-3.855v-12.29c1.716-.45 3-2.005 3-3.855 0-.318-.048-.624-.12-.922L21.55 7.98zM7 13c1.116 0 2 .884 2 2a1.979 1.979 0 01-1.91 1.99 1 1 0 00-.182 0A1.98 1.98 0 015 15c0-1.116.884-2 2-2zm36 0c1.116 0 2 .884 2 2a1.979 1.979 0 01-1.91 1.99 1 1 0 00-.182 0A1.98 1.98 0 0141 15c0-1.116.884-2 2-2zM6.91 33.01a1 1 0 00.182 0A1.98 1.98 0 019 35c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.086.838-1.943 1.91-1.99zm36 0a1 1 0 00.182 0A1.98 1.98 0 0145 35c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.086.838-1.943 1.91-1.99zM25 42c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 14l-9 4v6c0 7.83 6.439 11.486 9 12 2.561-.514 9-4.17 9-12v-6l-9-4zm7 10c0 6.134-4.785 9.254-7 9.937-2.215-.683-7-3.803-7-9.937v-4.7l7-3.111 7 3.111V24z"
  }));
};
SvgEdbEfm.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1J = ["title", "titleId"];
var SvgEdbEpas = function SvgEdbEpas(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1J);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25 2a4.015 4.015 0 00-4 3.99L9.937 12.312A3.98 3.98 0 007 11c-2.197 0-4 1.803-4 4 0 1.85 1.284 3.406 3 3.855v12.29c-1.716.45-3 2.005-3 3.855 0 2.197 1.803 4 4 4a3.98 3.98 0 002.938-1.313L21 44.01A4.015 4.015 0 0025 48a4.015 4.015 0 004-3.99l11.063-6.322A3.98 3.98 0 0043 39c2.197 0 4-1.803 4-4 0-1.85-1.284-3.406-3-3.855v-12.29c1.716-.45 3-2.005 3-3.855 0-2.197-1.803-4-4-4a3.98 3.98 0 00-2.938 1.313L29 5.99A4.015 4.015 0 0025 2zm0 2c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2zm-3.451 3.98C22.242 9.18 23.525 10 25 10s2.758-.821 3.451-2.02l10.668 6.098c-.071.298-.119.604-.119.922 0 1.85 1.284 3.406 3 3.855v12.29c-1.716.45-3 2.005-3 3.855 0 .318.048.624.12.922L28.45 42.02C27.758 40.82 26.475 40 25 40s-2.758.821-3.451 2.02L10.88 35.922c.071-.298.119-.604.119-.922 0-1.85-1.284-3.406-3-3.855v-12.29c1.716-.45 3-2.005 3-3.855 0-.318-.048-.624-.12-.922L21.55 7.98zM7 13c1.116 0 2 .884 2 2a1.979 1.979 0 01-1.91 1.99 1 1 0 00-.182 0A1.98 1.98 0 015 15c0-1.116.884-2 2-2zm36 0c1.116 0 2 .884 2 2a1.979 1.979 0 01-1.91 1.99 1 1 0 00-.182 0A1.98 1.98 0 0141 15c0-1.116.884-2 2-2zM6.91 33.01a1 1 0 00.182 0A1.98 1.98 0 019 35c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.086.838-1.943 1.91-1.99zm36 0a1 1 0 00.182 0A1.98 1.98 0 0145 35c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.086.838-1.943 1.91-1.99zM25 42c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 14c-2.553 0-4.693.457-6.283 1.283C17.127 16.11 16 17.422 16 19v12c0 1.578 1.126 2.89 2.717 3.717C20.307 35.543 22.447 36 25 36c2.553 0 4.693-.457 6.283-1.283C32.873 33.89 34 32.578 34 31V19c0-1.578-1.126-2.89-2.717-3.717C29.693 14.457 27.553 14 25 14zm0 2c2.308 0 4.167.438 5.361 1.059C31.556 17.679 32 18.369 32 19c0 .632-.444 1.32-1.639 1.941C29.167 21.562 27.308 22 25 22s-4.167-.438-5.361-1.059C18.444 20.321 18 19.631 18 19c0-.632.444-1.32 1.639-1.941C20.833 16.438 22.692 16 25 16zm-7 6.283c.227.155.464.302.717.434C20.307 23.543 22.447 24 25 24c2.553 0 4.693-.457 6.283-1.283a6.93 6.93 0 00.717-.434V23c0 .632-.444 1.32-1.639 1.941C29.167 25.562 27.308 26 25 26s-4.167-.438-5.361-1.059C18.444 24.321 18 23.631 18 23v-.717zm0 4c.227.155.464.302.717.434C20.307 27.543 22.447 28 25 28c2.553 0 4.693-.457 6.283-1.283a6.93 6.93 0 00.717-.434V27c0 .632-.444 1.32-1.639 1.941C29.167 29.562 27.308 30 25 30s-4.167-.438-5.361-1.059C18.444 28.321 18 27.631 18 27v-.717zm0 4c.227.155.464.302.717.434C20.307 31.543 22.447 32 25 32c2.553 0 4.693-.457 6.283-1.283a6.93 6.93 0 00.717-.434V31c0 .632-.444 1.32-1.639 1.941C29.167 33.562 27.308 34 25 34s-4.167-.438-5.361-1.059C18.444 32.321 18 31.631 18 31v-.717z"
  }));
};
SvgEdbEpas.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1I = ["title", "titleId"];
var SvgEdbKubernetes = function SvgEdbKubernetes(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1I);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25 2a4.015 4.015 0 00-4 3.99L9.937 12.312A3.98 3.98 0 007 11c-2.197 0-4 1.803-4 4 0 1.85 1.284 3.406 3 3.855v12.29c-1.716.45-3 2.005-3 3.855 0 2.197 1.803 4 4 4a3.98 3.98 0 002.938-1.313L21 44.01A4.015 4.015 0 0025 48a4.015 4.015 0 004-3.99l11.063-6.322A3.98 3.98 0 0043 39c2.197 0 4-1.803 4-4 0-1.85-1.284-3.406-3-3.855v-12.29c1.716-.45 3-2.005 3-3.855 0-2.197-1.803-4-4-4a3.98 3.98 0 00-2.938 1.313L29 5.99A4.015 4.015 0 0025 2zm0 2c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2zm-3.451 3.98C22.242 9.18 23.525 10 25 10s2.758-.821 3.451-2.02l10.668 6.098c-.071.298-.119.604-.119.922 0 1.85 1.284 3.406 3 3.855v12.29c-1.716.45-3 2.005-3 3.855 0 .318.048.624.12.922L28.45 42.02C27.758 40.82 26.475 40 25 40s-2.758.821-3.451 2.02L10.88 35.922c.071-.298.119-.604.119-.922 0-1.85-1.284-3.406-3-3.855v-12.29c1.716-.45 3-2.005 3-3.855 0-.318-.048-.624-.12-.922L21.55 7.98zM7 13c1.116 0 2 .884 2 2a1.979 1.979 0 01-1.91 1.99 1 1 0 00-.182 0A1.98 1.98 0 015 15c0-1.116.884-2 2-2zm36 0c1.116 0 2 .884 2 2a1.979 1.979 0 01-1.91 1.99 1 1 0 00-.182 0A1.98 1.98 0 0141 15c0-1.116.884-2 2-2zM6.91 33.01a1 1 0 00.182 0A1.98 1.98 0 019 35c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.086.838-1.943 1.91-1.99zm36 0a1 1 0 00.182 0A1.98 1.98 0 0145 35c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.086.838-1.943 1.91-1.99zM25 42c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 13.5c-.27 0-.538.06-.786.18l-7.949 3.838c-.494.24-.854.691-.976 1.227l-1.964 8.628a1.81 1.81 0 00.348 1.526l5.502 6.918c.343.431.864.682 1.414.682h8.82c.55 0 1.072-.25 1.415-.682l5.503-6.917v-.001a1.809 1.809 0 00.348-1.526l-1.965-8.628v-.001a1.808 1.808 0 00-.976-1.226l-7.948-3.837-.001-.001A1.81 1.81 0 0025 13.5zm0 1.03a.78.78 0 01.338.076l7.949 3.838a.778.778 0 01.42.529l1.965 8.628a.778.778 0 01-.15.658l-5.503 6.919a.777.777 0 01-.61.293h-8.82a.775.775 0 01-.608-.293l-5.503-6.919a.78.78 0 01-.15-.658l1.965-8.627a.777.777 0 01.42-.53l7.948-3.838A.777.777 0 0125 14.53zm-.004 2.162a.56.56 0 00-.51.78c.118.277.158.554.19.832.01.144.015.283.01.421.016.14-.057.278-.16.417-.107.139-.117.278-.133.417a6.146 6.146 0 00-3.652 1.686l-.01-.005c-.117-.077-.23-.155-.41-.16-.17-.01-.324-.04-.422-.143a3.125 3.125 0 01-.313-.272 2.652 2.652 0 01-.53-.674.576.576 0 00-.34-.278.564.564 0 00-.693.385.555.555 0 00.385.689c.288.087.53.231.766.386.114.077.222.16.33.252.118.077.18.22.226.385.034.165.128.26.22.353a6.131 6.131 0 00-1.086 4.178.68.68 0 00-.327.2c-.113.128-.237.23-.376.24a2.755 2.755 0 01-.41.078c-.278.036-.56.057-.854-.005a.572.572 0 00-.432.098.558.558 0 10.648.91c.247-.174.509-.273.776-.36a3.62 3.62 0 01.407-.103c.134-.046.282-.005.442.062.132.068.25.063.365.05a6.192 6.192 0 002.735 3.473c-.045.124-.086.253-.047.415.031.17.036.33-.036.448a5.06 5.06 0 01-.185.374c-.144.237-.298.474-.524.68a.556.556 0 00.355.971.563.563 0 00.581-.54c.005-.303.087-.57.18-.837.046-.129.103-.258.165-.381.046-.134.169-.232.318-.314.148-.077.215-.185.282-.3a6.126 6.126 0 002.073.367c.74 0 1.447-.138 2.105-.379.07.12.142.232.29.312.15.087.273.18.319.314.062.129.113.257.16.386.092.267.169.534.18.837 0 .15.06.294.179.402.231.205.582.19.792-.036a.566.566 0 00-.036-.793c-.226-.2-.38-.442-.519-.684a4.951 4.951 0 01-.185-.37c-.072-.122-.067-.277-.03-.447.04-.175-.006-.303-.047-.437l-.004-.013a6.19 6.19 0 002.701-3.483h.017c.144.011.283.026.437-.061.154-.072.31-.114.443-.073.133.02.272.052.405.088.268.077.536.17.788.339a.571.571 0 00.432.077.556.556 0 00.426-.662.56.56 0 00-.668-.427c-.299.067-.576.056-.859.03a3.81 3.81 0 01-.412-.066c-.139-.01-.261-.103-.38-.226-.118-.14-.251-.175-.385-.216l-.009-.003a6.135 6.135 0 00-1.025-4.024c.097-.103.196-.2.232-.374.046-.165.107-.309.226-.386.103-.093.216-.175.33-.257.23-.154.472-.303.76-.386a.542.542 0 00.339-.283.55.55 0 00-.241-.75.552.552 0 00-.751.241 2.75 2.75 0 01-.525.674c-.102.097-.205.19-.313.278-.098.103-.252.133-.422.144-.18.005-.293.087-.411.164a6.153 6.153 0 00-3.733-1.758c-.015-.139-.025-.278-.133-.417-.103-.139-.176-.278-.16-.417-.005-.138 0-.277.011-.421.03-.278.071-.555.19-.833a.572.572 0 000-.442.563.563 0 00-.518-.337zm-.737 3.923l-.026.198c-.072.555-.123 1.116-.174 1.671-.031.293-.057.592-.078.885-.252-.18-.503-.37-.77-.54-.464-.314-.926-.628-1.405-.926l-.161-.1a5.11 5.11 0 012.614-1.188zm1.482 0a5.11 5.11 0 012.7 1.267l-.172.108c-.473.303-.93.617-1.393.93-.185.124-.365.253-.54.381a.214.214 0 01-.34-.16c-.015-.22-.035-.436-.055-.657-.052-.555-.103-1.116-.175-1.67l-.025-.199zm-5.07 2.31l.164.17c.391.407.787.798 1.188 1.194.17.17.34.33.514.489a.21.21 0 01-.082.36c-.252.076-.504.148-.756.23-.53.175-1.064.34-1.594.53l-.233.082c-.005-.095-.014-.187-.014-.283 0-1.023.301-1.972.814-2.772zm8.718.101c.474.779.752 1.69.752 2.671 0 .086-.009.17-.013.254l-.183-.058c-.535-.175-1.069-.325-1.609-.479-.35-.103-.7-.195-1.049-.282.262-.252.535-.499.787-.756.396-.396.792-.792 1.177-1.203l.138-.147zM24.68 24.67h.627a.3.3 0 01.242.119l.4.504a.312.312 0 01.063.25l-.145.623a.316.316 0 01-.164.221l-.576.267a.274.274 0 01-.267 0l-.576-.267c-.083-.046-.155-.123-.165-.22l-.144-.623a.312.312 0 01.063-.251l.4-.504a.3.3 0 01.242-.119zm-1.856 2.452a.209.209 0 01.227.283c-.098.258-.191.51-.279.767-.19.53-.375 1.054-.55 1.588l-.07.221a5.134 5.134 0 01-1.992-2.557l.273-.024c.56-.051 1.11-.118 1.67-.185.242-.026.479-.062.72-.093zm4.442.073c.242.025.478.051.72.072.56.051 1.116.102 1.676.138l.179.01a5.135 5.135 0 01-1.951 2.537l-.059-.187c-.17-.534-.354-1.064-.534-1.588a27.96 27.96 0 00-.252-.7.21.21 0 01.221-.282zm-2.23 1.014c.074 0 .147.037.189.111.113.216.232.427.355.638.278.483.554.972.853 1.445l.121.197a5.158 5.158 0 01-3.067.014l.129-.206c.298-.473.58-.957.863-1.44.129-.21.253-.427.371-.648a.21.21 0 01.187-.111z"
  }));
};
SvgEdbKubernetes.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1H = ["title", "titleId"];
var SvgEdbMigrationPortal = function SvgEdbMigrationPortal(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1H);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25 2a4.015 4.015 0 00-4 3.99L9.937 12.312A3.98 3.98 0 007 11c-2.197 0-4 1.803-4 4 0 1.85 1.284 3.406 3 3.855v12.29c-1.716.45-3 2.005-3 3.855 0 2.197 1.803 4 4 4a3.98 3.98 0 002.938-1.313L21 44.01A4.015 4.015 0 0025 48a4.015 4.015 0 004-3.99l11.063-6.322A3.98 3.98 0 0043 39c2.197 0 4-1.803 4-4 0-1.85-1.284-3.406-3-3.855v-12.29c1.716-.45 3-2.005 3-3.855 0-2.197-1.803-4-4-4a3.98 3.98 0 00-2.938 1.313L29 5.99A4.015 4.015 0 0025 2zm0 2c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2zm-3.451 3.98C22.242 9.18 23.525 10 25 10s2.758-.821 3.451-2.02l10.668 6.098c-.071.298-.119.604-.119.922 0 1.85 1.284 3.406 3 3.855v12.29c-1.716.45-3 2.005-3 3.855 0 .318.048.624.12.922L28.45 42.02C27.758 40.82 26.475 40 25 40s-2.758.821-3.451 2.02L10.88 35.922c.071-.298.119-.604.119-.922 0-1.85-1.284-3.406-3-3.855v-12.29c1.716-.45 3-2.005 3-3.855 0-.318-.048-.624-.12-.922L21.55 7.98zM7 13c1.116 0 2 .884 2 2a1.979 1.979 0 01-1.91 1.99 1 1 0 00-.182 0A1.98 1.98 0 015 15c0-1.116.884-2 2-2zm36 0c1.116 0 2 .884 2 2a1.979 1.979 0 01-1.91 1.99 1 1 0 00-.182 0A1.98 1.98 0 0141 15c0-1.116.884-2 2-2zM6.91 33.01a1 1 0 00.182 0A1.98 1.98 0 019 35c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.086.838-1.943 1.91-1.99zm36 0a1 1 0 00.182 0A1.98 1.98 0 0145 35c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.086.838-1.943 1.91-1.99zM25 42c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6 14l-4.4 4.4h3.3V25c0 .622-.478 1.1-1.1 1.1h-7.7v2.2h7.7c1.81 0 3.3-1.49 3.3-3.3v-6.6H36L31.6 14zm-11 7.7c-1.81 0-3.3 1.49-3.3 3.3v6.6H14l4.4 4.4 4.4-4.4h-3.3V25c0-.622.478-1.1 1.1-1.1h7.7v-2.2h-7.7z"
  }));
};
SvgEdbMigrationPortal.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1G = ["title", "titleId"];
var SvgEdbMigrationToolkit = function SvgEdbMigrationToolkit(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1G);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25 2a4.015 4.015 0 00-4 3.99L9.937 12.312A3.98 3.98 0 007 11c-2.197 0-4 1.803-4 4 0 1.85 1.284 3.406 3 3.855v12.29c-1.716.45-3 2.005-3 3.855 0 2.197 1.803 4 4 4a3.98 3.98 0 002.938-1.313L21 44.01A4.015 4.015 0 0025 48a4.015 4.015 0 004-3.99l11.063-6.322A3.98 3.98 0 0043 39c2.197 0 4-1.803 4-4 0-1.85-1.284-3.406-3-3.855v-12.29c1.716-.45 3-2.005 3-3.855 0-2.197-1.803-4-4-4a3.98 3.98 0 00-2.938 1.313L29 5.99A4.015 4.015 0 0025 2zm0 2c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2zm-3.451 3.98C22.242 9.18 23.525 10 25 10s2.758-.821 3.451-2.02l10.668 6.098c-.071.298-.119.604-.119.922 0 1.85 1.284 3.406 3 3.855v12.29c-1.716.45-3 2.005-3 3.855 0 .318.048.624.12.922L28.45 42.02C27.758 40.82 26.475 40 25 40s-2.758.821-3.451 2.02L10.88 35.922c.071-.298.119-.604.119-.922 0-1.85-1.284-3.406-3-3.855v-12.29c1.716-.45 3-2.005 3-3.855 0-.318-.048-.624-.12-.922L21.55 7.98zM7 13c1.116 0 2 .884 2 2a1.979 1.979 0 01-1.91 1.99 1 1 0 00-.182 0A1.98 1.98 0 015 15c0-1.116.884-2 2-2zm36 0c1.116 0 2 .884 2 2a1.979 1.979 0 01-1.91 1.99 1 1 0 00-.182 0A1.98 1.98 0 0141 15c0-1.116.884-2 2-2zM6.91 33.01a1 1 0 00.182 0A1.98 1.98 0 019 35c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.086.838-1.943 1.91-1.99zm36 0a1 1 0 00.182 0A1.98 1.98 0 0145 35c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.086.838-1.943 1.91-1.99zM25 42c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.283 14.208l-.467.44-1.167 1.168-.441.467.337.545 1.738 2.905.234.416h2.438l3.32 3.294c-2.966 2.98-6.741 6.768-6.874 6.901-1.3 1.3-1.304 3.431.026 4.67 1.297 1.281 3.411 1.314 4.644 0l.026-.026 5.11-5.137 5.137 5.163.078.052c1.304 1.23 3.376 1.245 4.592-.052v-.026h.026c1.271-1.3 1.284-3.415-.026-4.644l-.026-.026-4.332-4.306c2.915-.273 5.198-2.734 5.24-5.708h.026c.003-.016 0-.035 0-.052v-.026c.081-.96-.126-1.877-.622-2.672l-.571-.882-3.866 3.866-1.167-1.22 3.943-3.943-1.141-.467a5.837 5.837 0 00-2.31-.493c-3.19 0-5.81 2.62-5.81 5.811 0 .347.074.649.13.96-.364.364-.637.662-1.065 1.09L20.15 18.98v-2.464l-.416-.234-2.905-1.738-.545-.337zm13.906 1.867c.116 0 .197.069.311.078l-3.14 3.14.572.596 2.335 2.413.57.597 3.295-3.295c.016.191.152.33.13.545v.077a4.159 4.159 0 01-4.151 4.151c-.305 0-.675-.071-1.09-.155l-.44-.078-.312.311-9.366 9.392h-.026v.026c-.59.645-1.621.661-2.309-.026v-.026h-.026c-.645-.59-.661-1.622.026-2.31.315-.314 6.408-6.46 9.392-9.443l.337-.337-.13-.467a5.075 5.075 0 01-.13-1.038 4.159 4.159 0 014.152-4.15zm-13.647.208l1.946 1.193v.83l-.181.182h-.83l-1.194-1.946.26-.259zm12.142 10.092l5.163 5.137v.026h.026c.645.59.661 1.621-.026 2.309h-.026v.026c-.59.645-1.622.661-2.31-.026l-5.136-5.163 2.309-2.309z"
  }));
};
SvgEdbMigrationToolkit.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1F = ["title", "titleId"];
var SvgEdbPem = function SvgEdbPem(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1F);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25 2a4.015 4.015 0 00-4 3.99L9.937 12.312A3.98 3.98 0 007 11c-2.197 0-4 1.803-4 4 0 1.85 1.284 3.406 3 3.855v12.29c-1.716.45-3 2.005-3 3.855 0 2.197 1.803 4 4 4a3.98 3.98 0 002.938-1.313L21 44.01A4.015 4.015 0 0025 48a4.015 4.015 0 004-3.99l11.063-6.322A3.98 3.98 0 0043 39c2.197 0 4-1.803 4-4 0-1.85-1.284-3.406-3-3.855v-12.29c1.716-.45 3-2.005 3-3.855 0-2.197-1.803-4-4-4a3.98 3.98 0 00-2.938 1.313L29 5.99A4.015 4.015 0 0025 2zm0 2c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2zm-3.451 3.98C22.242 9.18 23.525 10 25 10s2.758-.821 3.451-2.02l10.668 6.098c-.071.298-.119.604-.119.922 0 1.85 1.284 3.406 3 3.855v12.29c-1.716.45-3 2.005-3 3.855 0 .318.048.624.12.922L28.45 42.02C27.758 40.82 26.475 40 25 40s-2.758.821-3.451 2.02L10.88 35.922c.071-.298.119-.604.119-.922 0-1.85-1.284-3.406-3-3.855v-12.29c1.716-.45 3-2.005 3-3.855 0-.318-.048-.624-.12-.922L21.55 7.98zM7 13c1.116 0 2 .884 2 2a1.979 1.979 0 01-1.91 1.99 1 1 0 00-.182 0A1.98 1.98 0 015 15c0-1.116.884-2 2-2zm36 0c1.116 0 2 .884 2 2a1.979 1.979 0 01-1.91 1.99 1 1 0 00-.182 0A1.98 1.98 0 0141 15c0-1.116.884-2 2-2zM6.91 33.01a1 1 0 00.182 0A1.98 1.98 0 019 35c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.086.838-1.943 1.91-1.99zm36 0a1 1 0 00.182 0A1.98 1.98 0 0145 35c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.086.838-1.943 1.91-1.99zM25 42c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.54 14.93c-.888 0-1.61.722-1.61 1.61v11.28c0 .889.722 1.611 1.61 1.611h2.015v-2.014h-1.611V16.944h12.084v3.222h2.014v-3.625c0-.89-.722-1.612-1.611-1.612h-12.89zm4.029 5.639c-.89 0-1.611.722-1.611 1.611v11.28c0 .888.722 1.61 1.611 1.61h12.89c.89 0 1.612-.722 1.612-1.61V22.18c0-.889-.723-1.611-1.612-1.611H20.57zm.403 2.014h12.084v10.473H20.972V22.583z"
  }));
};
SvgEdbPem.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1E = ["title", "titleId"];
var SvgEdbReplicate = function SvgEdbReplicate(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1E);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25 2a4.015 4.015 0 014 3.99l11.063 6.322A3.98 3.98 0 0143 11c2.197 0 4 1.803 4 4 0 1.85-1.284 3.406-3 3.855v12.29c1.716.45 3 2.005 3 3.855 0 2.197-1.803 4-4 4a3.98 3.98 0 01-2.938-1.313L29 44.01A4.015 4.015 0 0125 48a4.015 4.015 0 01-4-3.99L9.937 37.688A3.98 3.98 0 017 39c-2.197 0-4-1.803-4-4 0-1.85 1.284-3.406 3-3.855v-12.29C4.284 18.405 3 16.85 3 15c0-2.197 1.803-4 4-4a3.98 3.98 0 012.938 1.313L21 5.99A4.015 4.015 0 0125 2zm0 40c-1.116 0-2 .884-2 2s.884 2 2 2 2-.884 2-2-.884-2-2-2zm-7.289-11.72l-6.824 3.783c.074.3.113.614.113.937 0 .318-.048.624-.12.922L21.55 42.02a4.043 4.043 0 012.45-1.89L24 33.945a8.993 8.993 0 01-6.289-3.664zm14.55.038a8.993 8.993 0 01-6.26 3.627L26 40.129a4.043 4.043 0 012.451 1.89l10.668-6.097A3.935 3.935 0 0139 35c0-.306.035-.604.101-.89l-6.84-3.792zM7.092 33.01a1 1 0 01-.18 0A1.979 1.979 0 005 35c0 1.116.884 2 2 2s2-.884 2-2a1.98 1.98 0 00-1.908-1.99zm36 0a1 1 0 01-.18 0A1.979 1.979 0 0041 35c0 1.116.884 2 2 2s2-.884 2-2a1.98 1.98 0 00-1.908-1.99zm-2.965-15.25l-6.816 3.777A8.973 8.973 0 0134 25a8.97 8.97 0 01-.741 3.583l6.774 3.756A4.048 4.048 0 0142 31.145v-12.29a4.046 4.046 0 01-1.874-1.095zm-30.406.15c-.48.445-1.069.775-1.72.945v12.29c.752.197 1.42.606 1.935 1.159l6.789-3.763A8.97 8.97 0 0116 25c0-1.154.217-2.257.613-3.27zM25 18a7 7 0 100 14 7 7 0 000-14zM21.549 7.98L10.88 14.078c.071.298.119.604.119.922 0 .427-.068.838-.195 1.224l6.738 3.736A8.997 8.997 0 0124 16.055V9.87a4.043 4.043 0 01-2.451-1.89zm6.902 0A4.043 4.043 0 0126 9.87v6.185a8.994 8.994 0 016.339 3.734l6.795-3.767A3.93 3.93 0 0139 15c0-.318.048-.624.12-.922zM7 13c-1.116 0-2 .884-2 2a1.98 1.98 0 001.908 1.99 1 1 0 01.182 0A1.979 1.979 0 009 15c0-1.116-.884-2-2-2zm36 0c-1.116 0-2 .884-2 2a1.98 1.98 0 001.908 1.99 1 1 0 01.182 0A1.979 1.979 0 0045 15c0-1.116-.884-2-2-2zM25 4c-1.116 0-2 .884-2 2s.884 2 2 2 2-.884 2-2-.884-2-2-2z"
  }));
};
SvgEdbReplicate.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1D = ["title", "titleId"];
var SvgEdbReplication = function SvgEdbReplication(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1D);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25 2a4.015 4.015 0 00-4 3.99L9.937 12.312A3.98 3.98 0 007 11c-2.197 0-4 1.803-4 4 0 1.85 1.284 3.406 3 3.855v12.29c-1.716.45-3 2.005-3 3.855 0 2.197 1.803 4 4 4a3.98 3.98 0 002.938-1.313L21 44.01A4.015 4.015 0 0025 48a4.015 4.015 0 004-3.99l11.063-6.322A3.98 3.98 0 0043 39c2.197 0 4-1.803 4-4 0-1.85-1.284-3.406-3-3.855v-12.29c1.716-.45 3-2.005 3-3.855 0-2.197-1.803-4-4-4a3.98 3.98 0 00-2.938 1.313L29 5.99A4.015 4.015 0 0025 2zm0 2c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2zm-3.451 3.98C22.242 9.18 23.525 10 25 10s2.758-.821 3.451-2.02l10.668 6.098c-.071.298-.119.604-.119.922 0 1.85 1.284 3.406 3 3.855v12.29c-1.716.45-3 2.005-3 3.855 0 .318.048.624.12.922L28.45 42.02C27.758 40.82 26.475 40 25 40s-2.758.821-3.451 2.02L10.88 35.922c.071-.298.119-.604.119-.922 0-1.85-1.284-3.406-3-3.855v-12.29c1.716-.45 3-2.005 3-3.855 0-.318-.048-.624-.12-.922L21.55 7.98zM7 13c1.116 0 2 .884 2 2a1.979 1.979 0 01-1.91 1.99 1 1 0 00-.182 0A1.98 1.98 0 015 15c0-1.116.884-2 2-2zm36 0c1.116 0 2 .884 2 2a1.979 1.979 0 01-1.91 1.99 1 1 0 00-.182 0A1.98 1.98 0 0141 15c0-1.116.884-2 2-2zM6.91 33.01a1 1 0 00.182 0A1.98 1.98 0 019 35c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.086.838-1.943 1.91-1.99zm36 0a1 1 0 00.182 0A1.98 1.98 0 0145 35c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.086.838-1.943 1.91-1.99zM25 42c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.429 19.414l-5.707-5.707a1 1 0 10-1.415 1.414l3.293 3.293H15.015a1 1 0 100 2H32.6l-3.293 3.293a1 1 0 101.415 1.414l5.707-5.707zm-.4 11.984a1 1 0 00-1.014-.984H17.429l3.293-3.293a1 1 0 10-1.415-1.414L13.6 31.414l5.707 5.707a1 1 0 101.415-1.414l-3.293-3.293h17.586a1 1 0 001.013-1.016z"
  }));
};
SvgEdbReplication.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1C = ["title", "titleId"];
var SvgEdbSymbol = function SvgEdbSymbol(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1C);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 180 180",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 90,
    cy: 90,
    r: 90
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.25 72.303c0-8.67-7.257-14.983-16.206-14.095l-13.612 1.35c-1.435.14-2.597 1.382-2.597 2.773V112.104c0 1.388 1.162 2.401 2.597 2.257l13.612-1.349c8.95-.885 16.206-8.633 16.206-17.305 0-4.65-2.089-8.62-5.406-11.167 3.317-3.203 5.406-7.588 5.406-12.237M63.568 59.556l-13.609-1.348c-8.952-.887-16.209 5.423-16.209 14.093 0 4.651 2.089 9.035 5.406 12.238-3.317 2.547-5.406 6.517-5.406 11.167 0 8.671 7.257 16.42 16.209 17.308l13.609 1.347c1.435.144 2.597-.869 2.597-2.258V62.33c0-1.39-1.162-2.633-2.597-2.774M89.996 73.125H76.39c-1.436 0-2.598 1.115-2.598 2.49V112.943c0 1.455 1.045 2.915 2.554 2.915H90c-.143 2.716-4.03 4.767-13.147 5.738l-1.034.089c-.615.062-2.026 0-2.026 2.553v.678c0 1.376 1.127 2.585 2.562 2.585H89.96c8.952 0 16.248-7.054 16.248-15.641V88.675c0-8.588-7.257-15.55-16.212-15.55",
    fill: "#FFF"
  })));
};
SvgEdbSymbol.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1B = ["title", "titleId"];
var SvgEdbTransporter = function SvgEdbTransporter(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1B);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 800 800",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, ".st1{stroke:currentColor;fill:none;stroke-width:17.619;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}"), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M754.2 450.2c0 25.8-72.8 47-162.1 47"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 592.1,
    cy: 249.9,
    rx: 162.1,
    ry: 47
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M754.2 350.4c0 25.8-72.8 47-162.1 47M754.2 433.2V249.9M430 550.1c0 25.8 72.8 47 162.1 47 15.9 0 31.1-.6 45.8-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M754.2 249.9V550c0 25.8-72.8 47-162.1 47-15.9 0-31.1-.6-45.8-1.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M754.2 450.2c0 25.8-72.8 47-162.1 47"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 592.1,
    cy: 249.9,
    rx: 162.1,
    ry: 47
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M754.2 350.4c0 25.8-72.8 47-162.1 47M754.2 433.2V249.9M430 550.1c0 25.8 72.8 47 162.1 47 15.9 0 31.1-.6 45.8-1.8M430 249.9v34.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M754.2 249.9V550c0 25.8-72.8 47-162.1 47-15.9 0-31.1-.6-45.8-1.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.9 497.2c-89.3 0-162.1-21.1-162.1-47"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 207.9,
    cy: 249.9,
    rx: 162.1,
    ry: 47
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.9 397.4c-89.3 0-162.1-21.1-162.1-47M95.7 326.9c0 4.7-3.5 8.2-8.2 8.2s-8.2-3.5-8.2-8.2c0-4.7 3.5-8.2 8.2-8.2s8.2 3.5 8.2 8.2zM95.7 426.1c0 4.7-3.5 8.2-8.2 8.2s-8.2-3.5-8.2-8.2c0-4.7 3.5-8.2 8.2-8.2s8.2 3.5 8.2 8.2zM95.7 525.4c0 4.7-3.5 8.2-8.2 8.2s-8.2-3.5-8.2-8.2 3.5-8.2 8.2-8.2 8.2 3.5 8.2 8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.8 249.9V550c0 25.8 72.8 47 162.1 47 15.9 0 31.1-.6 45.8-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370 550.1c0 25.8-72.8 47-162.1 47-15.9 0-31.1-.6-45.8-1.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.7 497.1c-2.9 0-5.8.1-8.8.1-89.3 0-162.1-21.1-162.1-47"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 207.9,
    cy: 249.9,
    rx: 162.1,
    ry: 47
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.4 397.2c-4.8.1-9.6.2-14.5.2-89.3 0-162.1-21.1-162.1-47M95.7 326.9c0 4.7-3.5 8.2-8.2 8.2s-8.2-3.5-8.2-8.2c0-4.7 3.5-8.2 8.2-8.2s8.2 3.5 8.2 8.2zM95.7 426.1c0 4.7-3.5 8.2-8.2 8.2s-8.2-3.5-8.2-8.2c0-4.7 3.5-8.2 8.2-8.2s8.2 3.5 8.2 8.2zM95.7 525.4c0 4.7-3.5 8.2-8.2 8.2s-8.2-3.5-8.2-8.2 3.5-8.2 8.2-8.2 8.2 3.5 8.2 8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.8 249.9V550c0 25.8 72.8 47 162.1 47 15.9 0 31.1-.6 45.8-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370 550.1c0 25.8-72.8 47-162.1 47-15.9 0-31.1-.6-45.8-1.8M370 249.9v30.9"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M562.6 416.2h0c0 1.8-1.2 3.5-2.3 4.7L423.8 522.2c-1.8 1.2-4.1 1.8-6.4.6-1.8-1.2-3.5-2.9-3.5-5.3l.6-40.4-130.7-1.2c-3.5 0-5.9-2.9-5.9-5.9h0l1.2-112.4c0-1.8.6-2.9 1.8-4.1 1.2-1.2 2.9-1.8 4.1-1.8l130.7 1.2.6-40.4c0-2.3 1.2-4.1 3.5-5.3 2.3-1.2 4.7-.6 6.4.6L560.3 412c1.7.7 2.3 2.4 2.3 4.2z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 17.564,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })));
};
SvgEdbTransporter.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1A = ["title", "titleId"];
var SvgEllipsis = function SvgEllipsis(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1A);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9 19c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm16 0c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm16 0c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6z"
  }));
};
SvgEllipsis.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1z = ["title", "titleId"];
var SvgEnergy = function SvgEnergy(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1z);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1a.5.5 0 00-.469.326L6.154 12.47A1 1 0 006 13a1 1 0 001 1h5v8.5a.5.5 0 00.5.5.5.5 0 00.445-.271l5.92-11.227-.002-.002A1 1 0 0019 11a1 1 0 00-1-1h-5V1.5a.5.5 0 00-.5-.5z"
  }));
};
SvgEnergy.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1y = ["title", "titleId"];
var SvgEnterprise = function SvgEnterprise(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1y);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17 2a1 1 0 00-1 1v1.455L11.146 3H10c-1.093 0-2 .907-2 2v10h2V5h.854L20 7.744V25h-6v-6a2 2 0 00-2-2H6v-2a1 1 0 00-2 0v12h22V11a2 2 0 00-2-2h-2V3a1 1 0 00-2 0v2.656l-2-.6V3a1 1 0 00-1-1zm-5 7v2h2V9h-2zm4 0v2h2V9h-2zm6 2h2v2h-2v-2zm-10 2v2h2v-2h-2zm4 0v2h2v-2h-2zm6 2h2v2h-2v-2zm-6 2v2h2v-2h-2zM6 19h2v2H6v-2zm4 0h2v2h-2v-2zm12 0h2v2h-2v-2zm-6 2v2h2v-2h-2zM6 23h2v2H6v-2zm4 0h2v2h-2v-2zm12 0h2v2h-2v-2z"
  }));
};
SvgEnterprise.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1x = ["title", "titleId"];
var SvgEvent = function SvgEvent(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1x);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 4a2 2 0 00-2 2v18a2 2 0 002 2h18a2 2 0 002-2V6a2 2 0 00-2-2H6zm0 2h18v4H6V6zm5 7a1 1 0 110 2 1 1 0 010-2zm4 0h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4a1 1 0 011-1zm8 0a1 1 0 110 2 1 1 0 010-2zm-7 2v2h2v-2h-2zm-9 2a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm12 0a1 1 0 110 2 1 1 0 010-2zM7 21a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2z"
  }));
};
SvgEvent.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1w = ["title", "titleId"];
var SvgExport = function SvgExport(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1w);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 3c-1.103 0-2 .897-2 2v20c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-9h-8a1 1 0 010-2h8V5c0-1.103-.897-2-2-2H5zm16 11v2h5.586l-2.293 2.293a1 1 0 101.414 1.414l4-4a1 1 0 000-1.414l-4-4a1 1 0 00-.717-.303 1 1 0 00-.697 1.717L26.586 14H21z"
  }));
};
SvgExport.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1v = ["title", "titleId"];
var SvgExtension = function SvgExtension(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1v);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0A2.5 2.5 0 009 2.5V4H5a2 2 0 00-2 2v3a1 1 0 001 1h.357c1.308 0 2.498.941 2.63 2.242A2.5 2.5 0 014.5 15H4a1 1 0 00-1 1v3a2 2 0 002 2h3a1 1 0 001-1v-.357c0-1.308.941-2.498 2.242-2.63A2.5 2.5 0 0114 19.5v.5a1 1 0 001 1h3a2 2 0 002-2v-4h1.5a2.5 2.5 0 100-5H20V6a2 2 0 00-2-2h-4V2.5A2.5 2.5 0 0011.5 0z"
  }));
};
SvgExtension.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1u = ["title", "titleId"];
var SvgExternalLink = function SvgExternalLink(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1u);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25.98 2.99a1 1 0 00-.11.01H20a1 1 0 100 2h3.586L13.293 15.293a1 1 0 101.414 1.414L25 6.414V10a1 1 0 102 0V4.127a1 1 0 00-1.02-1.137zM6 7c-1.093 0-2 .907-2 2v15c0 1.093.907 2 2 2h15c1.093 0 2-.907 2-2V11.422l-2 2V24H6V9h10.578l2-2H6z"
  }));
};
SvgExternalLink.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1t = ["title", "titleId"];
var SvgFile = function SvgFile(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1t);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24.707 8.793l-6.5-6.5A1 1 0 0017.5 2H7a2 2 0 00-2 2v22a2 2 0 002 2h16a2 2 0 002-2V9.5a1 1 0 00-.293-.707zM18 10a1 1 0 01-1-1V3.904L23.096 10H18z"
  }));
};
SvgFile.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1s = ["title", "titleId"];
var SvgGlobe = function SvgGlobe(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1s);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 3C8.384 3 3 8.384 3 15s5.384 12 12 12 12-5.384 12-12S21.616 3 15 3zm0 2c.393 0 .8.163 1.266.596.465.433.946 1.13 1.359 2.039.307.674.557 1.492.773 2.365h-6.796c.216-.873.466-1.69.773-2.365.413-.908.894-1.606 1.36-2.04C14.2 5.164 14.606 5 15 5zm-3.912.793c-.188.32-.37.655-.533 1.016-.428.94-.771 2.02-1.03 3.191H6.344a9.998 9.998 0 014.744-4.207zm7.824 0A9.998 9.998 0 0123.656 10h-3.181c-.259-1.172-.602-2.25-1.03-3.191a10.972 10.972 0 00-.533-1.016zM5.457 12h3.729C9.068 12.96 9 13.962 9 15s.068 2.04.186 3H5.457A10.037 10.037 0 015 15c0-1.046.161-2.053.457-3zm5.766 0h7.554c.13.954.223 1.947.223 3s-.092 2.046-.223 3h-7.554A21.977 21.977 0 0111 15c0-1.053.092-2.046.223-3zm9.591 0h3.729c.296.947.457 1.954.457 3s-.161 2.053-.457 3h-3.729c.118-.96.186-1.962.186-3s-.068-2.04-.186-3zm-14.47 8h3.181c.259 1.172.602 2.25 1.03 3.191.164.361.345.695.533 1.016A9.998 9.998 0 016.344 20zm5.258 0h6.796c-.216.873-.466 1.69-.773 2.365-.413.908-.894 1.606-1.36 2.04-.465.432-.872.595-1.265.595-.393 0-.8-.163-1.266-.596-.465-.433-.946-1.13-1.359-2.039-.307-.674-.557-1.492-.773-2.365zm8.873 0h3.181a9.998 9.998 0 01-4.744 4.207c.188-.32.37-.655.533-1.016.428-.94.771-2.02 1.03-3.191z"
  }));
};
SvgGlobe.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1r = ["title", "titleId"];
var SvgGovernment = function SvgGovernment(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1r);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 3a1 1 0 00-.332.059v-.002l-.023.01a1 1 0 00-.06.023l-9.64 4.015v.002A1.5 1.5 0 004 8.5 1.5 1.5 0 005.5 10h19A1.5 1.5 0 0026 8.5a1.5 1.5 0 00-.945-1.393v-.002l-.012-.003-9.647-4.018-.033-.016a1 1 0 00-.013-.004l-.018-.007v.002A1 1 0 0015 3zm0 3a1 1 0 110 2 1 1 0 010-2zm-9 6v8H5a1 1 0 100 2h20a1 1 0 100-2h-1v-8h-2v8h-2v-8h-2v8h-2v-8h-2v8h-2v-8h-2v8H8v-8H6zM3 24a1 1 0 100 2h24a1 1 0 100-2H3z"
  }));
};
SvgGovernment.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1q = ["title", "titleId"];
var SvgGui = function SvgGui(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1q);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 4a2 2 0 00-2 2v19a1 1 0 001 1h22a1 1 0 001-1V6a2 2 0 00-2-2H5zm0 5h20v15H5V9zm3 3a1 1 0 100 2h4a1 1 0 100-2H8zm8 0a1 1 0 00-1 1v8a1 1 0 001 1h6a1 1 0 001-1v-8a1 1 0 00-1-1h-6zm-8 4a1 1 0 100 2h4a1 1 0 100-2H8zm0 4a1 1 0 100 2h4a1 1 0 100-2H8z"
  }));
};
SvgGui.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1p = ["title", "titleId"];
var SvgHamburger = function SvgHamburger(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1p);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3 5a1 1 0 100 2h18a1 1 0 100-2H3zm0 6a1 1 0 100 2h18a1 1 0 100-2H3zm0 6a1 1 0 100 2h18a1 1 0 100-2H3z"
  }));
};
SvgHamburger.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1o = ["title", "titleId"];
var SvgHandshake = function SvgHandshake(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1o);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2 5l.016 12h1.59l8.789 9.19A2 2 0 0014 27a2 2 0 002-2 2 2 0 00-.023-.283A2 2 0 0017 25a2 2 0 002-2 2 2 0 00-.023-.283A2 2 0 0020 23a2 2 0 002-2 2 2 0 00-.023-.283A2 2 0 0023 21a2 2 0 002-2 2 2 0 00-.576-1.404l-.026-.024a2 2 0 00-.132-.119l-5.909-5.33-5.062.803C11.894 13.148 8 12.682 8 8c0-1.458 1.075-1.781 1.758-2.031A286.63 286.63 0 0112.5 5H2zm17 0a2 2 0 00-.52.068 2 2 0 00-.001 0l-.008.002a2 2 0 00-.006.002 2 2 0 00-.21.073L10 8v.5a2.5 2.5 0 002.5 2.5c.084 0 .163-.017.244-.025l.01.011.207-.033.059-.01L19 9.996s5.251 4.698 6.168 5.615c.88.88 1.75 1.544 1.818 3.389H29V7l-4 1-4.99-2.725a2 2 0 00-.108-.058l-.047-.026h-.007A2 2 0 0019 5z"
  }));
};
SvgHandshake.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1n = ["title", "titleId"];
var SvgHardToFind = function SvgHardToFind(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1n);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24 4H6a2 2 0 00-2 2v8h3c1.103 0 2 .897 2 2v5h3V9c0-1.103.897-2 2-2h3c1.103 0 2 .897 2 2v5h3v-2l3 3-3 3v-2h-3c-1.103 0-2-.897-2-2V9h-3v12c0 1.103-.897 2-2 2H9c-1.103 0-2-.897-2-2v-5H4v8a2 2 0 002 2h18a2 2 0 002-2V6a2 2 0 00-2-2z"
  }));
};
SvgHardToFind.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1m = ["title", "titleId"];
var SvgHelp = function SvgHelp(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1m);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1A6.51 6.51 0 001 7.5 6.51 6.51 0 007.5 14 6.51 6.51 0 0014 7.5 6.51 6.51 0 007.5 1zm0 1C10.543 2 13 4.457 13 7.5S10.543 13 7.5 13A5.493 5.493 0 012 7.5C2 4.457 4.457 2 7.5 2zm.059 2c-1.211.07-2.2 1.086-2.2 2.32h1c0-.812.704-1.449 1.563-1.3.613.105 1.098.707 1.078 1.34-.016.554-.34.906-.816 1.117-.297.132-.579.257-.817.507S7 8.605 7 9h1c0-.227.031-.262.094-.328.058-.063.222-.16.492-.281.746-.325 1.387-1.04 1.414-2 .035-1.137-.781-2.164-1.91-2.36-.18-.027-.36-.039-.531-.031zM7 10v1h1v-1z"
  }));
};
SvgHelp.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1l = ["title", "titleId"];
var SvgHighAvailability = function SvgHighAvailability(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1l);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 3.25a.743.743 0 00-.53.22l-2.25 2.25A.748.748 0 0012.75 7H14v3a1 1 0 102 0V7h1.25a.748.748 0 00.53-1.28l-2.25-2.25a.743.743 0 00-.53-.22zm8 5a.743.743 0 00-.53.22l-2.25 2.25a.748.748 0 00.53 1.28H22v2a1 1 0 102 0v-2h1.25a.748.748 0 00.53-1.28l-2.25-2.25a.743.743 0 00-.53-.22zm-16 2a.743.743 0 00-.53.22l-2.25 2.25A.748.748 0 004.75 14H6v3a1 1 0 102 0v-3h1.25a.748.748 0 00.53-1.28l-2.25-2.25a.743.743 0 00-.53-.22zM13 13a1 1 0 00-1 1v11a1 1 0 001 1h4a1 1 0 001-1V14a1 1 0 00-1-1h-4zm8 4a1 1 0 00-1 1v7a1 1 0 001 1h4a1 1 0 001-1v-7a1 1 0 00-1-1h-4zM5 20a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1v-4a1 1 0 00-1-1H5z"
  }));
};
SvgHighAvailability.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1k = ["title", "titleId"];
var SvgHorizontalNameTag = function SvgHorizontalNameTag(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1k);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14 2a2 2 0 00-2 2v2h6V4a2 2 0 00-2-2h-2zm4 4v1a2 2 0 01-2 2h-2a2 2 0 01-2-2V6H4a2 2 0 00-2 2v16a2 2 0 002 2h22a2 2 0 002-2V8a2 2 0 00-2-2h-8zm-8 5c.954 0 1.25.678 1.25.678.853 0 1.25.933 1.25 2.029 0 .547-.22 1-.22 1 .087.055.235.23.199.541-.068.579-.3.726-.448.738-.056.54-.591 1.232-.779 1.332v.905c.374 1.217 2.2.62 2.75 2.777H6c.55-2.157 2.376-1.56 2.75-2.777v-.905c-.188-.1-.723-.792-.78-1.332-.146-.012-.379-.159-.447-.738-.037-.311.109-.486.198-.541 0 0-.219-.501-.219-1C7.501 12.227 8.233 11 10 11zm7 4h6a1 1 0 010 2h-6a1 1 0 010-2zm0 4h6a1 1 0 010 2h-6a1 1 0 010-2z"
  }));
};
SvgHorizontalNameTag.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1j = ["title", "titleId"];
var SvgHorizontal = function SvgHorizontal(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1j);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.984 4.986A1 1 0 004 6v18a1 1 0 102 0V6a1 1 0 00-1.016-1.014zM6 15.016a1 1 0 00.293.691l2 2a1 1 0 101.414-1.414L9.414 16h11.172l-.293.293a1 1 0 101.414 1.414l2-2a1 1 0 00.293-.723 1 1 0 00-.293-.691l-2-2a1 1 0 00-.717-.303 1 1 0 00-.697 1.717l.293.293H9.414l.293-.293a1 1 0 00-.727-1.717 1 1 0 00-.687.303l-2 2a1 1 0 00-.293.723zm18-.032V24a1 1 0 102 0V6a1 1 0 00-1.016-1.014A1 1 0 0024 6v8.984zM9 5a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm4 0a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm4 0a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm4 0a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zM9 23a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm4 0a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm4 0a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm4 0a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1z"
  }));
};
SvgHorizontal.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1i = ["title", "titleId"];
var SvgIdeaSharing = function SvgIdeaSharing(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1i);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13 3a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm6.006 0a3.969 3.969 0 00-3.885 2.996c-.365 1.491.11 2.873 1.041 3.805C16.497 10.136 17 11 17 12h4c0-1 .516-1.875.854-2.217A3.943 3.943 0 0023 7a4 4 0 00-3.994-4zM25 3a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zM12 7a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm14 0a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm-13 4a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm12 0a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm-8 2a2.002 2.002 0 002.336 1.973c.948-.155 1.607-1.019 1.654-1.973H17zm-9 2a3 3 0 00-1.117.217L2 17v8l4.22-1.834a2.013 2.013 0 011.565-.018l9.065 3.704h.004A1.5 1.5 0 0017.5 27a1.5 1.5 0 00.738-.197h.006l8.986-4.992-.001-.002A1.5 1.5 0 0028 20.5a1.5 1.5 0 00-1.5-1.5 1.5 1.5 0 00-.637.145v-.002L19 22h-1.5a1.5 1.5 0 001.5-1.5 1.5 1.5 0 00-1.035-1.426v-.002l-8.694-3.79H9.26A3 3 0 008 15z"
  }));
};
SvgIdeaSharing.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1h = ["title", "titleId"];
var SvgImprove = function SvgImprove(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1h);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.33 2.102l-3.65.55a.5.5 0 00-.28.848l.842.844-3.064 3.064-.895-.838a1 1 0 00-1.398.032l-3.393 3.476-.785-.785a1 1 0 00-1.406-.008l-3.998 3.918a1 1 0 101.4 1.428l3.29-3.225.8.801a1 1 0 001.422-.008l3.416-3.5.885.83a1 1 0 001.39-.021l3.75-3.75.844.842a.5.5 0 00.848-.28l.55-3.65a.5.5 0 00-.568-.568zm-1.346 7.884A1 1 0 0019 11v9a1 1 0 102 0v-9a1 1 0 00-1.016-1.014zm-4 2A1 1 0 0015 13v7a1 1 0 102 0v-7a1 1 0 00-1.016-1.014zm-4 2A1 1 0 0011 15v5a1 1 0 102 0v-5a1 1 0 00-1.016-1.014zm-4 2A1 1 0 007 17v3a1 1 0 102 0v-3a1 1 0 00-1.016-1.014zm-4 2A1 1 0 003 19v1a1 1 0 102 0v-1a1 1 0 00-1.016-1.014z"
  }));
};
SvgImprove.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1g = ["title", "titleId"];
var SvgInfo = function SvgInfo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1g);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 3C8.373 3 3 8.373 3 15s5.373 12 12 12 12-5.373 12-12S21.627 3 15 3zm1 18h-2v-7h2v7zm-1-9.5a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0115 11.5z"
  }));
};
SvgInfo.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1f = ["title", "titleId"];
var SvgInstall = function SvgInstall(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1f);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7 2a2 2 0 00-2 2v14a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2h-6a1 1 0 00-1 1v8.586l2.293-2.293a.999.999 0 111.414 1.414l-4 4a.997.997 0 01-1.414 0l-4-4a.999.999 0 111.414-1.414L14 11.586V3a1 1 0 00-1-1H7zM5 21.443V26a2 2 0 002 2h16a2 2 0 002-2v-4.557A3.96 3.96 0 0123 22H7a3.96 3.96 0 01-2-.557zM22 24a1 1 0 110 2 1 1 0 010-2z"
  }));
};
SvgInstall.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1e = ["title", "titleId"];
var SvgInstances = function SvgInstances(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1e);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M26.072 4a2 2 0 00-1.728 1H15c-1.645 0-3 1.355-3 3v3.832a1 1 0 000 .326V14H7.824A3 3 0 005 12a3 3 0 00-3 3 3 3 0 003 3 3 3 0 002.826-2H12v1.832a1 1 0 000 .326V22c0 1.645 1.355 3 3 3h9.197a2 2 0 001.73 1 2 2 0 002-2 2 2 0 00-2-2 2 2 0 00-1.728 1H15c-.565 0-1-.435-1-1v-3h10.246a2 2 0 001.73 1 2 2 0 002-2 2 2 0 00-2-2 2 2 0 00-1.728 1H14v-1.832a1 1 0 000-.326V13h10.293a2 2 0 001.73 1 2 2 0 002-2 2 2 0 00-2-2 2 2 0 00-1.728 1H14V8c0-.565.435-1 1-1h9.342a2 2 0 001.73 1 2 2 0 002-2 2 2 0 00-2-2z"
  }));
};
SvgInstances.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1d = ["title", "titleId"];
var SvgIntegration = function SvgIntegration(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1d);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 4c-1.093 0-2 .907-2 2v2H6c-1.093 0-2 .907-2 2v14c0 1.093.907 2 2 2h12c1.093 0 2-.907 2-2v-2h4c1.093 0 2-.907 2-2V6c0-1.093-.907-2-2-2H12zm0 2h12v14h-5a1 1 0 00-1 1v3H6V10h5a1 1 0 001-1V6zm9 3l-3 3 3 3V9zm-8 2a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm2 3a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm-6 1v6l3-3-3-3zm8 2a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1z"
  }));
};
SvgIntegration.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1c = ["title", "titleId"];
var SvgKnight = function SvgKnight(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1c);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 3s-2 .047-2 2c-1.633.613-2.986 2.364-2.998 5-.013 2.988.998 4.009.998 7a1 1 0 00-.9 1.46C9.067 18.944 8 19.933 8 22h14c0-2.068-1.067-3.057-2.1-3.54A1 1 0 0019 17c0-3.987-4-6-4-6s1.474-.014 2.357-1H20a1 1 0 001-1V7.75a.75.75 0 00-.75-.75C19.238 7 17.262 5 15 5V3zM7 24a1 1 0 100 2h16a1 1 0 100-2H7z"
  }));
};
SvgKnight.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1b = ["title", "titleId"];
var SvgKubernetes = function SvgKubernetes(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1b);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.965 1.82l-.701.348-9.96 4.887-.67.277c-.068.281-.135.563-.204.844L1.969 19.17l-.16.734.468.655 6.893 8.82.504.611.764.01H21.49l.778-.01.492-.611 6.89-8.82.485-.612-.174-.777L27.5 8.176l-.156-.776-.721-.343-9.955-4.889-.703-.348zm-.004 3.596c.272 0 .532.16.648.43a.74.74 0 010 .562c-.148.354-.2.71-.238 1.063-.013.183-.018.36-.012.537-.019.177.07.352.2.53.135.176.149.353.168.53a7.581 7.581 0 014.675 2.243c.148-.098.291-.204.516-.211.213-.013.405-.051.527-.182.135-.111.264-.23.393-.355.245-.25.482-.518.656-.858a.687.687 0 01.942-.309.71.71 0 01.302.958.687.687 0 01-.425.36c-.361.106-.664.295-.954.491-.142.105-.283.21-.412.328-.148.098-.225.281-.283.49-.045.223-.166.348-.289.479a7.874 7.874 0 011.32 4.39c0 .25-.014.499-.033.74h.008c.167.053.334.097.482.274.148.157.303.276.477.29.174.038.342.064.516.083.354.033.702.046 1.076-.039a.7.7 0 01.836.545.707.707 0 01-1.078.744c-.316-.216-.65-.333-.985-.431a4.598 4.598 0 00-.51-.112c-.167-.052-.36 0-.552.092-.193.111-.367.093-.547.08h-.02a7.889 7.889 0 01-3.38 4.45v.005c.051.17.109.336.058.559-.045.216-.054.411.037.568.071.157.149.322.233.473.174.308.368.616.652.871a.73.73 0 01.045 1.01.7.7 0 01-1.217-.465c-.013-.387-.11-.727-.227-1.068a4.972 4.972 0 00-.199-.493c-.058-.17-.212-.286-.398-.398-.18-.098-.27-.238-.362-.389a7.606 7.606 0 01-5.244.014.825.825 0 01-.347.373c-.187.105-.34.23-.399.4-.077.157-.149.32-.207.485-.116.34-.218.681-.224 1.068a.71.71 0 01-.729.688.706.706 0 01-.676-.735.711.711 0 01.233-.504c.283-.262.478-.564.658-.865.084-.157.16-.313.23-.476.09-.151.084-.355.045-.57-.045-.204.001-.367.053-.518a7.889 7.889 0 01-3.42-4.43.776.776 0 01-.457-.072c-.2-.085-.387-.137-.555-.078a4.61 4.61 0 00-.507.13c-.335.111-.663.236-.973.46a.697.697 0 01-.98-.17.721.721 0 01.167-.99.706.706 0 01.541-.124c.367.08.72.051 1.069.006.174-.02.348-.052.515-.098.174-.013.327-.142.47-.306.121-.144.263-.203.405-.256a8.567 8.567 0 01-.039-.82 7.9 7.9 0 011.399-4.508c-.116-.118-.225-.236-.27-.446-.058-.21-.135-.394-.283-.492a4.524 4.524 0 00-.412-.32c-.296-.197-.598-.38-.96-.49a.71.71 0 01-.483-.88.706.706 0 01.87-.49.72.72 0 01.424.354c.174.341.414.609.665.858.122.124.257.242.392.347.122.131.315.17.527.184.225.007.368.105.516.203l.006.006a7.547 7.547 0 014.578-2.149c.02-.177.033-.354.168-.53.129-.178.218-.355.2-.532a5.103 5.103 0 00-.012-.537c-.04-.354-.09-.708-.239-1.06a.72.72 0 01.367-.938.696.696 0 01.272-.057zm-.924 4.992a6.263 6.263 0 00-3.271 1.522l.199.123c.599.38 1.179.78 1.758 1.18.335.215.651.458.966.687.026-.372.057-.751.096-1.125.064-.708.13-1.424.22-2.13l.032-.257zm1.856 0v.002h-.002l.033.254v.002c.09.708.155 1.422.219 2.129.026.282.05.558.07.84l.002.008.025.375c.09-.034.224-.092.377-.172.007-.004.015-.003.022-.008l.035-.025c.346-.196.567-.41.64-.461.58-.4 1.153-.8 1.745-1.186l.002-.002.218-.137a6.412 6.412 0 00-2.441-1.408 6.209 6.209 0 00-.945-.21zM10.54 13.36c-.16.254-.306.519-.432.795v.002a6.539 6.539 0 00-.318.86v.002a6.578 6.578 0 00-.268 1.873c0 .124.006.241.006.359v.002l.303-.106c.663-.242 1.332-.452 1.996-.675.318-.102.634-.2.947-.295l.362-.166-.258-.293a18.85 18.85 0 01-.645-.623c-.502-.505-.998-1.002-1.488-1.52l-.205-.215zm10.924.123l-.084.09-.092.1c-.483.524-.979 1.03-1.475 1.533-.316.328-.656.642-.984.963.438.111.877.228 1.315.36.676.196 1.345.387 2.015.609l.238.08c.006-.105.006-.216.006-.328 0-.313-.02-.622-.062-.922a6.499 6.499 0 00-.877-2.485zm-5.067 2.067l-1.173.012-.721.925.273 1.143 1.065.496 1.05-.521.249-1.149-.743-.906zm-2.78 3.14a7.428 7.428 0 00-.378.014c-.303.04-.6.086-.902.12-.702.084-1.392.17-2.094.236l-.348.033c.118.334.263.656.43.963a6.578 6.578 0 001.264 1.64c.25.237.521.454.806.647l.09-.276c.22-.68.452-1.35.69-2.025.11-.328.224-.65.347-.977.044-.157.074-.288.094-.375zm4.747.053a21.089 21.089 0 01.479 1.305c.225.668.457 1.343.67 2.025l.07.237a6.556 6.556 0 002.447-3.23l-.224-.015c-.702-.046-1.4-.11-2.102-.175-.303-.026-.597-.06-.9-.092-.185-.021-.338-.042-.44-.055zm-2.392 1.053a4.18 4.18 0 00-.192.432l-.004.003c-.148.282-.302.558-.463.827-.354.616-.708 1.233-1.082 1.836l-.162.261h.002c.3.095.61.167.926.215a6.453 6.453 0 001.963-.006h.002c.324-.051.642-.127.947-.228l-.148-.25c-.374-.603-.723-1.226-1.07-1.842a18.836 18.836 0 01-.444-.813l-.275-.435z"
  }));
};
SvgKubernetes.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1a = ["title", "titleId"];
var SvgLaptopConfig = function SvgLaptopConfig(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1a);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.64 0c-.13 0-.24.1-.25.22l-.03.26c-.03.33-.28.58-.6.65-.21.05-.42.1-.62.17a.762.762 0 01-.85-.27l-.15-.2c-.07-.11-.22-.13-.33-.07l-.62.36c-.11.06-.16.2-.11.32l.11.24c.13.3.05.64-.2.86-.15.15-.31.3-.45.45a.74.74 0 01-.86.2l-.24-.11c-.12-.05-.26 0-.32.11l-.36.62c-.07.11-.04.26.06.33l.21.15c.23.17.33.44.29.71a.4.4 0 01-.03.14c-.06.2-.12.41-.16.62-.07.32-.33.57-.65.6l-.22.03c-.16.01-.26.12-.26.25v.72c0 .13.1.24.22.25l.26.03c.33.03.58.28.65.6.05.21.1.42.17.62.1.31 0 .65-.27.85l-.2.15a.24.24 0 00-.07.33l.36.62c.06.11.2.16.32.11l.24-.11c.3-.13.64-.05.86.2.15.15.29.3.45.45.25.22.33.56.2.86l-.11.24c-.05.12 0 .26.11.32l.62.36c.11.06.26.04.33-.07l.15-.2c.2-.27.54-.37.85-.27.2.07.41.12.62.17.32.06.57.32.6.65l.03.26c.01.12.12.22.25.22h.72c.13 0 .24-.1.25-.22l.03-.26c.03-.33.28-.58.6-.65.21-.05.42-.1.62-.17.31-.1.65 0 .85.27l.15.2c.03.05.08.08.14.09.06.02.13.01.19-.02l.62-.36c.11-.06.16-.2.1-.32l-.1-.24a.74.74 0 01.2-.86l.45-.45a.77.77 0 01.54-.26c.1-.01.21.01.32.06l.24.11c.12.05.26 0 .32-.11l.36-.62c.06-.11.03-.26-.07-.33l-.2-.15a.762.762 0 01-.27-.85c.07-.2.12-.41.17-.62.06-.32.32-.57.65-.6l.26-.03a.25.25 0 00.22-.25v-.72c0-.13-.1-.24-.22-.25l-.26-.03c-.33-.03-.58-.28-.65-.6-.05-.21-.1-.42-.17-.62a.762.762 0 01.27-.85l.2-.15c.11-.07.13-.22.07-.33l-.36-.62a.256.256 0 00-.32-.11l-.24.11a.74.74 0 01-.86-.2l-.45-.45a.74.74 0 01-.2-.86l.1-.24c.06-.12.01-.26-.1-.32l-.62-.36c-.11-.06-.26-.04-.33.07l-.15.2a.762.762 0 01-.85.27c-.21-.07-.41-.12-.62-.17a.754.754 0 01-.61-.65l-.02-.26a.25.25 0 00-.25-.22h-.72zM23 3c1.7 0 3.14 1.05 3.72 2.55.18.45.28.94.28 1.45 0 1.01-.38 1.93-1 2.64-.73.83-1.8 1.36-3 1.36a3.999 3.999 0 01-3.46-6c.69-1.2 1.98-2 3.46-2zM5 5C3.36 5 2 6.36 2 8v13c0 .77.3 1.47.79 2H0c0 1.66 1.34 3 3 3h24c1.66 0 3-1.34 3-3h-2.79c.49-.53.79-1.23.79-2v-6.12c-.61.41-1.29.75-2 1V21c0 .57-.43 1-1 1H5c-.57 0-1-.43-1-1V8c0-.57.43-1 1-1h9.07c.03-.69.14-1.36.32-2H5zm18 1a1 1 0 000 2 1 1 0 000-2z"
  }));
};
SvgLaptopConfig.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$19 = ["title", "titleId"];
var SvgLeader = function SvgLeader(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$19);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14 2a3 3 0 00-3 3 3 3 0 003 3 3 3 0 003-3 3 3 0 00-3-3zm7 2a1 1 0 00-1 1v2a1 1 0 001 1h4.5a.5.5 0 00.5-.5.5.5 0 00-.27-.443l-.005-.004L24 6l1.727-1.055A.5.5 0 0026 4.5a.5.5 0 00-.5-.5H21zm-8 6c-1.645 0-3 1.355-3 3v6a1 1 0 001 1.014v6.088c0 .436.463.898 1.033.898.544 0 .995-.422 1.031-.965l.438-6.57a.5.5 0 01.996.002l.438 6.568A1.034 1.034 0 0017 25.967V12h5a1 1 0 100-2h-9z"
  }));
};
SvgLeader.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$18 = ["title", "titleId"];
var SvgLearning = function SvgLearning(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$18);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 5C3.355 5 2 6.355 2 8v13c0 .769.304 1.467.787 2H0a3 3 0 003 3h24a3 3 0 003-3h-2.787A2.975 2.975 0 0028 21V8c0-1.645-1.355-3-3-3H5zm0 2h20c.565 0 1 .435 1 1v13c0 .565-.435 1-1 1H5c-.565 0-1-.435-1-1V8c0-.565.435-1 1-1zm4 4a1 1 0 100 2h12a1 1 0 100-2H9zm0 5a1 1 0 100 2h8a1 1 0 100-2H9z"
  }));
};
SvgLearning.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$17 = ["title", "titleId"];
var SvgLink = function SvgLink(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$17);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22 2a5.962 5.962 0 00-4.242 1.758l-2 2A5.962 5.962 0 0014 10c0 1.264.393 2.464 1.113 3.473l-1.64 1.64A5.953 5.953 0 0010 14a5.962 5.962 0 00-4.242 1.758l-2 2A5.962 5.962 0 002 22c0 1.603.625 3.108 1.758 4.242A5.956 5.956 0 008 28a5.962 5.962 0 004.242-1.758l2-2A5.962 5.962 0 0016 20c0-.551-.079-1.088-.22-1.605l-1.8 1.798a3.973 3.973 0 01-1.152 2.635l-2 2a4.003 4.003 0 01-5.656 0 4.004 4.004 0 010-5.656l2-2a3.988 3.988 0 012.83-1.168c.702 0 1.397.195 2.02.56l-2.729 2.729a1 1 0 101.414 1.414l10-10a1 1 0 00-.727-1.717 1 1 0 00-.687.303l-2.729 2.728c-.9-1.533-.707-3.535.608-4.85l2-2A3.983 3.983 0 0122 4.005c1.025 0 2.048.389 2.828 1.168a4.003 4.003 0 010 5.656l-2 2a3.97 3.97 0 01-2.635 1.152l-1.798 1.8c.517.141 1.054.22 1.605.22a5.962 5.962 0 004.242-1.758l2-2A5.962 5.962 0 0028 8a5.962 5.962 0 00-1.758-4.242A5.962 5.962 0 0022 2z"
  }));
};
SvgLink.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$16 = ["title", "titleId"];
var SvgManagedOperations = function SvgManagedOperations(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$16);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14 2a1 1 0 00-1 1v1.191C7.889 5.136 4 9.621 4 15c0 6.063 4.937 11 11 11s11-4.937 11-11c0-5.38-3.889-9.864-9-10.809V3a1 1 0 00-1-1h-2zm8.99 1.99a1 1 0 00-.697 1.717l1 1a1 1 0 101.414-1.414l-1-1a1 1 0 00-.717-.303zM15 6c4.982 0 9 4.018 9 9s-4.018 9-9 9-9-4.018-9-9 4.018-9 9-9zm-.016 1.986A1 1 0 0014 9v4.271A2 2 0 0013 15a2 2 0 001 1.73V18a1 1 0 102 0v-1.271A2 2 0 0017 15a2 2 0 00-1-1.73V9a1 1 0 00-1.016-1.014z"
  }));
};
SvgManagedOperations.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$15 = ["title", "titleId"];
var SvgMigrate = function SvgMigrate(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$15);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4 4v9h2.059c.12-1.505.484-4.296 1.564-5.377C8.704 6.543 11.495 6.18 13 6.059V4H4zm10 4c-.979 0-4.32.396-4.963 1.037C8.395 9.678 8 13.021 8 14c0 .979.396 4.32 1.037 4.963.281.28 1.08.513 1.97.687 0-.05-.007-.099-.007-.15a8.47 8.47 0 012.49-6.01A8.47 8.47 0 0119.5 11c.051 0 .1.007.15.008-.174-.891-.406-1.688-.687-1.969C18.32 8.397 14.979 8 14 8zm5.5 5a6.5 6.5 0 00-6.5 6.5 6.5 6.5 0 006.5 6.5 6.5 6.5 0 006.5-6.5 6.5 6.5 0 00-6.5-6.5z"
  }));
};
SvgMigrate.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$14 = ["title", "titleId"];
var SvgMigration = function SvgMigration(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$14);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 24",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16 0c.49 0 .94.178 1.29.472C17.7.175 18.203 0 18.75 0h13a2.5 2.5 0 012.5 2.5v19a2.5 2.5 0 01-2.5 2.5h-13c-.546 0-1.05-.175-1.462-.472A1.988 1.988 0 0116 24H2c-1.103 0-2-.897-2-2V2C0 .897.897 0 2 0zm15.75 1.75h-13a.75.75 0 00-.749.706V2.5L18 10.999l5.586.001-2.293-2.293a1 1 0 111.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 11-1.414-1.414L23.586 13H18v-2h-8a1 1 0 00-.993.883L9 12a1 1 0 001 1h8v8.5c0 .4.312.726.706.749l.044.001h13a.75.75 0 00.749-.706l.001-.044v-19a.75.75 0 00-.706-.749l-.044-.001z"
  }));
};
SvgMigration.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$13 = ["title", "titleId"];
var SvgMission = function SvgMission(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$13);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 2a1 1 0 00-1 1v6.283a2.037 2.037 0 00-.586.512L2.566 22.609A2 2 0 004 26c.047.001.09-.01.137-.013l.008.014h21.71l.008-.014c.046.003.09.014.137.014a2 2 0 002-2c0-.502-.191-.956-.496-1.307L16.586 9.795A2.037 2.037 0 0016 9.283V6.756l4.682-1.79a.5.5 0 01.002-.001A.5.5 0 0021 4.5a.5.5 0 00-.365-.482L15.367 2.07v.004A.99.99 0 0015 2zm-.06 9.088h.12L21 18.102 17 16l-2 1-1-2-4.064 1.994 5.003-5.906z"
  }));
};
SvgMission.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$12 = ["title", "titleId"];
var SvgModule = function SvgModule(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$12);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.963 2a1 1 0 00-.41.105l-10 5A1 1 0 004 8v11.662a1 1 0 00.465.844l10 6.338a1 1 0 001.07 0l10-6.338a1 1 0 00.465-.844V8a1 1 0 00-.553-.895l-10-5A1 1 0 0014.963 2zM15 4.117l8.39 4.196L21 9.834V12l-5 3v6l4.514-2.709a.998.998 0 00.486-.857v-5.229l3-1.91v8.816l-8 5.07V21l-1 .645L14 21v3.182l-8-5.07v-8.817l3 1.91v5.229c0 .35.184.677.486.857L14 21v-6l-5-3V9.834L6.61 8.313 15 4.117zM9 9.84l6 3.75 6-3.75-5.084-2.62a2 2 0 00-1.832 0L9 9.84z"
  }));
};
SvgModule.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$11 = ["title", "titleId"];
var SvgMonitoring = function SvgMonitoring(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$11);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4 5c-1.1 0-2 .9-2 2v15c0 .37.11.7.28 1H0v1a2 2 0 002 2h26c1.1 0 2-.9 2-2v-1h-2.28c.17-.3.28-.63.28-1V7c0-1.1-.9-2-2-2H4zm0 2h22v15h-8c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1H4V7zm18.002 4a.996.996 0 00-.707.293l-4.211 4.21-3.303-4.128c-.38-.475-1.181-.475-1.562 0l-4 5A1.002 1.002 0 008.998 18c.294 0 .585-.129.783-.375L13 13.602l3.219 4.023a1.003 1.003 0 001.488.082l5-5A.999.999 0 0022.002 11z"
  }));
};
SvgMonitoring.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$10 = ["title", "titleId"];
var SvgMoreTeam = function SvgMoreTeam(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$10);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 3C18.374 3 18 4.5 18 4.5c-.743 0-1.337.278-1.799.742C16.713 6.344 17 7.614 17 9c0 .696-.138 1.371-.293 1.91a3.36 3.36 0 01.223 1.754c-.104.815-.35 1.443-.664 1.941.19.551.541 1.116.89 1.563a8.957 8.957 0 017.686-1.977c.009-.047.024-.097.03-.144.353-.027.91-.352 1.073-1.635.088-.688-.26-1.075-.472-1.197 0 0 .527-1.111.527-2.215 0-3.279-2.012-6-5.5-6zm-11 .002c-2.126 0-2.5 1.5-2.5 1.5-2.047 0-3 2.072-3 4.5 0 1.211.527 2.213.527 2.213-.212.122-.56.508-.472 1.197.164 1.283.72 1.61 1.074 1.637C5.264 15.246 6.55 16.777 7 17v2c-1 3-7 1-7 8h14.95a8.92 8.92 0 01-.95-4c0-.741.1-1.457.27-2.146-1.04-.408-1.936-.852-2.27-1.854v-2c.45-.223 1.736-1.755 1.871-2.953.354-.027.91-.352 1.074-1.635.088-.688-.26-1.075-.472-1.197 0 0 .527-1.111.527-2.215 0-3.279-2.012-5.999-5.5-5.998zM23 16a7 7 0 100 14 7 7 0 000-14zm0 3a1 1 0 011 1v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0v-2h-2a1 1 0 110-2h2v-2a1 1 0 011-1z"
  }));
};
SvgMoreTeam.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$$ = ["title", "titleId"];
var SvgNameTag = function SvgNameTag(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$$);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7 2a2 2 0 00-2 2v22a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2h-5v3a1 1 0 01-1 1h-4a1 1 0 01-1-1V2H7zm8 0a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1zm0 8c.872 0 1.377.688 1.377.688 1.186 0 1.893 1.083 1.893 2.49 0 .702-.39 1.437-.39 1.437s.218.074.218.557c0 .697-.565 1.086-.565 1.086-.06.532-.705 1.248-1.004 1.556v1.614C17.47 20.765 21 20.136 21 23H9c0-2.864 3.53-2.234 4.47-3.57v-1.614c-.298-.308-.942-1.026-1.003-1.558 0 0-.565-.21-.565-1.086 0-.451.217-.557.217-.557s-.474-.658-.474-1.502C11.645 11.115 13.147 10 15 10z"
  }));
};
SvgNameTag.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$_ = ["title", "titleId"];
var SvgNetwork = function SvgNetwork(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$_);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2a2 2 0 00-2 2 2 2 0 001 1.73v1.362c0 .545.441.986.986.986h.026A.986.986 0 0013 7.092V5.729A2 2 0 0014 4a2 2 0 00-2-2zM4 6a2 2 0 00-2 2 2 2 0 002 2 2 2 0 001.102-.332l2.06 1.031c.472.236 1.017.016 1.254-.455l.018-.037c.246-.477.102-1.057-.377-1.297L5.994 7.88A2 2 0 004 6zm16 0a2 2 0 00-1.994 1.879L15.943 8.91c-.48.24-.624.821-.377 1.297l.018.035c.238.471.782.693 1.254.457L18.9 9.668A2 2 0 0020 10a2 2 0 002-2 2 2 0 00-2-2zm-8 4a2 2 0 00-2 2 2 2 0 002 2 2 2 0 002-2 2 2 0 00-2-2zm4.477 3.205a.968.968 0 00-.893.55l-.018.038c-.246.477-.102 1.057.377 1.297l2.063 1.031A2 2 0 0020 18a2 2 0 002-2 2 2 0 00-2-2 2 2 0 00-1.102.332l-2.06-1.031a.89.89 0 00-.361-.096zm-8.954.002a.887.887 0 00-.36.094L5.1 14.332A2 2 0 004 14a2 2 0 00-2 2 2 2 0 002 2 2 2 0 001.994-1.879l2.063-1.03c.48-.24.624-.82.377-1.296l-.018-.037a.968.968 0 00-.893-.551zm4.465 2.715a.986.986 0 00-.988.986v1.363A2 2 0 0010 20a2 2 0 002 2 2 2 0 002-2 2 2 0 00-1-1.73v-1.362a.986.986 0 00-.986-.986h-.026z"
  }));
};
SvgNetwork.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$Z = ["title", "titleId"];
var SvgNetwork2 = function SvgNetwork2(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$Z);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13 2a1 1 0 00-1 1v1H9C6.25 4 4 6.25 4 9v3H3a1 1 0 00-1 1v4a1 1 0 001 1h1v3c0 2.75 2.25 5 5 5h3v1a1 1 0 001 1h4a1 1 0 001-1v-1h3c2.75 0 5-2.25 5-5v-3h1a1 1 0 001-1v-4a1 1 0 00-1-1h-1V9c0-2.75-2.25-5-5-5h-3V3a1 1 0 00-1-1h-4zM9 6h3v1a1 1 0 001 1h4a1 1 0 001-1V6h3c1.668 0 3 1.332 3 3v3h-1a1 1 0 00-1 1v4a1 1 0 001 1h1v3c0 1.668-1.332 3-3 3h-3v-1a1 1 0 00-1-1h-4a1 1 0 00-1 1v1H9c-1.668 0-3-1.332-3-3v-3h1a1 1 0 001-1v-4a1 1 0 00-1-1H6V9c0-1.668 1.332-3 3-3z"
  }));
};
SvgNetwork2.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$Y = ["title", "titleId"];
var SvgNewWindow = function SvgNewWindow(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$Y);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 4a2 2 0 00-2 2v21h24V6a2 2 0 00-2-2H5zm0 5h20v16H5V9zm9.984 2.986A1 1 0 0014 13v3h-3a1 1 0 100 2h3v3a1 1 0 102 0v-3h3a1 1 0 100-2h-3v-3a1 1 0 00-1.016-1.014z"
  }));
};
SvgNewWindow.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$X = ["title", "titleId"];
var SvgNews = function SvgNews(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$X);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4 2a1 1 0 00-1 1v21a4 4 0 004 4h17a4 4 0 004-4V10a1 1 0 00-1-1h-2v15a1 1 0 11-2 0V3a1 1 0 00-1-1H4zm2 4h14v3H6V6zm0 7h6v2H6v-2zm8 0h6v2h-6v-2zm-8 4h6v2H6v-2zm8 0h6v2h-6v-2zm-8 4h6v2H6v-2zm8 0h6v2h-6v-2z"
  }));
};
SvgNews.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$W = ["title", "titleId"];
var SvgOpenSource = function SvgOpenSource(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$W);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.227 46.582c-.122 0-.243-.02-.356-.062C7.977 43.156 2 34.508 2 25 2 12.316 12.316 2 25 2s23 10.316 23 23c0 9.508-5.977 18.156-14.871 21.52a.984.984 0 01-.766-.028.987.987 0 01-.523-.554l-4.95-13.11a.998.998 0 01.583-1.289A7.024 7.024 0 0032 25c0-3.86-3.14-7-7-7s-7 3.14-7 7c0 2.89 1.82 5.52 4.527 6.54.52.194.778.773.582 1.288L18.16 45.934a.994.994 0 01-.523.558.936.936 0 01-.41.09z"
  }));
};
SvgOpenSource.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$V = ["title", "titleId"];
var SvgOptions = function SvgOptions(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$V);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 0c-1.645 0-3 1.355-3 3H8C6.355 3 5 4.355 5 6v18c0 1.645 1.355 3 3 3h14c1.645 0 3-1.355 3-3V6c0-1.645-1.355-3-3-3h-4c0-1.645-1.355-3-3-3zm0 2c.564 0 1 .436 1 1 0 .564-.436 1-1 1-.564 0-1-.436-1-1 0-.564.436-1 1-1zM8 5h2a2 2 0 002 2h6a2 2 0 002-2h2c.565 0 1 .435 1 1v18c0 .565-.435 1-1 1H8c-.565 0-1-.435-1-1V6c0-.565.435-1 1-1zm10 6a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 00-1-1h-2zm-8 1a1 1 0 100 2h4a1 1 0 100-2h-4zm8 5a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 00-1-1h-2zm-8 1a1 1 0 100 2h4a1 1 0 100-2h-4z"
  }));
};
SvgOptions.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$U = ["title", "titleId"];
var SvgPartner = function SvgPartner(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$U);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7 2v2H2v34h18v-2H4V6h5V4h12v2h5v3.922h2V4h-5V2zm29 0l-3 3 3 3V6h4c.566 0 1 .434 1 1v3h2V7c0-1.645-1.355-3-3-3h-4zM6 8v2h3V8zm5 0v2h3V8zm5 0v2h3V8zm5 0v2h3V8zM6 12v2h3v-2zm5 0v2h3v-2zm5 0v2h3v-2zm11 0v2h-5v34h26V14h-5v-2zm2 2h12v2h5v30H24V16h5zM6 16v2h3v-2zm5 0v2h3v-2zm5 0v2h3v-2zm10 2v2h3v-2zm5 0v2h3v-2zm5 0v2h3v-2zm5 0v2h3v-2zM6 20v2h3v-2zm5 0v2h3v-2zm5 0v2h3v-2zm10 2v2h3v-2zm5 0v2h3v-2zm5 0v2h3v-2zm5 0v2h3v-2zM6 24v2h3v-2zm5 0v2h3v-2zm5 0v2h3v-2zm10 2v2h3v-2zm5 0v2h3v-2zm5 0v2h3v-2zm5 0v2h3v-2zM6 28v2h3v-2zm5 0v2h3v-2zm5 0v2h3v-2zm10 2v2h3v-2zm5 0v2h3v-2zm5 0v2h3v-2zm5 0v2h3v-2zM6 32v2h3v-2zm5 0v2h3v-2zm5 0v2h3v-2zm10 2v2h3v-2zm5 0v2h3v-2zm5 0v2h3v-2zm5 0v2h3v-2zm-15 4v2h3v-2zm5 0v2h3v-2zm5 0v2h3v-2zm5 0v2h3v-2zM7 40v3c0 1.645 1.355 3 3 3h4v2l3-3-3-3v2h-4c-.566 0-1-.434-1-1v-3zm19 2v2h3v-2zm5 0v2h3v-2zm5 0v2h3v-2zm5 0v2h3v-2z"
  }));
};
SvgPartner.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$T = ["title", "titleId"];
var SvgPartners = function SvgPartners(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$T);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 5a2 2 0 00-2 2v16a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2H10zM3 7a2 2 0 00-2 2v12a2 2 0 002 2h3v-3H3c0-2.938 2.579-2.104 3-3.367v-.844s-.785-.738-.842-1.242c0 0-.408-.153-.408-.79 0-.327.156-.403.156-.403s-.343-.477-.343-1.09c0-1.066.592-1.782 1.439-2.09V7H3zm21 0v3.5c.862 0 1.375.787 1.375 1.809 0 .51-.281 1.045-.281 1.045s.156.053.156.404c0 .506-.408.789-.408.789-.057.505-.842 1.242-.842 1.242v.842c.421 1.263 3 .42 3 3.367h-3v3h3a2 2 0 002-2V9a2 2 0 00-2-2h-3zm-9 3c.634 0 1 .5 1 .5.862 0 1.375.787 1.375 1.809 0 .51-.281 1.045-.281 1.045s.156.053.156.404c0 .506-.408.789-.408.789-.057.505-.842 1.242-.842 1.242v.842c.421 1.263 3 .42 3 3.367h-8c.001-2.935 2.58-2.102 3-3.365v-.844s-.785-.738-.842-1.242c0 0-.408-.153-.408-.79 0-.327.156-.403.156-.403s-.344-.477-.344-1.09C12.563 10.812 13.655 10 15 10z"
  }));
};
SvgPartners.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$S = ["title", "titleId"];
var SvgPdf = function SvgPdf(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$S);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7 3a2 2 0 00-2 2v21a2 2 0 002 2h16a2 2 0 002-2V10.5a1 1 0 00-.293-.707l-6.5-6.5A1 1 0 0017.5 3H7zm10 1.904L23.096 11H18a1 1 0 01-1-1V4.904zM9.568 15.17c.307 0 .61.029.907.086.297.057.562.167.795.334.233.167.424.402.57.705.146.304.219.7.219 1.185 0 .44-.061.813-.184 1.12a2.07 2.07 0 01-.494.75 1.889 1.889 0 01-.717.42c-.27.087-.548.13-.834.13H9.7c-.062 0-.124-.001-.19-.005s-.133-.007-.196-.014a.899.899 0 01-.134-.022v2.41H7.92v-6.93a8.208 8.208 0 011.648-.17zm5.08 0c.553 0 1.015.086 1.385.256.37.17.668.409.89.719.225.31.381.682.475 1.115.093.433.141.918.141 1.45 0 .488-.045.952-.135 1.395-.09.443-.247.833-.474 1.17a2.44 2.44 0 01-.922.805c-.387.2-.872.3-1.46.3-.085 0-.204-.004-.35-.01-.147-.008-.3-.014-.46-.024-.16-.01-.314-.022-.46-.032a3.54 3.54 0 01-.34-.035v-7.01c.12-.02.256-.034.406-.044l.459-.03c.156-.01.309-.016.455-.02.147-.002.276-.005.39-.005zm3.891.1h3.5v1.16h-2.238v1.82h2.058v1.16h-2.058v2.86h-1.262v-7zm-8.85 1.02c-.206 0-.375.017-.51.05v2.39c.04.014.115.026.225.036.11.01.187.013.227.013.146 0 .286-.018.42-.058a.87.87 0 00.353-.205.972.972 0 00.246-.4c.061-.17.09-.385.09-.645 0-.22-.029-.408-.086-.56a.94.94 0 00-.228-.366.882.882 0 00-.336-.195c-.127-.04-.26-.06-.4-.06zm5.09.04c-.106 0-.214.002-.324.006-.109.003-.196.01-.256.023v4.82a.506.506 0 00.106.016l.16.01.158.01c.05.003.086.006.106.006.3 0 .546-.071.74-.211.192-.14.346-.328.455-.56.11-.234.185-.502.228-.805a6.925 6.925 0 00.01-1.844 2.399 2.399 0 00-.209-.756 1.3 1.3 0 00-.437-.52c-.19-.13-.438-.195-.737-.195z"
  }));
};
SvgPdf.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$R = ["title", "titleId"];
var SvgPeople = function SvgPeople(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$R);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 6c-3.182 0-4.5 2.041-4.5 4.5 0 .828.396 1.66.396 1.66-.159.092-.423.385-.357.9.123.963.54 1.205.807 1.225.1.898 1.067 2.048 1.404 2.215v1.342C12 20.092 6 19.75 6 25h18c0-5.25-6-4.908-6.75-7.158V16.5c.338-.167 1.303-1.317 1.404-2.215.266-.02.684-.262.807-1.224.066-.517-.198-.809-.357-.9 0 0 .396-.752.396-1.661 0-1.821-.715-3.375-2.25-3.375 0 0-.533-1.125-2.25-1.125zm7.5 1.998c-.512 0-.948.093-1.348.225.22.679.348 1.436.348 2.277a5.7 5.7 0 01-.19 1.428c.146.429.195.9.133 1.384-.14 1.102-.568 1.85-1.105 2.32a6.19 6.19 0 01-.6 1.079c.284.583.7 1.102.887 1.207v.012C22.662 18.885 26 20.49 26 25h4c0-4.958-5-4.246-5.625-6.371v-.713c.281-.158 1.086-1.244 1.17-2.092.22-.019.57-.247.672-1.156.055-.488-.165-.763-.297-.85 0 0 .33-.711.33-1.568 0-1.72-.596-3.188-1.875-3.188 0 0-.444-1.064-1.875-1.064zM7.5 8C6.069 8 5.625 9.063 5.625 9.063c-1.279 0-1.875 1.469-1.875 3.189 0 .858.33 1.566.33 1.566-.133.086-.352.362-.297.85.102.909.451 1.14.672 1.158.084.848.889 1.934 1.17 2.092v.71C5 20.754 0 20.043 0 25h4c0-4.51 3.338-6.114 5.375-7.07v-.014c.187-.105.603-.621.887-1.205a6.206 6.206 0 01-.6-1.08c-.537-.47-.965-1.219-1.105-2.319a3.11 3.11 0 01.136-1.402A5.612 5.612 0 018.5 10.5c0-.827.117-1.587.33-2.281A4.19 4.19 0 007.5 8z"
  }));
};
SvgPeople.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$Q = ["title", "titleId"];
var SvgPiggyBank = function SvgPiggyBank(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$Q);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2A3.5 3.5 0 009 5.5c0 .981.407 1.865 1.057 2.5h4.888A3.487 3.487 0 0016 5.5 3.5 3.5 0 0012.5 2zM25 8l-4.633 1.545a15.144 15.144 0 00-3.234-1.107c-.226.353-.481.69-.79.992l-.583.57H9.24l-.584-.57a5.627 5.627 0 01-.556-.664c-2.466.906-4.235 2.64-4.848 5.267A1 1 0 003 14a1 1 0 00-1 1 1 1 0 001 1 1 1 0 00.01 0c0 .046-.01.086-.01.133 0 1.497.384 2.989 1.115 4.346l.92 5.515A1.2 1.2 0 006.22 27H8.99c.588 0 1.09-.425 1.186-1.006l.103-.617c1.26.393 2.663.623 4.221.623a18.1 18.1 0 003.242-.29l.545.837a1 1 0 00.838.453H22a1 1 0 00.98-1.195l-.392-1.955c1.154-.772 2.057-1.736 2.644-2.858h.862c.552 0 1.033-.375 1.168-.91l.703-2.816a1.201 1.201 0 00-.785-1.432l-1.54-.514a8.417 8.417 0 00-1.845-3.273A7.295 7.295 0 0025 8zm-3.5 6a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0121.5 14z"
  }));
};
SvgPiggyBank.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$P = ["title", "titleId"];
var SvgPlaceholder = function SvgPlaceholder(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$P);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22 10c-.523 0-.96.406-1 .93V11c0 .523.406.96.93 1H22c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V11c0 .523.406.96.93 1H26c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V11c0 .523.406.96.93 1H30c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V11c0 .523.406.96.93 1H34c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V11c0 .523.406.96.93 1H38c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V11c0 .523.406.96.93 1H42c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V11c0 .523.406.96.93 1H46c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V11c0 .523.406.96.93 1H50c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V11c0 .523.406.96.93 1H54c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V11c0 .523.406.96.93 1H58c.55 0 1-.45 1-1s-.45-1-1-1zm-40 1a1.002 1.002 0 00-.07 2H18c.55 0 1-.45 1-1s-.45-1-1-1zm44 0c-.523 0-.96.406-1 .93V12c0 .523.406.96.93 1H62c.55 0 1-.45 1-1s-.45-1-1-1zm-48 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm52 0c-.523 0-.96.406-1 .93V14c0 .523.406.96.93 1H66c.55 0 1-.45 1-1s-.45-1-1-1zm-26 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-4.484.441a1.003 1.003 0 00-.984 1.195 1 1 0 001.175.786c.543-.11.895-.633.79-1.176a1.007 1.007 0 00-.981-.805zm9 0a1 1 0 10-.053 2.001 1 1 0 00.053-2zM12 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm44 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 0c-.523 0-.96.406-1 .93V18c0 .523.406.96.93 1H68c.55 0 1-.45 1-1s-.45-1-1-1zm-19.176.75a1.001 1.001 0 00-.949.613 1.006 1.006 0 00.547 1.309.994.994 0 001.3-.543.994.994 0 00-.898-1.379zm-17.62 0a.951.951 0 00-.388.078.992.992 0 00-.539 1.305c.211.508.793.75 1.301.539a.98.98 0 00.543-.54c.102-.245.102-.519.004-.765a1.011 1.011 0 00-.922-.617zm-3.97 2.125a.966.966 0 00-.566.168 1 1 0 10.566-.168zm25.563 0a.999.999 0 10-.037 1.996.999.999 0 00.037-1.996zM21 20c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm38 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-48 1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm58 0c-.523 0-.96.406-1 .93V22c0 .523.406.96.93 1H69c.55 0 1-.45 1-1s-.45-1-1-1zm-45.25 1.734a.976.976 0 00-.719.297.995.995 0 000 1.41.995.995 0 001.41 0 .995.995 0 000-1.41 1 1 0 00-.691-.297zm32.527 0c-.27 0-.53.106-.718.297a.995.995 0 000 1.41.995.995 0 001.41 0 .995.995 0 000-1.41.983.983 0 00-.692-.297zM11 25c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm28 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 0c-.523 0-.96.406-1 .93V26c0 .523.406.96.93 1H69c.55 0 1-.45 1-1s-.45-1-1-1zm-9.863 1.219a1.02 1.02 0 00-.57.172.999.999 0 101.386.273.995.995 0 00-.816-.445zm-38.242 0a1 1 0 00-.848.449.992.992 0 00.277 1.383 1 1 0 001.535-1.023.98.98 0 00-.425-.637.98.98 0 00-.54-.172zM40 27c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-4.582.91a1.002 1.002 0 00-.934 1.387 1 1 0 001.848-.766 1.004 1.004 0 00-.914-.62zm9.195 0a.999.999 0 00-.945.621 1 1 0 101.305-.543 1.022 1.022 0 00-.36-.078zM29 28c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm22 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-40 1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm58 0c-.523 0-.96.406-1 .93V30c0 .523.406.96.93 1H69c.55 0 1-.45 1-1s-.45-1-1-1zm-50.23 1.2a.99.99 0 00-.942.613.997.997 0 101.844.766.994.994 0 00-.902-1.38zm42.484 0a.994.994 0 00-.926 1.379.997.997 0 101.844-.767.992.992 0 00-.918-.613zm-29.723.316a.96.96 0 00-.722.293.995.995 0 000 1.41.987.987 0 001.414 0 .995.995 0 000-1.41.97.97 0 00-.692-.293zm16.969 0a1 1 0 10-.032 2 1 1 0 00.032-2zM11 33c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm23 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm12 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm23 0c-.523 0-.96.406-1 .93V34c0 .523.406.96.93 1H69c.55 0 1-.45 1-1s-.45-1-1-1zm-17.906 1.406a.999.999 0 10.375 1.922.997.997 0 00-.375-1.922zm-22.157 0a1.008 1.008 0 00-.949.621.999.999 0 00.543 1.305 1.004 1.004 0 001.309-.539 1.002 1.002 0 00-.902-1.387zm-11.468.11a.994.994 0 00-1.008.8c-.11.543.242 1.07.785 1.18a1.003 1.003 0 001.027-1.539 1.003 1.003 0 00-.636-.426.815.815 0 00-.168-.015zm45.093 0a.857.857 0 00-.199.015.998.998 0 00-.36 1.813.996.996 0 001.388-.274 1.01 1.01 0 00.152-.754 1 1 0 00-.98-.8zM37 36c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-32 1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm58 0c-.523 0-.96.406-1 .93V38c0 .523.406.96.93 1H69c.55 0 1-.45 1-1s-.45-1-1-1zm-52 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm11 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm12 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm12 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm11 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-52 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm58 0c-.523 0-.96.406-1 .93V42c0 .523.406.96.93 1H69c.55 0 1-.45 1-1s-.45-1-1-1zm-32 1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm19.582 1.484a1 1 0 00-1.004.809 1 1 0 101.961.39 1.001 1.001 0 00-.957-1.199zm-45.133.004c-.07 0-.137.004-.199.016a1.027 1.027 0 00-.64.426.998.998 0 101.664 1.113.999.999 0 00-.824-1.555zm33.66.102a.995.995 0 00-.945.617c-.21.512.031 1.094.54 1.309a1.002 1.002 0 001.308-.543.997.997 0 00-.543-1.305.943.943 0 00-.36-.078zm-22.187.004a.999.999 0 00-.934 1.379 1.003 1.003 0 001.852-.766 1.002 1.002 0 00-.918-.613zM11 45c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm23 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm12 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm23 0c-.523 0-.96.406-1 .93V46c0 .523.406.96.93 1H69c.55 0 1-.45 1-1s-.45-1-1-1zm-37.469 2.484a1 1 0 10.688 1.707 1 1 0 00-.688-1.707zm16.969 0a.997.997 0 00-1.016 1 1 1 0 101.016-1zm-29.738.317c-.137 0-.27.023-.39.074a1.003 1.003 0 00-.544 1.309.997.997 0 001.309.539.999.999 0 00-.375-1.922zm42.508 0a.994.994 0 00-.942.617.992.992 0 00.54 1.305 1 1 0 10.402-1.922zM11 49c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm58 0c-.523 0-.96.406-1 .93V50c0 .523.406.96.93 1H69c.55 0 1-.45 1-1s-.45-1-1-1zm-40 1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm22 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-15.566.086a1.005 1.005 0 00-.95.617 1.005 1.005 0 00.543 1.305.999.999 0 001.305-1.309 1.011 1.011 0 00-.539-.539 1.055 1.055 0 00-.36-.074zm9.164 0a.998.998 0 00-.926 1.383.997.997 0 101.844-.766 1.001 1.001 0 00-.918-.617zM40 51c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm19.14.777a.993.993 0 00-.847.442 1.004 1.004 0 00.273 1.39c.223.145.493.2.754.149.262-.055.489-.207.637-.43a1.001 1.001 0 00-.277-1.387.973.973 0 00-.54-.164zm-38.25 0a.965.965 0 00-.566.168 1 1 0 10.566-.168zM11 53c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm28 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 0c-.523 0-.96.406-1 .93V54c0 .523.406.96.93 1H69c.55 0 1-.45 1-1s-.45-1-1-1zm-45.25 2.262a1 1 0 10.691 1.707 1 1 0 00-.691-1.707zm32.527.004a.972.972 0 00-.722.293 1 1 0 101.414 0 .98.98 0 00-.692-.293zM11 57c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm58 0c-.523 0-.96.406-1 .93V58c0 .523.406.96.93 1H69c.55 0 1-.45 1-1s-.45-1-1-1zm-48 1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm38 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-6.207.121a1.02 1.02 0 00-.57.172.995.995 0 00-.274 1.383 1 1 0 101.66-1.11.995.995 0 00-.816-.445zm-25.55.004c-.34-.008-.661.16-.852.441-.305.461-.18 1.079.277 1.387a.997.997 0 001.387-.277.995.995 0 00-.813-1.551zm3.976 2.125a.99.99 0 00-.942.613.997.997 0 00.54 1.309 1.003 1.003 0 001.308-.543.999.999 0 00-.906-1.379zm17.593 0a.999.999 0 00-.934 1.379c.212.512.798.754 1.31.543.507-.211.75-.797.539-1.309a.997.997 0 00-.914-.613zM12 61c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm44 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 0c-.523 0-.96.406-1 .93V62c0 .523.406.96.93 1H68c.55 0 1-.45 1-1s-.45-1-1-1zm-32.457.559a1.008 1.008 0 00-1.012.804.996.996 0 00.153.75.998.998 0 101.664-1.11.997.997 0 00-.805-.444zm8.95 0a.998.998 0 00-.984 1.195.998.998 0 001.175.785.998.998 0 00.785-1.176c-.094-.465-.5-.8-.977-.804zM40 62c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-26 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm52 0c-.523 0-.96.406-1 .93V66c0 .523.406.96.93 1H66c.55 0 1-.45 1-1s-.45-1-1-1zm-48 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm44 0c-.523 0-.96.406-1 .93V68c0 .523.406.96.93 1H62c.55 0 1-.45 1-1s-.45-1-1-1zm-40 1c-.523 0-.96.406-1 .93V69c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V69c0 .523.406.96.93 1H26c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V69c0 .523.406.96.93 1H30c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V69c0 .523.406.96.93 1H34c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V69c0 .523.406.96.93 1H38c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V69c0 .523.406.96.93 1H42c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V69c0 .523.406.96.93 1H46c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V69c0 .523.406.96.93 1H50c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V69c0 .523.406.96.93 1H54c.55 0 1-.45 1-1s-.45-1-1-1zm4 0c-.523 0-.96.406-1 .93V69c0 .523.406.96.93 1H58c.55 0 1-.45 1-1s-.45-1-1-1z"
  }));
};
SvgPlaceholder.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$O = ["title", "titleId"];
var SvgPlanner = function SvgPlanner(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$O);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24 4H6a2 2 0 00-2 2v18a2 2 0 002 2h18a2 2 0 002-2V6a2 2 0 00-2-2zM7 23a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm4 4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm4 8a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm4 8a1 1 0 110-2 1 1 0 010 2zm0-3.5a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0119 19.5zM18 14a1 1 0 112 0 1 1 0 01-2 0zm5 5a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm1-5H6V6h18v4z"
  }));
};
SvgPlanner.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$N = ["title", "titleId"];
var SvgPlayCircle = function SvgPlayCircle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$N);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 3C8.373 3 3 8.373 3 15s5.373 12 12 12 12-5.373 12-12S21.627 3 15 3zm5.304 12.402l-7.608 4.392c-.383.221-.696.04-.696-.402v-8.785c0-.442.313-.623.696-.402l7.608 4.392c.383.222.383.584 0 .805z"
  }));
};
SvgPlayCircle.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$M = ["title", "titleId"];
var SvgPlus = function SvgPlus(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$M);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.97 2.973A2 2 0 0013 5v8H5a2 2 0 100 4h8v8a2 2 0 104 0v-8h8a2 2 0 100-4h-8V5a2 2 0 00-2.03-2.027z"
  }));
};
SvgPlus.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$L = ["title", "titleId"];
var SvgPostgresql = function SvgPostgresql(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$L);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13 2C9.281 2 8.316 4.828 7.992 6.469 8.438 6.277 9.535 6 10 6h.02c1.144.008 1.5.332 1.73 1.39.168.778.254 1.989.25 2.61-.004 1.36-.332 2.297-.574 2.926l-.078.203c-.059.168-.13.324-.192.469-.062.152-.117.285-.156.402.242.055.434.133.563.188l.074.035c.023.011.047.02.066.035.426.258.297.851.297 1.32 0 .39.012 1.945 0 3.426.043.64.207 1.18.348 1.574.207.555.672 1.379 1.652 1.422.773.035 1.89-.371 2-1.996v-4c.074-1.336 1.605-1.867 2-2.16-.055-.074-.266-.727-.488-1.074l-.043-.082c-.032-.079-.114-.22-.215-.407-.59-1.07-1.824-3.816-.98-5.222C16.64 6.44 17 6.086 18 6c-.406-1.16-1.531-3.941-5-4zM6.437 2C4.567 2.07 2 3.23 2 7.012 2 9.574 3.742 17 6.492 17c.125 0 .25-.043.38-.11-.243-.21-.419-.484-.442-.843-.043-.727.484-1.238 1.62-1.527.055-.008.345-.094.981-.454-.336-.144-.687-.34-.976-.64-.793-.828-1.196-1.989-1.047-3.031.14-1.016.058-2.012.015-2.543L7.02 7.8l-.012-.176-.024-.367.032-.985C7.34 4.61 8.02 3.32 9 2.43c-.742-.243-1.676-.461-2.563-.43zm10.497.004c-.192.004-.372.02-.547.039 1.004.7 1.925 1.828 2.554 3.629l.043 1.375c.004.047.012.094.02.14.031.172.07.407.039.688-.04.32-.078.648-.09.977-.008.324.035.64.082.976a4.33 4.33 0 01-.148 1.852l-.293 1.008c.078.171.152.347.226.53.016.048.032.083.043.114l.328.453C20.957 12.23 22 8.977 22 5.625c0-.648-.176-1.148-.402-1.438-1.34-1.714-3.196-2.207-4.664-2.183zM10 7c-.281 0-1.25.23-1.617.387l-.36.152a.104.104 0 00-.02.024c.005.054.013.12.02.203.043.574.13 1.64-.027 2.77-.105.741.195 1.585.785 2.198.336.352.938.582 1.375.68l.082-.207c.055-.133.117-.273.176-.43l.078-.21A6.805 6.805 0 0011 9.996a14.893 14.893 0 00-.129-1.813c-.012.015-.02.015-.027.035-.149.148-.38.281-.633.242-.414-.066-.73-.57-.711-.758.023-.183.379-.281.793-.215.14.024.273.067.383.114.039.03.07.05.105.074-.004-.024-.004-.051-.011-.074-.094-.442-.172-.524-.176-.528-.004-.004-.11-.07-.594-.074zm7.984.012c-.484.058-.62.187-.797.472.34 0 .586.114.614.325.027.18-.125.351-.192.418a.878.878 0 01-.492.242c-.031.008-.062.008-.097.008-.008 0-.012-.004-.02-.004.059.824.43 1.937.926 2.93.137-.477.191-.942.12-1.434-.05-.364-.105-.739-.093-1.149.016-.37.055-.718.094-1.058.031-.262-.07-.504-.063-.75zm2.196 7.52a.972.972 0 00-.32.023c-.63.129-1.047.164-1.356.144-.11.074-.223.145-.363.223-.563.308-1.063.629-1.13 1.078v.582c.66.031 1.544-.379 2.052-.613.957-.442 1.675-1.364 1.117-1.438zm-10.344.23c-.55.328-1.172.652-1.586.738-1.469.39-.559.848-.04.898.556.137 1.915.446 2.79-.27v-.55c0-.105.004-.21.012-.324 0-.059.004-.137.004-.207a1.935 1.935 0 00-.239-.074z"
  }));
};
SvgPostgresql.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$K = ["title", "titleId"];
var SvgPreferences = function SvgPreferences(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$K);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20 4c-1.293 0-2.395.843-2.813 2H4a1 1 0 100 2h13.188c.417 1.157 1.519 2 2.812 2s2.395-.843 2.813-2H26a1 1 0 100-2h-3.188C22.395 4.843 21.294 4 20 4zm0 2c.544 0 .958.409.988.943a1 1 0 000 .116A.978.978 0 0120 8a.978.978 0 01-.988-.943 1 1 0 000-.116A.978.978 0 0120 6zm-8 6c-1.293 0-2.395.843-2.813 2H4a1 1 0 100 2h5.188c.417 1.157 1.519 2 2.812 2s2.395-.843 2.813-2H26a1 1 0 100-2H14.812c-.417-1.157-1.519-2-2.812-2zm0 2c.544 0 .958.409.988.943a1 1 0 000 .116A.978.978 0 0112 16a.978.978 0 01-.988-.943 1 1 0 000-.116A.978.978 0 0112 14zm4 6c-1.293 0-2.395.843-2.813 2H4a1 1 0 100 2h9.188c.417 1.157 1.519 2 2.812 2s2.395-.843 2.813-2H26a1 1 0 100-2h-7.188c-.417-1.157-1.519-2-2.812-2zm0 2c.544 0 .958.409.988.943a1 1 0 000 .116A.978.978 0 0116 24a.978.978 0 01-.988-.943 1 1 0 000-.116A.978.978 0 0116 22z"
  }));
};
SvgPreferences.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$J = ["title", "titleId"];
var SvgPresentation = function SvgPresentation(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$J);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2 3a1 1 0 100 2h26a1 1 0 100-2H2zm0 4v15a2 2 0 002 2h10v1.271A2 2 0 0013 27a2 2 0 002 2 2 2 0 002-2 2 2 0 00-1-1.73V24h10a2 2 0 002-2V7H2zm9 3a4 4 0 014 4h-4v-4zm-2 2v4h4a4 4 0 11-4-4zm10 0h5a1 1 0 010 2h-5a1 1 0 010-2zm0 4h5a1 1 0 010 2h-5a1 1 0 010-2z"
  }));
};
SvgPresentation.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$I = ["title", "titleId"];
var SvgProcessImprovement = function SvgProcessImprovement(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$I);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.031 3.281c-.38-.04-.689.16-.879.46-.19.29-.21.67-.05.98l.441.89a11.964 11.964 0 00-4.541 9.391c0 1.02.14 2 .37 2.93.12.54.66.88 1.2.76.54-.12.88-.662.76-1.202-.01-.01-.01-.029-.02-.049-.2-.79-.31-1.599-.31-2.439 0-3.02 1.34-5.72 3.46-7.55l.27.55c.06.13.16.238.26.318.15.13.34.21.54.23.03.01.06.01.09.01.31 0 .61-.15.8-.4l1.08-1.43 1.22-1.609a1 1 0 00-.68-1.7h-.01l-4-.14zm9.942.14c-.55.01-.99.46-.98 1.01 0 .45.3.84.73.96 3.6 1.02 6.38 3.99 7.09 7.71l-.622-.03a.838.838 0 00-.388.06c-.19.07-.36.18-.48.36a1 1 0 00-.11.96l.709 1.68.75 1.78c.1.54.63.89 1.17.78a.96.96 0 00.66-.46l.01-.01.01-.02 2.11-3.38a.98.98 0 00.05-.98c-.17-.32-.48-.52-.83-.54l-.99-.07c-.69-4.69-4.1-8.5-8.59-9.77a.94.94 0 00-.3-.04zm-2.971 4.57c-1.49 0-2.87.461-4 1.261-.61.42-1.15.939-1.59 1.539-.7.92-1.17 2.01-1.33 3.2-.06.32-.08.66-.08 1 0 3.87 3.13 7 7 7s7-3.13 7-7a6.98 6.98 0 00-6.01-6.92c-.32-.06-.65-.08-.99-.08zm0 3c.17 0 .34.04.48.13.31.16.52.49.52.87v2h2c.55 0 1 .45 1 1s-.45 1-1 1h-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2h-2c-.55 0-1-.45-1-1s.45-1 1-1h2v-2c0-.55.45-1 1-1zm7.697 10.888a.995.995 0 00-.717.271c-.01 0-.01.012-.02.022a9.949 9.949 0 01-6.96 2.83c-1.15 0-2.24-.2-3.27-.56l.34-.51c.08-.11.12-.241.15-.371.03-.2.02-.41-.07-.6a.991.991 0 00-.78-.57l-1.81-.23-1.95-.25h-.01a.917.917 0 00-.29-.03c-.55.01-.99.46-.98 1.01 0 .16.04.32.12.46v.01l1.88 3.54c.17.31.48.51.84.53h.05c.33 0 .64-.17.83-.45l.55-.83c1.36.54 2.84.851 4.4.851 3.24 0 6.2-1.3 8.35-3.4a.988.988 0 00.04-1.41.98.98 0 00-.693-.313z"
  }));
};
SvgProcessImprovement.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$H = ["title", "titleId"];
var SvgProcess = function SvgProcess(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$H);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 3c-.365 0-.71.023-1.037.05a1 1 0 00.17 1.995c.3-.026.59-.045.867-.045a9.93 9.93 0 016.547 2.453L19 10h6V4l-2.04 2.04A11.951 11.951 0 0015 3zM4 5l2.04 2.04A11.951 11.951 0 003 15c0 .365.023.71.05 1.037a1 1 0 001.995-.17C5.019 15.567 5 15.277 5 15a9.93 9.93 0 012.453-6.547L10 11V5H4zm21.95 8.033a1 1 0 00-.995 1.1c.026.3.045.59.045.867a9.93 9.93 0 01-2.453 6.547L20 19v6h6l-2.04-2.04A11.951 11.951 0 0027 15c0-.365-.023-.71-.05-1.037a1 1 0 00-1-.93zM5 20v6l2.04-2.04A11.951 11.951 0 0015 27c.365 0 .71-.023 1.037-.05a1 1 0 00-.17-1.995c-.3.026-.59.045-.867.045a9.93 9.93 0 01-6.547-2.453L11 20H5z"
  }));
};
SvgProcess.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$G = ["title", "titleId"];
var SvgProductStar = function SvgProductStar(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$G);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M27 8V6a2 2 0 00-2-2H5a2 2 0 00-2 2v2h24zM4 10v14a2 2 0 002 2h18a2 2 0 002-2V10H4zm16.047 6.297l-2.638 1.964.98 3.139c.1.322-.155.6-.441.6a.45.45 0 01-.265-.087L15 20.011l-2.683 1.902a.453.453 0 01-.265.087.462.462 0 01-.441-.6l.98-3.139-2.638-1.964a.46.46 0 01.27-.83l3.288-.038 1.053-3.115c.071-.209.253-.314.436-.314s.365.105.436.314l1.053 3.115 3.288.038a.46.46 0 01.27.83z"
  }));
};
SvgProductStar.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$F = ["title", "titleId"];
var SvgPulse = function SvgPulse(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$F);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.986 2a1 1 0 00-.941.701L9.844 16.146 8.68 13.49v-.002c-.814-1.858-3.577-1.93-4.485-.115L3.883 14H2a1 1 0 100 2h2.5a1 1 0 00.895-.553l.59-1.18c.212-.424.672-.412.863.024l2.236 5.11a1 1 0 001.871-.102L14.43 8.184l1.574 18.9a1 1 0 001.92.3L22.666 16h2.605A2 2 0 0027 17a2 2 0 002-2 2 2 0 00-2-2 2 2 0 00-1.73 1H22a1 1 0 00-.924.615l-3.422 8.211-1.658-19.91A1 1 0 0014.986 2z"
  }));
};
SvgPulse.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$E = ["title", "titleId"];
var SvgPunch = function SvgPunch(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$E);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16 4c-1 0-1.771.407-2.281.797a1.965 1.965 0 01-1.68.334A4.293 4.293 0 0011 5c-1.228 0-1.98.625-2.426 1.25-.437.613-1.202.909-1.947.797A4.23 4.23 0 006 7c-1.559 0-3 1.348-3 3.639v7.865c0 2.129 1.215 2.498 2 2.498.785 0 2-.37 2-2.264v-6.24a.5.5 0 011 .002v5.768c0 1.699.774 2.73 2 2.73s2-.858 2-2.73V11.5a.5.5 0 011 0v6.768C13 20.255 14.396 21 15.5 21s2.5-.754 2.5-2.732V11.5a.5.5 0 011 0v6.768C19 20.31 20.135 21 21.236 21c1.038 0 2.242-.685 2.616-2.818.374-2.133 1.148-6.26 1.148-9.246C25 5.975 23.102 5 22 5c-.677 0-1.258.095-1.707.205a2.042 2.042 0 01-1.715-.324C18.014 4.46 17.135 4 16 4zm10 9s.037 1.324-.71 2.734c-.127.767-.252 1.478-.358 2.077l-.096.543c-.47 2.689-2.168 3.646-3.6 3.646-1.024 0-2.166-.46-2.783-1.637C17.8 21.443 16.646 22 15.5 22c-.081 0-.161-.023-.242-.03A2.347 2.347 0 0015 23v1a1 1 0 001 1s1.537-.424 3.025-.424 2.742.424 3.913.424c1.035 0 1.798-1.34 2.523-2.168.725-.828 1.537-1.78 1.537-2.736C26.998 17.589 26 13 26 13z"
  }));
};
SvgPunch.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$D = ["title", "titleId"];
var SvgQuoteLeft = function SvgQuoteLeft(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$D);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.486 5a.996.996 0 00-.8.402l-4.291 5.764A2.003 2.003 0 003 12.359v4.668a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-2-2H5.99l3.3-4.431A1 1 0 008.485 5zm9.98 0a1 1 0 00-.802.402l-4.27 5.737A2 2 0 0013 12.332V17a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-2-2h-3.01l3.28-4.402A1 1 0 0018.467 5z"
  }));
};
SvgQuoteLeft.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$C = ["title", "titleId"];
var SvgQuoteRight = function SvgQuoteRight(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$C);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 4.973a2 2 0 00-2 2v4a2 2 0 002 2h3.01l-3.3 4.431a1 1 0 001.604 1.194l4.291-5.764c.256-.345.395-.763.395-1.193V6.973a2 2 0 00-2-2h-4zM5 5a2 2 0 00-2 2v4a2 2 0 002 2h3.01l-3.28 4.402a1 1 0 001.606 1.196l4.27-5.737A2 2 0 0011 11.668V7a2 2 0 00-2-2H5z"
  }));
};
SvgQuoteRight.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$B = ["title", "titleId"];
var SvgRemoteDba = function SvgRemoteDba(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$B);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 2C10 2 4 6 4 13v5c0 1.517.664 2.597 1.342 3.19.413.361.586.367.863.476C6.568 22.605 8.891 28 15 28c.034 0 .066-.004.1-.004a1 1 0 00.007 0c2.29-.026 4.117-.867 5.516-1.996H15c-5.333 0-7.05-5.316-7.05-5.316l-.175-.522-.533-.133s-.261-.061-.584-.343C6.336 19.403 6 18.983 6 18v-1h1c0-7 10-2 13-9 0 0 3 2.76 3 9v3h.818A2.974 2.974 0 0121 22h-4.092c-.206-.581-.756-1-1.408-1h-1a1.5 1.5 0 000 3h1a1.5 1.5 0 00.262-.027A1 1 0 0016 24h5c2.491 0 4.567-1.85 4.936-4.242A1.99 1.99 0 0027 18v-1a1.99 1.99 0 00-1-1.723V13c0-4-2-9-6-9 0 0-1-2-5-2z"
  }));
};
SvgRemoteDba.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$A = ["title", "titleId"];
var SvgReplication = function SvgReplication(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$A);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 4a2 2 0 00-2 2v2a2 2 0 002 2h18a2 2 0 002-2V6a2 2 0 00-2-2H6zm1 2a1 1 0 110 2 1 1 0 010-2zm-1 6a2 2 0 00-2 2v2a2 2 0 002 2h18a2 2 0 002-2v-2a2 2 0 00-2-2H6zm1 2a1 1 0 110 2 1 1 0 010-2zm-1 6a2 2 0 00-2 2v2a2 2 0 002 2h18a2 2 0 002-2v-2a2 2 0 00-2-2H6zm1 2a1 1 0 110 2 1 1 0 010-2z"
  }));
};
SvgReplication.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$z = ["title", "titleId"];
var SvgRocket = function SvgRocket(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$z);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 2S9 6 9 15c0 .159.014.318.023.477C7.99 16.313 6 18.104 6 19.545 6 21.364 7.818 25 7.818 25l3.301-4.127L12 23h6l.88-2.127L22.183 25S24 21.364 24 19.545c0-1.441-1.99-3.232-3.023-4.068.01-.159.023-.318.023-.477 0-9-6-13-6-13zm0 7a2 2 0 11.001 3.999A2 2 0 0115 9zm-2.582 15c-.259.334-.418.718-.418 1.133C12 27.036 15 29 15 29s3-1.938 3-3.867c0-.415-.158-.798-.416-1.133h-.846c.018.077.063.146.063.227 0 1.359-1.801 2.039-1.801 2.039s-1.8-.68-1.8-2.04c0-.08.044-.149.062-.226h-.844z"
  }));
};
SvgRocket.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$y = ["title", "titleId"];
var SvgRss = function SvgRss(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$y);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM7.5 18a1.5 1.5 0 11.001-3.001A1.5 1.5 0 017.5 18zm5.5 0a1 1 0 01-1-1 5 5 0 00-5-5 1 1 0 010-2 7 7 0 017 7 1 1 0 01-1 1zm4 0a1 1 0 01-1-1 9 9 0 00-9-9 1 1 0 010-2c6.075 0 11 4.925 11 11a1 1 0 01-1 1z"
  }));
};
SvgRss.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$x = ["title", "titleId"];
var SvgSearch = function SvgSearch(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$x);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13 3C7.489 3 3 7.489 3 13s4.489 10 10 10a9.947 9.947 0 006.322-2.264l5.971 5.971a1 1 0 101.414-1.414l-5.97-5.97A9.947 9.947 0 0023 13c0-5.511-4.489-10-10-10zm0 2c4.43 0 8 3.57 8 8s-3.57 8-8 8-8-3.57-8-8 3.57-8 8-8z"
  }));
};
SvgSearch.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$w = ["title", "titleId"];
var SvgSecurityConfig = function SvgSecurityConfig(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$w);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 3c-4.602 0-9.389 1.037-9.389 1.037l-.004.004A2 2 0 004 6v6c0 10.398 10.021 14.744 10.021 14.744A2 2 0 0015 27a2 2 0 00.975-.256h.004S26 22.398 26 12V6a2 2 0 00-1.611-1.963S19.602 3 15 3zm-.361 3h.722a.25.25 0 01.248.223l.03.256a.757.757 0 00.603.654c.21.044.416.099.617.164a.758.758 0 00.85-.264l.152-.207a.248.248 0 01.326-.066l.625.36c.11.063.157.2.106.317l-.107.24a.758.758 0 00.197.868c.157.142.305.291.447.45a.76.76 0 00.87.194l.24-.105a.25.25 0 01.316.104l.361.626a.25.25 0 01-.068.327l-.205.152a.759.759 0 00-.266.85c.065.2.12.405.164.615.068.322.326.57.654.605l.256.028a.25.25 0 01.223.248v.722a.25.25 0 01-.223.248l-.256.028a.758.758 0 00-.654.605 6.05 6.05 0 01-.164.615.759.759 0 00.266.85l.205.152a.249.249 0 01.068.327l-.361.627a.25.25 0 01-.317.103l-.24-.105a.76.76 0 00-.869.195c-.142.157-.29.307-.447.45a.758.758 0 00-.197.866l.105.24a.252.252 0 01-.104.319l-.626.36a.25.25 0 01-.327-.067l-.15-.207a.757.757 0 00-.85-.264c-.2.065-.407.12-.617.164a.756.756 0 00-.603.654l-.03.256a.249.249 0 01-.248.223h-.722a.25.25 0 01-.248-.223l-.03-.256a.757.757 0 00-.603-.654 6.087 6.087 0 01-.617-.164.758.758 0 00-.85.264l-.15.207a.248.248 0 01-.327.066l-.627-.36a.252.252 0 01-.103-.317l.105-.24a.758.758 0 00-.197-.868 6.115 6.115 0 01-.447-.45.76.76 0 00-.87-.194l-.24.105a.25.25 0 01-.316-.104l-.361-.626a.25.25 0 01.068-.327l.205-.152a.759.759 0 00.266-.85 5.981 5.981 0 01-.164-.615.758.758 0 00-.654-.605l-.256-.028A.249.249 0 018 13.361v-.722c0-.127.095-.233.264-.252l.215-.026a.757.757 0 00.654-.605c.044-.21.099-.414.164-.615a.762.762 0 00-.266-.852l-.205-.15a.25.25 0 01-.068-.326l.361-.627a.25.25 0 01.317-.104l.24.105a.76.76 0 00.869-.195c.142-.157.29-.307.447-.449a.758.758 0 00.197-.867l-.107-.24a.253.253 0 01.105-.319l.626-.36a.25.25 0 01.326.067l.152.207a.758.758 0 00.85.264c.2-.065.407-.12.617-.164a.755.755 0 00.603-.654l.03-.256A.249.249 0 0114.639 6zM15 9a4 4 0 100 8 4 4 0 000-8zm0 3a1 1 0 110 2 1 1 0 010-2z"
  }));
};
SvgSecurityConfig.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$v = ["title", "titleId"];
var SvgSecurity = function SvgSecurity(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$v);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 3c-4.602 0-9.389 1.037-9.389 1.037l-.004.004A2 2 0 004 6v6c0 10.398 10.021 14.744 10.021 14.744A2 2 0 0015 27a2 2 0 00.975-.256h.004S26 22.398 26 12V6a2 2 0 00-1.611-1.963S19.602 3 15 3zm6 6a.999.999 0 01.707 1.707l-7.56 7.56a1 1 0 01-1.415 0L9.28 14.815a.999.999 0 111.414-1.414l2.746 2.746 6.854-6.853A.996.996 0 0121 9z"
  }));
};
SvgSecurity.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$u = ["title", "titleId"];
var SvgServicesSupport = function SvgServicesSupport(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$u);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.781 2a1 1 0 00-.97.758l-.15.603c-.12.477-.504.825-.98.951-.004.002-.01.003-.017.004-.475.128-.98.02-1.322-.334l-.434-.447a1 1 0 00-1.219-.172l-.378.219a1.001 1.001 0 00-.461 1.143l.168.591c.135.473-.024.966-.372 1.313l-.017.017c-.347.348-.84.507-1.313.372l-.591-.168a1.002 1.002 0 00-1.143.46l-.219.38a1 1 0 00.172 1.218l.447.434c.354.342.462.849.334 1.324l-.003.016c-.127.475-.475.858-.952.978l-.603.152a.998.998 0 00-.758.97v.437a1 1 0 00.758.97l.603.15c.477.12.825.504.951.98.002.004.003.01.004.017.128.475.02.98-.334 1.322l-.447.434a1 1 0 00-.172 1.219l.219.38c.229.397.702.588 1.143.461l.591-.17c.473-.135.966.025 1.313.373l.016.016c.348.347.508.84.373 1.313l-.17.591c-.126.441.064.914.46 1.143l.381.219a1 1 0 001.22-.172l.43-.447c.343-.354.85-.462 1.325-.334l.016.003c.113.03.218.075.318.13V18.65A5.996 5.996 0 0113 7a6 6 0 016 6h5v-.219a1 1 0 00-.758-.97l-.603-.15c-.477-.12-.825-.504-.951-.98-.002-.004-.003-.01-.004-.017-.128-.475-.02-.98.334-1.322l.447-.434a1 1 0 00.172-1.219l-.219-.38a1.001 1.001 0 00-1.143-.461l-.591.17c-.473.135-.966-.025-1.313-.373l-.016-.016c-.348-.347-.508-.84-.373-1.313l.17-.591a1.002 1.002 0 00-.46-1.143l-.381-.219a1 1 0 00-1.22.172l-.433.447c-.342.354-.847.462-1.322.334l-.018-.003c-.475-.127-.858-.475-.978-.952l-.15-.603A1 1 0 0013.218 2h-.438zM13 10a3 3 0 00-1.695 5.473A3.998 3.998 0 0115 13h1a3 3 0 00-3-3zm2 5c-1.093 0-2 .907-2 2v9a1 1 0 001 1h12a1 1 0 001-1v-9c0-1.093-.907-2-2-2H15zm0 3h10v7H15v-7zm4.98.99a1 1 0 00-.687.303L18 20.586l-.293-.293a1 1 0 10-1.414 1.414l1 1a1 1 0 001.414 0l2-2a1 1 0 00-.727-1.717z"
  }));
};
SvgServicesSupport.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$t = ["title", "titleId"];
var SvgSmallDashboard = function SvgSmallDashboard(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$t);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2C1.677 2 1 2.677 1 3.5v9c0 .823.677 1.5 1.5 1.5h11c.823 0 1.5-.677 1.5-1.5v-9c0-.823-.677-1.5-1.5-1.5h-11zm0 1h11c.281 0 .5.219.5.5V4H2v-.5c0-.281.219-.5.5-.5zM2 5h12v7.5c0 .281-.219.5-.5.5h-11a.493.493 0 01-.5-.5V5zm1.5 2a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-3zM8 7v1h5V7H8zM4 8h2v3H4V8zm4 1v1h5V9H8zm0 2v1h5v-1H8z"
  }));
};
SvgSmallDashboard.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$s = ["title", "titleId"];
var SvgSmallMigration = function SvgSmallMigration(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$s);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2A2.507 2.507 0 002 4.5V6h1V4.5C3 3.664 3.664 3 4.5 3h7c.836 0 1.5.664 1.5 1.5V6h-2l2.5 2.5L16 6h-2V4.5C14 3.125 12.875 2 11.5 2zm-2 5.5L0 10h2v1.5C2 12.875 3.125 14 4.5 14h7c1.375 0 2.5-1.125 2.5-2.5V10h-1v1.5c0 .836-.664 1.5-1.5 1.5h-7A1.49 1.49 0 013 11.5V10h2z"
  }));
};
SvgSmallMigration.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$r = ["title", "titleId"];
var SvgSmallPartners = function SvgSmallPartners(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$r);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.625 5.195C8.735 3.985 9.668 3.996 10.352 4l.148.004L15 4V3l-4.5.004L10.36 3c-.778-.004-2.063-.02-3.47 1.516C5.97 3.988 5.149 3.992 4.64 4L1 4.004v1L4.648 5c.442-.004.965.004 1.567.297L4.816 6.91l.329.328a2.582 2.582 0 003.62.051 1.08 1.08 0 011.477-.008l1.54 1.442c.14.136.218.328.218.527 0 .21-.086.402-.246.555a.799.799 0 01-.113.093.855.855 0 01-.391.102h-.75v.32l-.016.078A.752.752 0 019.75 11H9v.324l-.016.074A.752.752 0 018.25 12H7.5v.332l-.016.066a.745.745 0 01-.398.516c-.41.203-.871.117-1.242-.242L1.98 9H1v1h.582l3.57 3.395c.43.418.957.632 1.485.632.199 0 .394-.039.586-.101l.004.011c.496-.14.894-.488 1.105-.94a1.753 1.753 0 001.5-1 1.746 1.746 0 001.5-1c.277-.013.563-.095.805-.231v.004l.008-.008c.003 0 .007-.004.011-.004v-.004c.133-.082.258-.195.285-.223.102-.094.188-.203.262-.316L13.73 9H15V8h-1.5a.513.513 0 00-.383.176l-.285.34A1.766 1.766 0 0012.477 8l-1.551-1.45a2.083 2.083 0 00-2.848.013 1.586 1.586 0 01-1.851.25z"
  }));
};
SvgSmallPartners.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$q = ["title", "titleId"];
var SvgSmallSettings = function SvgSmallSettings(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$q);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1c-.277 0-.5.223-.5.5v.781a5.51 5.51 0 00-1.125.469l-.555-.555a.512.512 0 00-.71 0L2.194 3.61a.512.512 0 000 .711l.563.555c-.2.355-.356.73-.469 1.125H1.5c-.277 0-.5.223-.5.5v2c0 .277.223.5.5.5h.781c.117.398.274.773.469 1.125l-.555.559a.507.507 0 000 .707L3.61 12.8a.505.505 0 00.711 0l.555-.555A5.51 5.51 0 006 12.715v.785c0 .277.223.5.5.5h2a.503.503 0 00.5-.5v-.781a5.509 5.509 0 001.125-.469l.559.55a.5.5 0 00.707 0l1.41-1.41a.5.5 0 000-.706l-.559-.559A5.52 5.52 0 0012.715 9h.785c.277 0 .5-.223.5-.5v-2c0-.277-.223-.5-.5-.5h-.79a5.48 5.48 0 00-.46-1.129l.55-.55a.505.505 0 000-.712l-1.41-1.414a.502.502 0 00-.706 0l-.555.555c-.352-.2-.73-.355-1.129-.473V1.5c0-.277-.223-.5-.5-.5zM7 2h1v.602c0 .238.168.441.398.492a4.34 4.34 0 011.579.656c.199.129.464.102.632-.066l.426-.426.707.707-.43.426a.513.513 0 00-.062.632c.313.465.527 1 .645 1.579.05.23.253.398.492.398H13v1h-.61a.498.498 0 00-.488.402 4.491 4.491 0 01-.66 1.567c-.133.199-.105.46.063.629l.437.437-.707.707-.437-.433a.496.496 0 00-.63-.063c-.476.313-1 .547-1.57.66a.502.502 0 00-.398.492V13H7v-.61a.498.498 0 00-.402-.488 4.491 4.491 0 01-1.567-.66.503.503 0 00-.633.067l-.433.433-.707-.707.433-.433a.503.503 0 00.067-.63 4.423 4.423 0 01-.664-1.574A.506.506 0 002.602 8H2V7h.61a.506.506 0 00.492-.398c.113-.57.343-1.098.656-1.57a.507.507 0 00-.063-.634l-.437-.433.707-.707.433.433c.168.168.43.196.63.067a4.423 4.423 0 011.574-.664A.506.506 0 007 2.602zm.586 3A2.514 2.514 0 005 7.414 2.514 2.514 0 007.414 10 2.514 2.514 0 0010 7.586 2.514 2.514 0 007.586 5zm-.031 1A1.494 1.494 0 019 7.555 1.494 1.494 0 017.445 9 1.494 1.494 0 016 7.445 1.494 1.494 0 017.555 6z"
  }));
};
SvgSmallSettings.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$p = ["title", "titleId"];
var SvgSmallSignout = function SvgSmallSignout(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$p);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 1C1.676 1 1 1.676 1 2.5v10c0 .824.676 1.5 1.5 1.5h10c.824 0 1.5-.676 1.5-1.5V10l-1 1v1.5c0 .281-.219.5-.5.5h-10a.494.494 0 01-.5-.5v-10c0-.281.219-.5.5-.5h10c.281 0 .5.219.5.5V4l1 1V2.5c0-.824-.676-1.5-1.5-1.5zm8.23 3.023l-.71.704L12.293 7H5v1h7.293l-2.273 2.27.71.71 3.477-3.48z"
  }));
};
SvgSmallSignout.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$o = ["title", "titleId"];
var SvgSmallSupport = function SvgSmallSupport(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$o);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2C2.676 2 2 2.676 2 3.5v6.863l-.836 1.453-.008.012C.668 12.808 1.406 14 2.5 14h11c1.094 0 1.832-1.191 1.344-2.172l-.012-.012L14 10.363V3.5c0-.824-.676-1.5-1.5-1.5zm0 1h9c.281 0 .5.219.5.5V10H3V3.5c0-.281.219-.5.5-.5zm-.71 8h10.42l.74 1.281a.486.486 0 01-.45.719h-11c-.39 0-.621-.371-.445-.719v-.004z"
  }));
};
SvgSmallSupport.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$n = ["title", "titleId"];
var SvgSmallTraining = function SvgSmallTraining(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$n);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1 2v1h13V2zm0 2v9h6v2h1v-2h6V4zm1 1h11v7H2zm3 1c-1.098 0-2 .902-2 2 0 1.098.902 2 2 2 1.098 0 2-.902 2-2 0-1.098-.902-2-2-2zm0 1v1h1c0 .559-.441 1-1 1-.559 0-1-.441-1-1 0-.559.441-1 1-1zm3 0v1h4V7zm0 2v1h3V9z"
  }));
};
SvgSmallTraining.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$m = ["title", "titleId"];
var SvgSpeed = function SvgSpeed(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$m);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M27.879 15.203c-.78-5.815-5.536-10.459-11.366-11.117C8.656 3.199 2 9.322 2 17c0 3.133 1.112 6.005 2.959 8.249.387.47.959.751 1.568.751h16.956c.569 0 1.125-.229 1.49-.665 2.24-2.676 3.425-6.266 2.906-10.132zM19.134 7.84a1 1 0 111.732 1.001 1 1 0 01-1.732-1.001zM15 6a1 1 0 110 2 1 1 0 010-2zM4 17a1 1 0 112 0 1 1 0 01-2 0zm2.84 5.866a1 1 0 11-1-1.733 1 1 0 011 1.733zM7.206 12.5a1 1 0 11-1.732-1.001A1 1 0 017.206 12.5zM10.5 9.206a1 1 0 11-1-1.733 1 1 0 011 1.733zM13.268 18A2 2 0 0114 15.268c.601-.347 5.194-2.087 8.525-3.332.668-.25 1.174.626.623 1.08-2.744 2.262-6.547 5.37-7.148 5.717A2 2 0 0113.268 18zm11.258 4.5a1 1 0 11-1.732-1.001 1 1 0 011.732 1.001zM25 18a1 1 0 110-2 1 1 0 010 2z"
  }));
};
SvgSpeed.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$l = ["title", "titleId"];
var SvgSpinner = function SvgSpinner(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$l);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 8 8",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    fill: "none",
    d: "M4 7.5A3.5 3.5 0 10.5 4"
  }));
};
SvgSpinner.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$k = ["title", "titleId"];
var SvgSql = function SvgSql(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$k);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3 5c-1.093 0-2 .907-2 2v11c0 1.093.907 2 2 2h18c1.093 0 2-.907 2-2V7c0-1.093-.907-2-2-2H3zm0 2h18v11H3V7zm9 3c-1.833.029-2 1.779-2 2.129v.807c0 .342-.032 2.018 2.008 2.06.348.008.618-.06.855-.152l.69 1.379.894-.446-.789-1.58c.31-.5.342-1.078.342-1.26v-.808c0-.35-.136-2.159-2-2.129zm3 0v5h3v-1h-2v-4h-1zm-7.355.002c-.894-.025-1.539.482-1.526 1.36.015.973.838 1.28 1.358 1.53.37.179.719.398.697.764-.014.218-.103.511-.51.545-.677.055-.69-.656-.69-.803H6c0 .277.105 1.619 1.664 1.602 1.433-.015 1.488-1.136 1.486-1.35-.009-1.008-1.115-1.502-1.34-1.584-.106-.048-.691-.258-.72-.699-.03-.483.364-.56.539-.56.576 0 .559.596.559.699h.966c0-.221-.086-1.463-1.51-1.504zm4.357.82c.886-.019.998 1.067.998 1.3v.816c0 .22-.166 1.227-.988 1.242-.857.017-1.012-1.02-1.012-1.242v-.817c0-.232.057-1.28 1.002-1.299z"
  }));
};
SvgSql.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$j = ["title", "titleId"];
var SvgStack = function SvgStack(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$j);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.018 4a1 1 0 00-.313.045l-13 4a1 1 0 00-.111 1.87l9 4a1 1 0 00.7.04l13-4a1 1 0 00.112-1.87l-9-4A1 1 0 0017.018 4zm-.082 2.066l6.218 2.764-10.09 3.104L6.846 9.17l10.09-3.104zm9.07 5.924a1 1 0 00-.3.055l-12.642 3.889-8.658-3.848a1 1 0 00-.386-.092 1 1 0 00-.426 1.92l9 4a1 1 0 00.7.041l13-4a1 1 0 00-.288-1.965zm0 4a1 1 0 00-.3.055l-12.642 3.889-8.658-3.848a1 1 0 00-.386-.092 1 1 0 00-.426 1.92l9 4a1 1 0 00.7.041l13-4a1 1 0 00-.288-1.965zm0 4a1 1 0 00-.3.055l-12.642 3.889-8.658-3.848a1 1 0 00-.386-.092 1 1 0 00-.426 1.92l9 4a1 1 0 00.7.041l13-4a1 1 0 00-.288-1.965z"
  }));
};
SvgStack.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$i = ["title", "titleId"];
var SvgStar = function SvgStar(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$i);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.765 2.434l2.875 8.512 8.983.104c.773.009 1.093.994.473 1.455l-7.207 5.364 2.677 8.576c.23.738-.607 1.346-1.238.899L15 22.147l-7.329 5.196c-.63.447-1.468-.162-1.238-.899l2.677-8.576-7.207-5.364c-.62-.461-.3-1.446.473-1.455l8.983-.104 2.875-8.512c.248-.732 1.284-.732 1.531.001z"
  }));
};
SvgStar.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$h = ["title", "titleId"];
var SvgStopwatch = function SvgStopwatch(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$h);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14 2a1 1 0 00-1 1v1.19C7.881 5.13 4 9.608 4 15c0 6.075 4.925 11 11 11s11-4.925 11-11c0-5.391-3.881-9.869-9-10.81V3a1 1 0 00-1-1h-2zm8.99 1.99a1 1 0 00-.697 1.717l1 1a1 1 0 101.414-1.414l-1-1a1 1 0 00-.717-.303zM15 6a1 1 0 011 1v6.277c.595.346 1 .984 1 1.723 0 .738-.405 1.376-1 1.723V19h-2v-2.277A1.99 1.99 0 0113 15c0-.738.405-1.376 1-1.723V7a1 1 0 011-1z"
  }));
};
SvgStopwatch.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$g = ["title", "titleId"];
var SvgStore = function SvgStore(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$g);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 3a2 2 0 00-2 2v1l-3 4a2 2 0 104 0l2-4h3l-1 4a2 2 0 104 0V6h4v4a2 2 0 104 0l-1-4h3l2 4a2 2 0 104 0l-3-4V5a2 2 0 00-2-2H6zm7 10.443A3.96 3.96 0 0111 14a3.95 3.95 0 01-1.994-.555A3.957 3.957 0 017 14c-.727 0-1.4-.21-1.988-.55A3.965 3.965 0 013 14v11a2 2 0 002 2h12V17h6v10h2a2 2 0 002-2V14c-.734 0-1.42-.204-2.012-.55-.588.34-1.261.55-1.988.55a3.957 3.957 0 01-2.006-.555A3.95 3.95 0 0119 14a3.96 3.96 0 01-2-.557A3.96 3.96 0 0115 14a3.96 3.96 0 01-2-.557zM7 17h6v6H7v-6z"
  }));
};
SvgStore.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$f = ["title", "titleId"];
var SvgSubset = function SvgSubset(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$f);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 2a1 1 0 00-1 1v10a1 1 0 001 1h7v10.832a1 1 0 000 .326V42a1 1 0 001 1h13v4a1 1 0 001 1h16a1 1 0 001-1V37a1 1 0 00-1-1H28a1 1 0 00-1 1v4H15V26h12v4a1 1 0 001 1h16a1 1 0 001-1V20a1 1 0 00-1-1H28a1 1 0 00-1 1v4H15V14h7a1 1 0 001-1V3a1 1 0 00-1-1H6zm1 2h14v8h-6.846a1 1 0 00-.17-.014 1 1 0 00-.144.014H7V4zm22 34h14v8H29v-3.832a1 1 0 000-.326V38z"
  }));
};
SvgSubset.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$e = ["title", "titleId"];
var SvgSupportPortal = function SvgSupportPortal(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$e);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 5C3.346 5 2 6.346 2 8v13c0 .771.3 1.468.78 2H0a3 3 0 003 3h11.338c.21-.508.52-.986.932-1.398L17.87 22H5c-.552 0-1-.449-1-1V8c0-.551.448-1 1-1h20c.552 0 1 .449 1 1v6.113c.463.08.918.201 1.361.371.244.093.454.241.639.414V8c0-1.654-1.346-3-3-3H5zm19.47 11.016a5.172 5.172 0 00-3.368 1.511c-1.442 1.441-1.335 2.993-.43 4.5l-3.988 3.989a2.335 2.335 0 003.3 3.3l3.989-3.988c1.506.905 3.058 1.012 4.5-.43a5.208 5.208 0 001.175-5.546L26.5 22.5 24 22l-.5-2.5 3.148-3.148a5.253 5.253 0 00-2.177-.336z"
  }));
};
SvgSupportPortal.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$d = ["title", "titleId"];
var SvgSupport = function SvgSupport(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$d);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.78 1a.501.501 0 00-.499.445l-.04.38a1.003 1.003 0 01-.772.863c-.103.024-.208.05-.309.08a1.001 1.001 0 01-1.092-.364l-.224-.304a.5.5 0 00-.653-.137l-.382.22a.5.5 0 00-.21.633l.157.354c.17.388.072.837-.235 1.129-.076.072-.15.146-.222.222a1.003 1.003 0 01-1.131.235l-.354-.154a.498.498 0 00-.632.207l-.221.382a.503.503 0 00.137.655l.304.224c.341.25.482.686.364 1.092a7.652 7.652 0 00-.08.307c-.098.414-.44.724-.864.771l-.379.043A.498.498 0 0012 8.78v.442c0 .255.192.47.445.498l.38.04c.422.048.763.358.86.772.026.103.053.208.083.309.118.406-.023.842-.364 1.092l-.306.224a.5.5 0 00-.137.653l.22.382a.502.502 0 00.635.21l.354-.157c.388-.17.837-.072 1.129.235.072.076.146.15.222.222.307.293.406.742.235 1.131l-.156.354a.5.5 0 00.209.632l.382.221a.5.5 0 00.653-.137l.224-.304c.25-.341.686-.482 1.092-.364.101.03.206.055.309.08.414.098.724.44.771.864l.041.379a.5.5 0 00.498.443h.442c.255 0 .47-.192.498-.445l.04-.38c.048-.422.358-.763.772-.86.103-.026.208-.054.309-.083.406-.118.842.023 1.092.364l.224.306a.5.5 0 00.653.137l.382-.22a.502.502 0 00.21-.635l-.157-.354a1.002 1.002 0 01.235-1.129c.076-.072.15-.146.222-.222a1 1 0 011.13-.235l.353.154a.501.501 0 00.634-.207l.221-.382a.503.503 0 00-.137-.655l-.306-.224a1.001 1.001 0 01-.364-1.092c.03-.101.057-.204.082-.307.098-.414.439-.724.862-.771l.38-.043A.498.498 0 0028 9.22v-.442a.501.501 0 00-.445-.498l-.38-.04a1.003 1.003 0 01-.863-.772c-.024-.103-.05-.208-.08-.309a1.001 1.001 0 01.364-1.092l.304-.224a.5.5 0 00.137-.653l-.22-.382a.5.5 0 00-.633-.21l-.354.157c-.388.17-.838.072-1.13-.235a6.677 6.677 0 00-.223-.222 1 1 0 01-.235-1.13l.156-.353a.502.502 0 00-.209-.634l-.382-.221a.5.5 0 00-.653.137l-.224.306c-.25.341-.686.482-1.092.364a7.761 7.761 0 00-.309-.082 1.001 1.001 0 01-.771-.862l-.041-.379A.498.498 0 0020.22 1h-.442zM20 5a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 10-.001 3.999A2 2 0 0020 7zM8 15a3 3 0 00-1.117.217L2 17v8l4.22-1.834a2.013 2.013 0 011.565-.018l9.065 3.704h.004A1.5 1.5 0 0017.5 27a1.5 1.5 0 00.738-.197h.006l8.986-4.992-.001-.002A1.5 1.5 0 0028 20.5a1.5 1.5 0 00-1.5-1.5 1.5 1.5 0 00-.637.145v-.002L19 22h-1.5a1.5 1.5 0 001.5-1.5 1.5 1.5 0 00-1.035-1.426v-.002l-8.694-3.79H9.26A3 3 0 008 15z"
  }));
};
SvgSupport.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$c = ["title", "titleId"];
var SvgSynchronize = function SvgSynchronize(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$c);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 3C8.913 3 3.88 7.553 3.113 13.44a1 1 0 101.983.257C5.735 8.79 9.909 5 15 5a9.924 9.924 0 017.059 2.941L20 10l6 1-1-6-1.53 1.53C21.3 4.357 18.31 3 15 3zm10.912 12.418a1 1 0 00-1.008.885C24.265 21.21 20.091 25 15 25c-3.022 0-5.701-1.35-7.535-3.465L9 20l-6-1 1 6 2.049-2.049C8.245 25.423 11.436 27 15 27c6.087 0 11.12-4.553 11.887-10.44a1 1 0 00-.975-1.142z"
  }));
};
SvgSynchronize.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$b = ["title", "titleId"];
var SvgTenYears = function SvgTenYears(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$b);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 4a2 2 0 00-2 2v18a2 2 0 002 2h18a2 2 0 002-2V6a2 2 0 00-2-2H6zm0 2h18v4H6V6zm12.188 8.309c1.812 0 2.958 1.357 2.958 3.7 0 2.325-1.133 3.725-2.959 3.725-1.83 0-2.958-1.396-2.958-3.73s1.143-3.695 2.959-3.695zm-7.553.187h1.793v7.047h-1.793v-5.43h-.092l-1.7 1.147v-1.543l1.792-1.22zm7.553 1.188c-.684 0-1.137.772-1.137 2.32 0 1.558.453 2.353 1.137 2.353.684 0 1.142-.795 1.142-2.353 0-1.547-.458-2.32-1.142-2.32z"
  }));
};
SvgTenYears.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$a = ["title", "titleId"];
var SvgTicketStar = function SvgTicketStar(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$a);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M28 12.184V7a2 2 0 00-2-2H4a2 2 0 00-2 2v5.184c1.163.413 2 1.512 2 2.816s-.837 2.403-2 2.816V23a2 2 0 002 2h22a2 2 0 002-2v-5.184c-1.163-.413-2-1.512-2-2.816s.837-2.403 2-2.816zm-7.448 1.777l-2.902 2.16 1.078 3.453a.507.507 0 01-.777.564L15 18.046l-2.951 2.092a.507.507 0 01-.777-.564l1.078-3.453-2.902-2.16a.507.507 0 01.297-.913l3.617-.042 1.158-3.427a.507.507 0 01.96 0l1.158 3.427 3.617.042a.507.507 0 01.297.913z"
  }));
};
SvgTicketStar.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$9 = ["title", "titleId"];
var SvgTicket = function SvgTicket(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$9);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24.898 3.002a2.024 2.024 0 00-.406.02L4.674 6h22.289l-.195-1.297a2 2 0 00-1.87-1.701zM4 8a2 2 0 00-2 2v4.184A2.99 2.99 0 014 17a2.99 2.99 0 01-2 2.816V24a2 2 0 002 2h22a2 2 0 002-2v-4.184A2.99 2.99 0 0126 17a2.99 2.99 0 012-2.816V10a2 2 0 00-2-2H4z"
  }));
};
SvgTicket.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$8 = ["title", "titleId"];
var SvgToolbox = function SvgToolbox(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$8);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.563 3c-.918 0-1.719.626-1.942 1.516L11.5 5H3a2 2 0 00-2 2v5h5.277c.347-.595.985-1 1.723-1 .738 0 1.376.405 1.723 1h10.554c.346-.595.986-1 1.725-1 .739 0 1.376.405 1.723 1H29V7a2 2 0 00-2-2h-8.5l-.121-.484A2 2 0 0016.439 3h-2.877zM2 14v9a2 2 0 002 2h22a2 2 0 002-2v-9h-4.277A1.99 1.99 0 0122 15a1.992 1.992 0 01-1.723-1H9.723c-.347.595-.985 1-1.723 1a1.993 1.993 0 01-1.723-1H2z"
  }));
};
SvgToolbox.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$7 = ["title", "titleId"];
var SvgTools = function SvgTools(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$7);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4 3L2 5l2 4 3 1 3.5 3.5 2-2L9 8 8 5 4 3zm18.066.01a6.146 6.146 0 00-4.603 1.799c-1.636 1.636-1.783 3.603-.969 5.455L4.88 21.879a2.999 2.999 0 000 4.242 2.999 2.999 0 004.242 0l11.615-11.615c1.851.813 3.82.666 5.455-.97a6.163 6.163 0 001.512-6.24l-3.705 3.708-3.201-.8-.8-3.202 3.706-3.705a6.216 6.216 0 00-1.637-.287zm-1.545 14.627L16.758 21.4l4.818 4.82a2.662 2.662 0 103.766-3.765l-4.82-4.818zM7 23a1 1 0 110 2 1 1 0 010-2z"
  }));
};
SvgTools.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$6 = ["title", "titleId"];
var SvgTraining = function SvgTraining(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$6);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7 3a3 3 0 00-3 3 3 3 0 003 3 3 3 0 003-3 3 3 0 00-3-3zm9.984.986A1 1 0 0016 5h-4v2h4.832a1 1 0 00.326 0H24v10h-4.842a1 1 0 00-.12-.014 1 1 0 00-.1 0 1 1 0 00-.11.014h-3.662a1 1 0 00-.133-.014 1 1 0 00-.199.014H12v2h1.719l-1.69 6.758a1 1 0 101.942.484L15.78 19h2.438l1.81 7.242a1 1 0 101.942-.484L20.28 19H25a1 1 0 001-1V6a1 1 0 00-1-1h-7a1 1 0 00-1.016-1.014zM6 11a2 2 0 00-2 2v12.967a1.034 1.034 0 002.064.068l.438-6.568a.5.5 0 01.996-.002l.438 6.57A1.033 1.033 0 0010 25.967V14a1 1 0 011-1h5a1 1 0 100-2H6z"
  }));
};
SvgTraining.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$5 = ["title", "titleId"];
var SvgTreehouse = function SvgTreehouse(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$5);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 3c-.928 0-1.747.43-2.297 1.092A2.964 2.964 0 0012 4a2.99 2.99 0 00-2.822 2.018C9.118 6.014 9.06 6 9 6a3 3 0 00-3 3c0 .395.082.77.22 1.115A2.993 2.993 0 004 13c0 1.067.561 1.997 1.4 2.53-.247.435-.4.933-.4 1.47a3 3 0 003 3c.061 0 .118-.014.178-.018A2.99 2.99 0 0011 22c.907 0 1.712-.412 2.262-1.049-.36 2.12-.811 3.598-1.262 4.049a1 1 0 100 2h6a1 1 0 100-2c-.451-.451-.903-1.929-1.262-4.049A2.981 2.981 0 0019 22a2.99 2.99 0 002.822-2.018c.06.004.117.018.178.018a3 3 0 003-3c0-.537-.153-1.035-.4-1.47A2.991 2.991 0 0026 13c0-1.385-.945-2.54-2.22-2.885.138-.346.22-.72.22-1.115a3 3 0 00-3-3c-.061 0-.118.014-.178.018A2.99 2.99 0 0018 4c-.243 0-.477.037-.703.092A2.978 2.978 0 0015 3zm0 6c.077 0 .155.018.225.053l4 2A.502.502 0 0119 12v5h-2v-4h-4v4h-2v-5l.008-.004a.496.496 0 01-.23-.943l4-2A.499.499 0 0115 9z"
  }));
};
SvgTreehouse.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$4 = ["title", "titleId"];
var SvgTutorial = function SvgTutorial(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$4);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 5C3.355 5 2 6.355 2 8v13c0 .769.304 1.467.787 2H0a3 3 0 003 3h24a3 3 0 003-3h-2.787A2.975 2.975 0 0028 21V8c0-1.645-1.355-3-3-3H5zm0 2h20c.565 0 1 .435 1 1v13c0 .565-.435 1-1 1H5c-.565 0-1-.435-1-1V8c0-.565.435-1 1-1zm4 4a1 1 0 100 2h12a1 1 0 100-2H9zm0 5a1 1 0 100 2h8a1 1 0 100-2H9z"
  }));
};
SvgTutorial.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$3 = ["title", "titleId"];
var SvgUnlock = function SvgUnlock(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$3);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 2c-3.854 0-7 3.146-7 7v2H6a2 2 0 00-2 2v12a2 2 0 002 2h18a2 2 0 002-2V13a2 2 0 00-2-2H10V9c0-2.774 2.226-5 5-5a4.99 4.99 0 014.709 3.334 1 1 0 101.885-.668A7.003 7.003 0 0015 2z"
  }));
};
SvgUnlock.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$2 = ["title", "titleId"];
var SvgVenn = function SvgVenn(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11 4c-4.406 0-8 3.594-8 8 0 2.951 1.616 5.531 4.004 6.918 0 .028-.004.054-.004.082 0 4.406 3.594 8 8 8 4.406 0 8-3.594 8-8 0-.028-.004-.054-.004-.082C25.384 17.531 27 14.951 27 12c0-4.406-3.594-8-8-8-1.457 0-2.821.4-4 1.086A7.933 7.933 0 0011 4zm0 2c.802 0 1.564.159 2.262.441A7.968 7.968 0 0011 12c0 .028.004.054.004.082a8.036 8.036 0 00-3.674 4.664A5.974 5.974 0 015 12c0-3.326 2.674-6 6-6zm8 0c3.326 0 6 2.674 6 6 0 1.939-.913 3.65-2.33 4.746a8.036 8.036 0 00-3.674-4.664c0-.028.004-.054.004-.082a7.968 7.968 0 00-2.262-5.559A6.008 6.008 0 0119 6zm-4 1.527a5.966 5.966 0 011.95 3.723A7.95 7.95 0 0015 11a7.95 7.95 0 00-1.95.25A5.966 5.966 0 0115 7.527zM15 13c.65 0 1.273.106 1.857.295A5.965 5.965 0 0115 16.473a5.965 5.965 0 01-1.857-3.178A6.03 6.03 0 0115 13zm-3.67 1.254a8.003 8.003 0 001.932 3.305 6.008 6.008 0 01-4.12.146 5.968 5.968 0 012.188-3.451zm7.34 0a5.968 5.968 0 012.187 3.451 6.008 6.008 0 01-4.12-.146 8.003 8.003 0 001.933-3.305zM15 18.914A7.933 7.933 0 0019 20a7.95 7.95 0 001.95-.25A5.98 5.98 0 0115 25a5.98 5.98 0 01-5.95-5.25A7.95 7.95 0 0011 20c1.457 0 2.821-.4 4-1.086z"
  }));
};
SvgVenn.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded$1 = ["title", "titleId"];
var SvgWebSecurity = function SvgWebSecurity(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4 4a2 2 0 00-2 2v20h26V6a2 2 0 00-2-2H4zm1 3a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm3 0h14v2H12V7zm-8 5h22v12H4V12zm11 2c-1.535 0-3.4.615-3.4.615a.857.857 0 00-.6.815V17c0 3.429 3.676 4.936 3.676 4.936a.834.834 0 00.648 0S19 20.428 19 17v-1.57a.857.857 0 00-.6-.815S16.535 14 15 14z"
  }));
};
SvgWebSecurity.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

var _excluded = ["title", "titleId"];
var SvgWebinar = function SvgWebinar(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 6a2 2 0 00-2 2v12a2 2 0 002 2h20a2 2 0 002-2V8a2 2 0 00-2-2H5zm0 3h3v2H5V9zm10 0c.954 0 1.25.678 1.25.678.853 0 1.25.933 1.25 2.029 0 .547-.22 1-.22 1 .087.055.235.23.199.541-.068.579-.3.726-.448.738-.056.54-.841 1.232-1.029 1.332v.905c.374 1.217 2.45.62 3 2.777H11c.55-2.157 2.626-1.56 3-2.777v-.905c-.188-.1-.973-.792-1.03-1.332-.146-.012-.379-.159-.447-.738-.037-.311.109-.486.198-.541 0 0-.219-.501-.219-1C12.501 10.227 13.233 9 15 9zM5 13h3v2H5v-2zm0 4h3v2H5v-2zm5 7a1 1 0 100 2h10a1 1 0 100-2H10z"
  }));
};
SvgWebinar.propTypes = {
  title: PropTypes.string,
  titleId: PropTypes.string
};

export { SvgAlert as Alert, SvgAnnounce as Announce, SvgArrowDown as ArrowDown, SvgArrowLeft as ArrowLeft, SvgArrowRight as ArrowRight, SvgArrowUp as ArrowUp, SvgBackup as Backup, SvgBarman as Barman, SvgBdr as Bdr, SvgBigData as BigData, SvgBrainCircuit as BrainCircuit, SvgBriefcase as Briefcase, SvgBusinessman as Businessman, SvgBusinesswoman as Businesswoman, SvgCaseStudy as CaseStudy, SvgCellular as Cellular, SvgCertificate as Certificate, SvgChange as Change, SvgChat as Chat, SvgChecklist as Checklist, SvgCheckmark as Checkmark, SvgCheckmarkCircle as CheckmarkCircle, SvgChevronDown as ChevronDown, SvgChevronLeft as ChevronLeft, SvgChevronRight as ChevronRight, SvgChevronUp as ChevronUp, SvgClose as Close, SvgCloud as Cloud, SvgCloudChecked as CloudChecked, SvgCloudDb as CloudDb, SvgCloudDba as CloudDba, SvgCloudPrivate as CloudPrivate, SvgCloudPublic as CloudPublic, SvgCluster as Cluster, SvgCodeWriting as CodeWriting, SvgCoffee as Coffee, SvgConfigManagement as ConfigManagement, SvgConflict as Conflict, SvgConnect as Connect, SvgConsole as Console, SvgContact as Contact, SvgContainer as Container, SvgControl as Control, SvgConvert as Convert, SvgCrown as Crown, SvgCrystalBall as CrystalBall, SvgCubes as Cubes, SvgCycle as Cycle, SvgDataTransfer as DataTransfer, SvgDatabase as Database, SvgDatabaseAdmin as DatabaseAdmin, SvgDatabaseBackup as DatabaseBackup, SvgDeliverLove as DeliverLove, SvgDesign as Design, SvgDeveloper as Developer, SvgDiploma as Diploma, SvgDockerContainer as DockerContainer, SvgDocs as Docs, SvgDottedBox as DottedBox, SvgDownload as Download, SvgDrives as Drives, SvgDuplicate as Duplicate, SvgEarth as Earth, SvgEasy as Easy, SvgEdbArk as EdbArk, SvgEdbBart as EdbBart, SvgEdbDashboard as EdbDashboard, SvgEdbEfm as EdbEfm, SvgEdbEpas as EdbEpas, SvgEdbKubernetes as EdbKubernetes, SvgEdbMigrationPortal as EdbMigrationPortal, SvgEdbMigrationToolkit as EdbMigrationToolkit, SvgEdbPem as EdbPem, SvgEdbReplicate as EdbReplicate, SvgEdbReplication as EdbReplication, SvgEdbSymbol as EdbSymbol, SvgEdbTransporter as EdbTransporter, SvgEllipsis as Ellipsis, SvgEnergy as Energy, SvgEnterprise as Enterprise, SvgEvent as Event, SvgExport as Export, SvgExtension as Extension, SvgExternalLink as ExternalLink, SvgFile as File, SvgGlobe as Globe, SvgGovernment as Government, SvgGui as Gui, SvgHamburger as Hamburger, SvgHandshake as Handshake, SvgHardToFind as HardToFind, SvgHelp as Help, SvgHighAvailability as HighAvailability, SvgHorizontal as Horizontal, SvgHorizontalNameTag as HorizontalNameTag, SvgIdeaSharing as IdeaSharing, SvgImprove as Improve, SvgInfo as Info, SvgInstall as Install, SvgInstances as Instances, SvgIntegration as Integration, SvgKnight as Knight, SvgKubernetes as Kubernetes, SvgLaptopConfig as LaptopConfig, SvgLeader as Leader, SvgLearning as Learning, SvgLink as Link, SvgManagedOperations as ManagedOperations, SvgMigrate as Migrate, SvgMigration as Migration, SvgMission as Mission, SvgModule as Module, SvgMonitoring as Monitoring, SvgMoreTeam as MoreTeam, SvgNameTag as NameTag, SvgNetwork as Network, SvgNetwork2 as Network2, SvgNewWindow as NewWindow, SvgNews as News, SvgOpenSource as OpenSource, SvgOptions as Options, SvgPartner as Partner, SvgPartners as Partners, SvgPdf as Pdf, SvgPeople as People, SvgPiggyBank as PiggyBank, SvgPlaceholder as Placeholder, SvgPlanner as Planner, SvgPlayCircle as PlayCircle, SvgPlus as Plus, SvgPostgresql as Postgresql, SvgPreferences as Preferences, SvgPresentation as Presentation, SvgProcess as Process, SvgProcessImprovement as ProcessImprovement, SvgProductStar as ProductStar, SvgPulse as Pulse, SvgPunch as Punch, SvgQuoteLeft as QuoteLeft, SvgQuoteRight as QuoteRight, SvgRemoteDba as RemoteDba, SvgReplication as Replication, SvgRocket as Rocket, SvgRss as Rss, SvgSearch as Search, SvgSecurity as Security, SvgSecurityConfig as SecurityConfig, SvgServicesSupport as ServicesSupport, SvgSmallDashboard as SmallDashboard, SvgSmallMigration as SmallMigration, SvgSmallPartners as SmallPartners, SvgSmallSettings as SmallSettings, SvgSmallSignout as SmallSignout, SvgSmallSupport as SmallSupport, SvgSmallTraining as SmallTraining, SvgSpeed as Speed, SvgSpinner as Spinner, SvgSql as Sql, SvgStack as Stack, SvgStar as Star, SvgStopwatch as Stopwatch, SvgStore as Store, SvgSubset as Subset, SvgSupport as Support, SvgSupportPortal as SupportPortal, SvgSynchronize as Synchronize, SvgTenYears as TenYears, SvgTicket as Ticket, SvgTicketStar as TicketStar, SvgToolbox as Toolbox, SvgTools as Tools, SvgTraining as Training, SvgTreehouse as Treehouse, SvgTutorial as Tutorial, SvgUnlock as Unlock, SvgVenn as Venn, SvgWebSecurity as WebSecurity, SvgWebinar as Webinar };
